//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAddressTypesClient {
    addressTypes_GetAddressTypes(): Observable<AddressTypesDto[]>;
    addressTypes_CreateAddressType(commad: CreateAddressTypeCommand): Observable<void>;
    addressTypes_GetAddressType(id: number): Observable<AddressTypeDto>;
    addressTypes_UpdateAddressType(id: number, command: UpdateAddressTypeCommand): Observable<void>;
    addressTypes_DeleteAddressType(id: number): Observable<void>;
    addressTypes_GetAddressTypeSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AddressTypesClient implements IAddressTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    addressTypes_GetAddressTypes(): Observable<AddressTypesDto[]> {
        let url_ = this.baseUrl + "/api/AddressTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_GetAddressTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_GetAddressTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressTypesDto[]>;
        }));
    }

    protected processAddressTypes_GetAddressTypes(response: HttpResponseBase): Observable<AddressTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addressTypes_CreateAddressType(commad: CreateAddressTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/AddressTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_CreateAddressType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_CreateAddressType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressTypes_CreateAddressType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addressTypes_GetAddressType(id: number): Observable<AddressTypeDto> {
        let url_ = this.baseUrl + "/api/AddressTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_GetAddressType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_GetAddressType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressTypeDto>;
        }));
    }

    protected processAddressTypes_GetAddressType(response: HttpResponseBase): Observable<AddressTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addressTypes_UpdateAddressType(id: number, command: UpdateAddressTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/AddressTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_UpdateAddressType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_UpdateAddressType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressTypes_UpdateAddressType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addressTypes_DeleteAddressType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AddressTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_DeleteAddressType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_DeleteAddressType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressTypes_DeleteAddressType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addressTypes_GetAddressTypeSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/AddressTypes/GetAddressTypeSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressTypes_GetAddressTypeSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressTypes_GetAddressTypeSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processAddressTypes_GetAddressTypeSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAiAssistantClient {
    aiAssistant_Ask(query: AskQuestionQuery): Observable<AskQuestionResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AiAssistantClient implements IAiAssistantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    aiAssistant_Ask(query: AskQuestionQuery): Observable<AskQuestionResult> {
        let url_ = this.baseUrl + "/api/AiAssistant/Ask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAiAssistant_Ask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAiAssistant_Ask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AskQuestionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AskQuestionResult>;
        }));
    }

    protected processAiAssistant_Ask(response: HttpResponseBase): Observable<AskQuestionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AskQuestionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBargeCharterPartyContractsClient {
    bargeCharterPartyContracts_Get(id: number | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BargeCharterPartyContractsClient implements IBargeCharterPartyContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    bargeCharterPartyContracts_Get(id: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BargeCharterPartyContracts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargeCharterPartyContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargeCharterPartyContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBargeCharterPartyContracts_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBargePreparationsClient {
    bargePreparations_GetBargePreparations(): Observable<BargePreparationsDto[]>;
    bargePreparations_CreateBargePreparation(commad: CreateBargePreparationCommand): Observable<void>;
    bargePreparations_GetBargePreparation(id: number): Observable<BargePreparationDto>;
    bargePreparations_UpdatePreparation(id: number, command: UpdateBargePreparationCommand): Observable<void>;
    bargePreparations_DeletePreparation(id: number): Observable<void>;
    bargePreparations_GetBargePreparationSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BargePreparationsClient implements IBargePreparationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    bargePreparations_GetBargePreparations(): Observable<BargePreparationsDto[]> {
        let url_ = this.baseUrl + "/api/BargePreparations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_GetBargePreparations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_GetBargePreparations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargePreparationsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargePreparationsDto[]>;
        }));
    }

    protected processBargePreparations_GetBargePreparations(response: HttpResponseBase): Observable<BargePreparationsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BargePreparationsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bargePreparations_CreateBargePreparation(commad: CreateBargePreparationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/BargePreparations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_CreateBargePreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_CreateBargePreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBargePreparations_CreateBargePreparation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bargePreparations_GetBargePreparation(id: number): Observable<BargePreparationDto> {
        let url_ = this.baseUrl + "/api/BargePreparations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_GetBargePreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_GetBargePreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargePreparationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargePreparationDto>;
        }));
    }

    protected processBargePreparations_GetBargePreparation(response: HttpResponseBase): Observable<BargePreparationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BargePreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bargePreparations_UpdatePreparation(id: number, command: UpdateBargePreparationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/BargePreparations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_UpdatePreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_UpdatePreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBargePreparations_UpdatePreparation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bargePreparations_DeletePreparation(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BargePreparations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_DeletePreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_DeletePreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBargePreparations_DeletePreparation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bargePreparations_GetBargePreparationSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/BargePreparations/GetBargePreparationSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBargePreparations_GetBargePreparationSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBargePreparations_GetBargePreparationSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processBargePreparations_GetBargePreparationSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBargesClient {
    barges_GetBarges(): Observable<BargesDto[]>;
    barges_CreateBarge(commad: CreateBargeCommand): Observable<void>;
    barges_GetBarge(id: number): Observable<BargeDto>;
    barges_UpdateBarge(id: number, command: UpdateBargeCommand): Observable<void>;
    barges_DeleteBarge(id: number): Observable<void>;
    barges_GetBargeSelectOptions(): Observable<SelectDto[]>;
    barges_GetBargeByName(name: string): Observable<BargeDto>;
    barges_GetBargeVm(id: number): Observable<BargeVm>;
}

@Injectable({
    providedIn: 'root'
})
export class BargesClient implements IBargesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    barges_GetBarges(): Observable<BargesDto[]> {
        let url_ = this.baseUrl + "/api/Barges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_GetBarges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_GetBarges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargesDto[]>;
        }));
    }

    protected processBarges_GetBarges(response: HttpResponseBase): Observable<BargesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BargesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_CreateBarge(commad: CreateBargeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Barges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_CreateBarge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_CreateBarge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBarges_CreateBarge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_GetBarge(id: number): Observable<BargeDto> {
        let url_ = this.baseUrl + "/api/Barges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_GetBarge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_GetBarge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargeDto>;
        }));
    }

    protected processBarges_GetBarge(response: HttpResponseBase): Observable<BargeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BargeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_UpdateBarge(id: number, command: UpdateBargeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Barges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_UpdateBarge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_UpdateBarge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBarges_UpdateBarge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_DeleteBarge(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Barges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_DeleteBarge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_DeleteBarge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBarges_DeleteBarge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_GetBargeSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Barges/GetBargeSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_GetBargeSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_GetBargeSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processBarges_GetBargeSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_GetBargeByName(name: string): Observable<BargeDto> {
        let url_ = this.baseUrl + "/api/Barges/GetBargeByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_GetBargeByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_GetBargeByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargeDto>;
        }));
    }

    protected processBarges_GetBargeByName(response: HttpResponseBase): Observable<BargeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BargeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    barges_GetBargeVm(id: number): Observable<BargeVm> {
        let url_ = this.baseUrl + "/api/Barges/GetBargeVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarges_GetBargeVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarges_GetBargeVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BargeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BargeVm>;
        }));
    }

    protected processBarges_GetBargeVm(response: HttpResponseBase): Observable<BargeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BargeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBatchContractsClient {
    batchContracts_GetNew(): Observable<BatchContractVm>;
    batchContracts_Create(command: BatchCreateContractCommand): Observable<number>;
    batchContracts_Get(id: number): Observable<BatchContractVm>;
}

@Injectable({
    providedIn: 'root'
})
export class BatchContractsClient implements IBatchContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    batchContracts_GetNew(): Observable<BatchContractVm> {
        let url_ = this.baseUrl + "/api/BatchContracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchContracts_GetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchContracts_GetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchContractVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchContractVm>;
        }));
    }

    protected processBatchContracts_GetNew(response: HttpResponseBase): Observable<BatchContractVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchContractVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchContracts_Create(command: BatchCreateContractCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BatchContracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchContracts_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchContracts_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBatchContracts_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchContracts_Get(id: number): Observable<BatchContractVm> {
        let url_ = this.baseUrl + "/api/BatchContracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchContractVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchContractVm>;
        }));
    }

    protected processBatchContracts_Get(response: HttpResponseBase): Observable<BatchContractVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchContractVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBatchEmployeesClient {
    batchEmployees_GetNew(): Observable<BatchEmployeeVm>;
    batchEmployees_Create(command: BatchCreateEmployeeCommand): Observable<void>;
    batchEmployees_Get(id: number): Observable<BatchEmployeeVm>;
}

@Injectable({
    providedIn: 'root'
})
export class BatchEmployeesClient implements IBatchEmployeesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    batchEmployees_GetNew(): Observable<BatchEmployeeVm> {
        let url_ = this.baseUrl + "/api/BatchEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchEmployees_GetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchEmployees_GetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchEmployeeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchEmployeeVm>;
        }));
    }

    protected processBatchEmployees_GetNew(response: HttpResponseBase): Observable<BatchEmployeeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchEmployeeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchEmployees_Create(command: BatchCreateEmployeeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/BatchEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchEmployees_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchEmployees_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchEmployees_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchEmployees_Get(id: number): Observable<BatchEmployeeVm> {
        let url_ = this.baseUrl + "/api/BatchEmployees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchEmployees_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchEmployees_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchEmployeeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchEmployeeVm>;
        }));
    }

    protected processBatchEmployees_Get(response: HttpResponseBase): Observable<BatchEmployeeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchEmployeeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBatchNewVoyagesClient {
    batchNewVoyages_Get(id: number): Observable<BatchVoyageVm>;
}

@Injectable({
    providedIn: 'root'
})
export class BatchNewVoyagesClient implements IBatchNewVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    batchNewVoyages_Get(id: number): Observable<BatchVoyageVm> {
        let url_ = this.baseUrl + "/api/BatchNewVoyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchNewVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchNewVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchVoyageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchVoyageVm>;
        }));
    }

    protected processBatchNewVoyages_Get(response: HttpResponseBase): Observable<BatchVoyageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchVoyageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBatchVoyagesClient {
    batchVoyages_Get(id: number): Observable<BatchVoyageVm>;
    batchVoyages_Create(command: BatchCreateVoyageCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class BatchVoyagesClient implements IBatchVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    batchVoyages_Get(id: number): Observable<BatchVoyageVm> {
        let url_ = this.baseUrl + "/api/BatchVoyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchVoyageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchVoyageVm>;
        }));
    }

    protected processBatchVoyages_Get(response: HttpResponseBase): Observable<BatchVoyageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchVoyageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchVoyages_Create(command: BatchCreateVoyageCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BatchVoyages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchVoyages_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchVoyages_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBatchVoyages_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICargosClient {
    cargos_GetCargos(): Observable<CargosDto[]>;
    cargos_CreateCargo(commad: CreateCargoCommand): Observable<void>;
    cargos_GetCargo(id: number): Observable<CargoDto>;
    cargos_UpdateCargo(id: number, command: UpdateCargoCommand): Observable<void>;
    cargos_DeleteCargo(id: number): Observable<void>;
    cargos_GetCargoSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CargosClient implements ICargosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    cargos_GetCargos(): Observable<CargosDto[]> {
        let url_ = this.baseUrl + "/api/Cargos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_GetCargos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_GetCargos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargosDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargosDto[]>;
        }));
    }

    protected processCargos_GetCargos(response: HttpResponseBase): Observable<CargosDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CargosDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cargos_CreateCargo(commad: CreateCargoCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Cargos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_CreateCargo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_CreateCargo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCargos_CreateCargo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cargos_GetCargo(id: number): Observable<CargoDto> {
        let url_ = this.baseUrl + "/api/Cargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_GetCargo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_GetCargo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CargoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CargoDto>;
        }));
    }

    protected processCargos_GetCargo(response: HttpResponseBase): Observable<CargoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CargoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cargos_UpdateCargo(id: number, command: UpdateCargoCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Cargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_UpdateCargo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_UpdateCargo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCargos_UpdateCargo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cargos_DeleteCargo(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Cargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_DeleteCargo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_DeleteCargo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCargos_DeleteCargo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cargos_GetCargoSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Cargos/GetCargoSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCargos_GetCargoSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCargos_GetCargoSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCargos_GetCargoSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompaniesClient {
    companies_GetAll(): Observable<CompaniesDto[]>;
    companies_Create(commad: CreateCompanyCommand): Observable<void>;
    companies_Get(id: number): Observable<CompanyDto>;
    companies_Update(id: number, command: UpdateCompanyCommand): Observable<void>;
    companies_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesClient implements ICompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companies_GetAll(): Observable<CompaniesDto[]> {
        let url_ = this.baseUrl + "/api/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanies_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanies_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompaniesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompaniesDto[]>;
        }));
    }

    protected processCompanies_GetAll(response: HttpResponseBase): Observable<CompaniesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompaniesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    companies_Create(commad: CreateCompanyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanies_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanies_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanies_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    companies_Get(id: number): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanies_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanies_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processCompanies_Get(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    companies_Update(id: number, command: UpdateCompanyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanies_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanies_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanies_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    companies_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanies_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanies_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanies_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompaniesSelectClient {
    companiesSelect_Get(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesSelectClient implements ICompaniesSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companiesSelect_Get(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/CompaniesSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompaniesSelect_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompaniesSelect_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCompaniesSelect_Get(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompaniesVmClient {
    companiesVm_Get(id: number): Observable<CompanyVm>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesVmClient implements ICompaniesVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companiesVm_Get(id: number): Observable<CompanyVm> {
        let url_ = this.baseUrl + "/api/CompaniesVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompaniesVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompaniesVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyVm>;
        }));
    }

    protected processCompaniesVm_Get(response: HttpResponseBase): Observable<CompanyVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyCharterersSelectClient {
    companyCharterersSelect_Get(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyCharterersSelectClient implements ICompanyCharterersSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companyCharterersSelect_Get(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/CompanyCharterersSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyCharterersSelect_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyCharterersSelect_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCompanyCharterersSelect_Get(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyEmployeesSelectClient {
    companyEmployeesSelect_Get(name: string): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyEmployeesSelectClient implements ICompanyEmployeesSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companyEmployeesSelect_Get(name: string): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/CompanyEmployeesSelect/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyEmployeesSelect_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyEmployeesSelect_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCompanyEmployeesSelect_Get(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyOwnersSelectClient {
    companyOwnersSelect_Get(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyOwnersSelectClient implements ICompanyOwnersSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    companyOwnersSelect_Get(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/CompanyOwnersSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyOwnersSelect_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyOwnersSelect_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCompanyOwnersSelect_Get(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConstructionsClient {
    constructions_GetConstructions(): Observable<ConstructionsDto[]>;
    constructions_CreateConstruction(commad: CreateConstructionCommand): Observable<void>;
    constructions_GetConstruction(id: number): Observable<ConstructionDto>;
    constructions_UpdateConstruction(id: number, command: UpdateConstructionCommand): Observable<void>;
    constructions_DeleteConstruction(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionsClient implements IConstructionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    constructions_GetConstructions(): Observable<ConstructionsDto[]> {
        let url_ = this.baseUrl + "/api/Constructions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstructions_GetConstructions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstructions_GetConstructions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstructionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstructionsDto[]>;
        }));
    }

    protected processConstructions_GetConstructions(response: HttpResponseBase): Observable<ConstructionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConstructionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    constructions_CreateConstruction(commad: CreateConstructionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Constructions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstructions_CreateConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstructions_CreateConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConstructions_CreateConstruction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    constructions_GetConstruction(id: number): Observable<ConstructionDto> {
        let url_ = this.baseUrl + "/api/Constructions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstructions_GetConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstructions_GetConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstructionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstructionDto>;
        }));
    }

    protected processConstructions_GetConstruction(response: HttpResponseBase): Observable<ConstructionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstructionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    constructions_UpdateConstruction(id: number, command: UpdateConstructionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Constructions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstructions_UpdateConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstructions_UpdateConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConstructions_UpdateConstruction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    constructions_DeleteConstruction(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Constructions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstructions_DeleteConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstructions_DeleteConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConstructions_DeleteConstruction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContractsClient {
    contracts_GetAll(): Observable<ContractsDto[]>;
    contracts_Create(commad: CreateContractCommand): Observable<void>;
    contracts_Get(id: number): Observable<ContractDto>;
    contracts_Update(id: number, command: UpdateContractCommand): Observable<void>;
    contracts_Delete(id: number): Observable<void>;
    contracts_GetRefNumbers(): Observable<SelectDto[]>;
    contracts_GetRefNumbersByOwner(owner: string): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractsClient implements IContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    contracts_GetAll(): Observable<ContractsDto[]> {
        let url_ = this.baseUrl + "/api/Contracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractsDto[]>;
        }));
    }

    protected processContracts_GetAll(response: HttpResponseBase): Observable<ContractsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_Create(commad: CreateContractCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContracts_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_Get(id: number): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/Contracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processContracts_Get(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_Update(id: number, command: UpdateContractCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Contracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContracts_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Contracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContracts_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_GetRefNumbers(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Contracts/GetRefNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_GetRefNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_GetRefNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processContracts_GetRefNumbers(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contracts_GetRefNumbersByOwner(owner: string): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Contracts/GetRefNumbersByOwner/{owner}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContracts_GetRefNumbersByOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContracts_GetRefNumbersByOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processContracts_GetRefNumbersByOwner(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContractSpProvsClient {
    contractSpProvs_GetContractSpecialProvisions(): Observable<ContractSpProvsDto[]>;
    contractSpProvs_CreateContractSpecialProvision(commad: CreateContractSpProvCommand): Observable<number>;
    contractSpProvs_GetContractSpecialProvision(id: number): Observable<ContractSpProvDto>;
    contractSpProvs_UpdateContractSpecialProvision(id: number, command: UpdateContractSpProvCommand): Observable<number>;
    contractSpProvs_DeleteContractSpecialProvision(id: number): Observable<void>;
    contractSpProvs_GetContractSpecialProvisionByRefNo(id: number): Observable<ContractSpProvsDto[]>;
    contractSpProvs_GetContractSpecialProvisionVm(id: number): Observable<ContractSpProvVm>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractSpProvsClient implements IContractSpProvsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    contractSpProvs_GetContractSpecialProvisions(): Observable<ContractSpProvsDto[]> {
        let url_ = this.baseUrl + "/api/ContractSpProvs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_GetContractSpecialProvisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_GetContractSpecialProvisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractSpProvsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractSpProvsDto[]>;
        }));
    }

    protected processContractSpProvs_GetContractSpecialProvisions(response: HttpResponseBase): Observable<ContractSpProvsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSpProvsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_CreateContractSpecialProvision(commad: CreateContractSpProvCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ContractSpProvs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_CreateContractSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_CreateContractSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processContractSpProvs_CreateContractSpecialProvision(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_GetContractSpecialProvision(id: number): Observable<ContractSpProvDto> {
        let url_ = this.baseUrl + "/api/ContractSpProvs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_GetContractSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_GetContractSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractSpProvDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractSpProvDto>;
        }));
    }

    protected processContractSpProvs_GetContractSpecialProvision(response: HttpResponseBase): Observable<ContractSpProvDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractSpProvDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_UpdateContractSpecialProvision(id: number, command: UpdateContractSpProvCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ContractSpProvs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_UpdateContractSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_UpdateContractSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processContractSpProvs_UpdateContractSpecialProvision(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_DeleteContractSpecialProvision(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ContractSpProvs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_DeleteContractSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_DeleteContractSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContractSpProvs_DeleteContractSpecialProvision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_GetContractSpecialProvisionByRefNo(id: number): Observable<ContractSpProvsDto[]> {
        let url_ = this.baseUrl + "/api/ContractSpProvs/GetContractSpecialProvisionByRefNo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_GetContractSpecialProvisionByRefNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_GetContractSpecialProvisionByRefNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractSpProvsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractSpProvsDto[]>;
        }));
    }

    protected processContractSpProvs_GetContractSpecialProvisionByRefNo(response: HttpResponseBase): Observable<ContractSpProvsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractSpProvsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractSpProvs_GetContractSpecialProvisionVm(id: number): Observable<ContractSpProvVm> {
        let url_ = this.baseUrl + "/api/ContractSpProvs/GetContractSpecialProvisionVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractSpProvs_GetContractSpecialProvisionVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractSpProvs_GetContractSpecialProvisionVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractSpProvVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractSpProvVm>;
        }));
    }

    protected processContractSpProvs_GetContractSpecialProvisionVm(response: HttpResponseBase): Observable<ContractSpProvVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractSpProvVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContractsVmClient {
    contractsVm_Get(id: number): Observable<ContractVm>;
    contractsVm_GetNew(): Observable<ContractVm>;
}

@Injectable({
    providedIn: 'root'
})
export class ContractsVmClient implements IContractsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    contractsVm_Get(id: number): Observable<ContractVm> {
        let url_ = this.baseUrl + "/api/ContractsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractVm>;
        }));
    }

    protected processContractsVm_Get(response: HttpResponseBase): Observable<ContractVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contractsVm_GetNew(): Observable<ContractVm> {
        let url_ = this.baseUrl + "/api/ContractsVm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContractsVm_GetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContractsVm_GetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractVm>;
        }));
    }

    protected processContractsVm_GetNew(response: HttpResponseBase): Observable<ContractVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICountriesClient {
    countries_GetCountries(): Observable<CountryDto[]>;
    countries_CreateCountry(commad: CreateCountryCommand): Observable<number>;
    countries_GetCountry(id: number): Observable<CountryDto>;
    countries_UpdateCountry(id: number, command: UpdateCountryCommand): Observable<FileResponse>;
    countries_DeleteCountry(id: number): Observable<FileResponse>;
    countries_GetCountrySelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CountriesClient implements ICountriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    countries_GetCountries(): Observable<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_GetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_GetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto[]>;
        }));
    }

    protected processCountries_GetCountries(response: HttpResponseBase): Observable<CountryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countries_CreateCountry(commad: CreateCountryCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_CreateCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_CreateCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountries_CreateCountry(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countries_GetCountry(id: number): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_GetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_GetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto>;
        }));
    }

    protected processCountries_GetCountry(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countries_UpdateCountry(id: number, command: UpdateCountryCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_UpdateCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_UpdateCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCountries_UpdateCountry(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countries_DeleteCountry(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_DeleteCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_DeleteCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCountries_DeleteCountry(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countries_GetCountrySelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Countries/GetCountrySelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries_GetCountrySelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries_GetCountrySelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCountries_GetCountrySelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICpFormsClient {
    cpForms_GetCpForms(): Observable<CpFormsDto[]>;
    cpForms_CreateCpForm(commad: CreateCpFormCommand): Observable<void>;
    cpForms_GetCpForm(id: number): Observable<CpFormDto>;
    cpForms_UpdateCpForm(id: number, command: UpdateCpFormCommand): Observable<void>;
    cpForms_DeleteCpForm(id: number): Observable<void>;
    cpForms_GetCpFormSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CpFormsClient implements ICpFormsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    cpForms_GetCpForms(): Observable<CpFormsDto[]> {
        let url_ = this.baseUrl + "/api/CpForms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_GetCpForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_GetCpForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CpFormsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CpFormsDto[]>;
        }));
    }

    protected processCpForms_GetCpForms(response: HttpResponseBase): Observable<CpFormsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CpFormsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cpForms_CreateCpForm(commad: CreateCpFormCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/CpForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_CreateCpForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_CreateCpForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCpForms_CreateCpForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cpForms_GetCpForm(id: number): Observable<CpFormDto> {
        let url_ = this.baseUrl + "/api/CpForms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_GetCpForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_GetCpForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CpFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CpFormDto>;
        }));
    }

    protected processCpForms_GetCpForm(response: HttpResponseBase): Observable<CpFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CpFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cpForms_UpdateCpForm(id: number, command: UpdateCpFormCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/CpForms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_UpdateCpForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_UpdateCpForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCpForms_UpdateCpForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cpForms_DeleteCpForm(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/CpForms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_DeleteCpForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_DeleteCpForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCpForms_DeleteCpForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cpForms_GetCpFormSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/CpForms/GetCpFormSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCpForms_GetCpFormSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCpForms_GetCpFormSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processCpForms_GetCpFormSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomReportsClient {
    customReports_Get(): Observable<CustomReportsDto[]>;
    customReports_GetDemurragesQuery(query: GetDemurragesQuery): Observable<DemurrageLevelDto[]>;
    customReports_DownloadDemurragesQuery(query: DownloadDemurragesQuery): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomReportsClient implements ICustomReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    customReports_Get(): Observable<CustomReportsDto[]> {
        let url_ = this.baseUrl + "/api/CustomReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReports_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReports_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomReportsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomReportsDto[]>;
        }));
    }

    protected processCustomReports_Get(response: HttpResponseBase): Observable<CustomReportsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomReportsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customReports_GetDemurragesQuery(query: GetDemurragesQuery): Observable<DemurrageLevelDto[]> {
        let url_ = this.baseUrl + "/api/CustomReports/GetDemurragesQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReports_GetDemurragesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReports_GetDemurragesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DemurrageLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DemurrageLevelDto[]>;
        }));
    }

    protected processCustomReports_GetDemurragesQuery(response: HttpResponseBase): Observable<DemurrageLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DemurrageLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customReports_DownloadDemurragesQuery(query: DownloadDemurragesQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomReports/DownloadDemurragesQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomReports_DownloadDemurragesQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomReports_DownloadDemurragesQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCustomReports_DownloadDemurragesQuery(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentVersionClient {
    documentVersion_CreateContractFolders(command: CreateContractFoldersCommand): Observable<void>;
    documentVersion_CreateContract(command: CreateContractVersionCommand): Observable<string>;
    documentVersion_CreateContracts(command: CreateContractVersionsCommand): Observable<void>;
    documentVersion_CreateNomination(command: CreateNominationVersionCommand): Observable<string>;
    documentVersion_CreateTraffic(command: CreateTrafficVersionCommand): Observable<string>;
    documentVersion_CreateBillingFolder(command: CreateVoyageFolderCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentVersionClient implements IDocumentVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    documentVersion_CreateContractFolders(command: CreateContractFoldersCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateContractFolders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateContractFolders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateContractFolders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDocumentVersion_CreateContractFolders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentVersion_CreateContract(command: CreateContractVersionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDocumentVersion_CreateContract(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentVersion_CreateContracts(command: CreateContractVersionsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateContracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateContracts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDocumentVersion_CreateContracts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentVersion_CreateNomination(command: CreateNominationVersionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateNomination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateNomination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateNomination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDocumentVersion_CreateNomination(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentVersion_CreateTraffic(command: CreateTrafficVersionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateTraffic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateTraffic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateTraffic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDocumentVersion_CreateTraffic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    documentVersion_CreateBillingFolder(command: CreateVoyageFolderCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DocumentVersion/CreateBillingFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentVersion_CreateBillingFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentVersion_CreateBillingFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDocumentVersion_CreateBillingFolder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeePersonalsClient {
    employeePersonals_GetAll(): Observable<EmployeePersonalsDto[]>;
    employeePersonals_Create(commad: CreateEmployeePersonalCommand): Observable<void>;
    employeePersonals_Get(id: number): Observable<EmployeePersonalDto>;
    employeePersonals_Update(id: number, command: UpdateEmployeePersonalCommand): Observable<void>;
    employeePersonals_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeePersonalsClient implements IEmployeePersonalsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeePersonals_GetAll(): Observable<EmployeePersonalsDto[]> {
        let url_ = this.baseUrl + "/api/EmployeePersonals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonals_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonals_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePersonalsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePersonalsDto[]>;
        }));
    }

    protected processEmployeePersonals_GetAll(response: HttpResponseBase): Observable<EmployeePersonalsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeePersonalsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePersonals_Create(commad: CreateEmployeePersonalCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePersonals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonals_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonals_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePersonals_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePersonals_Get(id: number): Observable<EmployeePersonalDto> {
        let url_ = this.baseUrl + "/api/EmployeePersonals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonals_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonals_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePersonalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePersonalDto>;
        }));
    }

    protected processEmployeePersonals_Get(response: HttpResponseBase): Observable<EmployeePersonalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeePersonalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePersonals_Update(id: number, command: UpdateEmployeePersonalCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePersonals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonals_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonals_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePersonals_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePersonals_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePersonals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonals_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonals_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePersonals_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeePersonalsVmClient {
    employeePersonalsVm_Get(id: number): Observable<EmployeePersonalVm>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeePersonalsVmClient implements IEmployeePersonalsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeePersonalsVm_Get(id: number): Observable<EmployeePersonalVm> {
        let url_ = this.baseUrl + "/api/EmployeePersonalsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePersonalsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePersonalsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePersonalVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePersonalVm>;
        }));
    }

    protected processEmployeePersonalsVm_Get(response: HttpResponseBase): Observable<EmployeePersonalVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeePersonalVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeePhonesClient {
    employeePhones_GetAll(): Observable<EmployeePhonesDto[]>;
    employeePhones_Create(commad: CreateEmployeePhoneCommand): Observable<void>;
    employeePhones_Get(id: number): Observable<EmployeePhoneDto>;
    employeePhones_Update(id: number, command: UpdateEmployeePhoneCommand): Observable<void>;
    employeePhones_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeePhonesClient implements IEmployeePhonesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeePhones_GetAll(): Observable<EmployeePhonesDto[]> {
        let url_ = this.baseUrl + "/api/EmployeePhones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhones_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhones_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePhonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePhonesDto[]>;
        }));
    }

    protected processEmployeePhones_GetAll(response: HttpResponseBase): Observable<EmployeePhonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeePhonesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePhones_Create(commad: CreateEmployeePhoneCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePhones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhones_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhones_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePhones_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePhones_Get(id: number): Observable<EmployeePhoneDto> {
        let url_ = this.baseUrl + "/api/EmployeePhones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhones_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhones_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePhoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePhoneDto>;
        }));
    }

    protected processEmployeePhones_Get(response: HttpResponseBase): Observable<EmployeePhoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeePhoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePhones_Update(id: number, command: UpdateEmployeePhoneCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePhones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhones_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhones_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePhones_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeePhones_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/EmployeePhones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhones_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhones_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeePhones_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeePhonesVmClient {
    employeePhonesVm_Get(id: number): Observable<EmployeePhoneVm>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeePhonesVmClient implements IEmployeePhonesVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeePhonesVm_Get(id: number): Observable<EmployeePhoneVm> {
        let url_ = this.baseUrl + "/api/EmployeePhonesVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeePhonesVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeePhonesVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePhoneVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePhoneVm>;
        }));
    }

    protected processEmployeePhonesVm_Get(response: HttpResponseBase): Observable<EmployeePhoneVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeePhoneVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeesClient {
    employees_GetAll(): Observable<EmployeesDto[]>;
    employees_Create(commad: CreateEmployeeCommand): Observable<void>;
    employees_Get(id: number): Observable<EmployeeDto>;
    employees_Update(id: number, command: UpdateEmployeeCommand): Observable<void>;
    employees_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeesClient implements IEmployeesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employees_GetAll(): Observable<EmployeesDto[]> {
        let url_ = this.baseUrl + "/api/Employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployees_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployees_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesDto[]>;
        }));
    }

    protected processEmployees_GetAll(response: HttpResponseBase): Observable<EmployeesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employees_Create(commad: CreateEmployeeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployees_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployees_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployees_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employees_Get(id: number): Observable<EmployeeDto> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployees_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployees_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto>;
        }));
    }

    protected processEmployees_Get(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employees_Update(id: number, command: UpdateEmployeeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployees_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployees_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployees_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employees_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployees_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployees_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployees_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeesSelectClient {
    employeesSelect_Get(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeesSelectClient implements IEmployeesSelectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeesSelect_Get(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/EmployeesSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeesSelect_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeesSelect_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processEmployeesSelect_Get(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeesVmClient {
    employeesVm_Get(id: number): Observable<EmployeeVm>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeesVmClient implements IEmployeesVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    employeesVm_Get(id: number): Observable<EmployeeVm> {
        let url_ = this.baseUrl + "/api/EmployeesVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeesVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeesVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeVm>;
        }));
    }

    protected processEmployeesVm_Get(response: HttpResponseBase): Observable<EmployeeVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportCompaniesClient {
    exportCompanies_GetAll(): Observable<FileResponse>;
    exportCompanies_Get(filterValue: string, isActive: boolean): Observable<FileResponse>;
    exportCompanies_GetByStatus(isActive: boolean): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportCompaniesClient implements IExportCompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportCompanies_GetAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompanies_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompanies_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCompanies_GetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompanies_Get(filterValue: string, isActive: boolean): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportCompanies/{filterValue}/{isActive}";
        if (filterValue === undefined || filterValue === null)
            throw new Error("The parameter 'filterValue' must be defined.");
        url_ = url_.replace("{filterValue}", encodeURIComponent("" + filterValue));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompanies_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompanies_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCompanies_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCompanies_GetByStatus(isActive: boolean): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportCompanies/GetByStatus/{isActive}";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCompanies_GetByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCompanies_GetByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCompanies_GetByStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportContractsClient {
    exportContracts_GetAll(): Observable<FileResponse>;
    exportContracts_GetContractsByTermAndStatus(filterValue: string, isActive: boolean): Observable<FileResponse>;
    exportContracts_GetContractsByStatus(isActive: boolean): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportContractsClient implements IExportContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportContracts_GetAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportContracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContracts_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContracts_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportContracts_GetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportContracts_GetContractsByTermAndStatus(filterValue: string, isActive: boolean): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportContracts/GetContractsByTermAndStatus/{filterValue}/{isActive}";
        if (filterValue === undefined || filterValue === null)
            throw new Error("The parameter 'filterValue' must be defined.");
        url_ = url_.replace("{filterValue}", encodeURIComponent("" + filterValue));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContracts_GetContractsByTermAndStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContracts_GetContractsByTermAndStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportContracts_GetContractsByTermAndStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportContracts_GetContractsByStatus(isActive: boolean): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportContracts/GetContractsByStatus/{isActive}";
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContracts_GetContractsByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContracts_GetContractsByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportContracts_GetContractsByStatus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportReportCompaniesClient {
    exportReportCompanies_Get(name: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportCompaniesClient implements IExportReportCompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportReportCompanies_Get(name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportCompanies/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportCompanies_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportCompanies_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportCompanies_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportReportEmployeesClient {
    exportReportEmployees_Get(name: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportEmployeesClient implements IExportReportEmployeesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportReportEmployees_Get(name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportEmployees/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportEmployees_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportEmployees_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportEmployees_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportReportInvoicesClient {
    exportReportInvoices_GetAll(): Observable<FileResponse>;
    exportReportInvoices_Get(name: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportInvoicesClient implements IExportReportInvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportReportInvoices_GetAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportInvoices_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportInvoices_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportInvoices_GetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportReportInvoices_Get(name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportInvoices/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportInvoices_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportInvoices_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportInvoices_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportReportTrafficsClient {
    exportReportTraffics_Get(owner: string, charterer: string, from: Date, to: Date): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportTrafficsClient implements IExportReportTrafficsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportReportTraffics_Get(owner: string, charterer: string, from: Date, to: Date): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportTraffics/{owner}/{charterer}/{from}/{to}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportTraffics_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportTraffics_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportTraffics_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportReportWordInvoicesClient {
    exportReportWordInvoices_GetAll(): Observable<FileResponse>;
    exportReportWordInvoices_Get(owner: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportWordInvoicesClient implements IExportReportWordInvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportReportWordInvoices_GetAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportWordInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportWordInvoices_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportWordInvoices_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportWordInvoices_GetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportReportWordInvoices_Get(owner: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportReportWordInvoices/{owner}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportWordInvoices_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportWordInvoices_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportReportWordInvoices_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExportVoyagesClient {
    exportVoyages_GetAll(): Observable<FileResponse>;
    exportVoyages_Get(filterValue: string, isActive: boolean): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportVoyagesClient implements IExportVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportVoyages_GetAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportVoyages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVoyages_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoyages_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportVoyages_GetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportVoyages_Get(filterValue: string, isActive: boolean): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ExportVoyages/{filterValue}/{isActive}";
        if (filterValue === undefined || filterValue === null)
            throw new Error("The parameter 'filterValue' must be defined.");
        url_ = url_.replace("{filterValue}", encodeURIComponent("" + filterValue));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportVoyages_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGroupsClient {
    groups_GetGroups(): Observable<GroupsDto[]>;
    groups_CreateGroup(commad: CreateGroupCommand): Observable<void>;
    groups_GetGroup(id: number): Observable<GroupDto>;
    groups_UpdateGroup(id: number, command: UpdateGroupCommand): Observable<void>;
    groups_DeleteGroup(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class GroupsClient implements IGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    groups_GetGroups(): Observable<GroupsDto[]> {
        let url_ = this.baseUrl + "/api/Groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroups_GetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroups_GetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupsDto[]>;
        }));
    }

    protected processGroups_GetGroups(response: HttpResponseBase): Observable<GroupsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    groups_CreateGroup(commad: CreateGroupCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroups_CreateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroups_CreateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGroups_CreateGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    groups_GetGroup(id: number): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroups_GetGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroups_GetGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processGroups_GetGroup(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    groups_UpdateGroup(id: number, command: UpdateGroupCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroups_UpdateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroups_UpdateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGroups_UpdateGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    groups_DeleteGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroups_DeleteGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroups_DeleteGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGroups_DeleteGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHistoricVoyagesClient {
    historicVoyages_Get(): Observable<VoyagesDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class HistoricVoyagesClient implements IHistoricVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    historicVoyages_Get(): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/HistoricVoyages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistoricVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistoricVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processHistoricVoyages_Get(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveCargosByVoyageIdClient {
    moveCargosByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveCargosDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveCargosByVoyageIdClient implements IMoveCargosByVoyageIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveCargosByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveCargosDto[]> {
        let url_ = this.baseUrl + "/api/MoveCargosByVoyageId/{id}/{refNo}/{moveNo}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargosByVoyageId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargosByVoyageId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveCargosDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveCargosDto[]>;
        }));
    }

    protected processMoveCargosByVoyageId_Get(response: HttpResponseBase): Observable<MoveCargosDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveCargosDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveCargosClient {
    moveCargos_GetAll(): Observable<MoveCargosDto[]>;
    moveCargos_Create(commad: CreateMoveCargoCommand): Observable<number>;
    moveCargos_Get(id: number): Observable<MoveCargoDto>;
    moveCargos_Update(id: number, command: UpdateMoveCargoCommand): Observable<number>;
    moveCargos_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveCargosClient implements IMoveCargosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveCargos_GetAll(): Observable<MoveCargosDto[]> {
        let url_ = this.baseUrl + "/api/MoveCargos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargos_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargos_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveCargosDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveCargosDto[]>;
        }));
    }

    protected processMoveCargos_GetAll(response: HttpResponseBase): Observable<MoveCargosDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveCargosDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveCargos_Create(commad: CreateMoveCargoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveCargos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargos_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargos_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveCargos_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveCargos_Get(id: number): Observable<MoveCargoDto> {
        let url_ = this.baseUrl + "/api/MoveCargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargos_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargos_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveCargoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveCargoDto>;
        }));
    }

    protected processMoveCargos_Get(response: HttpResponseBase): Observable<MoveCargoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveCargoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveCargos_Update(id: number, command: UpdateMoveCargoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveCargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargos_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargos_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveCargos_Update(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveCargos_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveCargos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargos_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargos_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveCargos_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveCargosVmClient {
    moveCargosVm_Get(id: number): Observable<MoveCargoVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveCargosVmClient implements IMoveCargosVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveCargosVm_Get(id: number): Observable<MoveCargoVm> {
        let url_ = this.baseUrl + "/api/MoveCargosVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveCargosVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveCargosVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveCargoVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveCargoVm>;
        }));
    }

    protected processMoveCargosVm_Get(response: HttpResponseBase): Observable<MoveCargoVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveCargoVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveDischargePortsByVoyageIdClient {
    moveDischargePortsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveDischargePortsDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveDischargePortsByVoyageIdClient implements IMoveDischargePortsByVoyageIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveDischargePortsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveDischargePortsDto[]> {
        let url_ = this.baseUrl + "/api/MoveDischargePortsByVoyageId/{id}/{refNo}/{moveNo}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePortsByVoyageId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePortsByVoyageId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveDischargePortsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveDischargePortsDto[]>;
        }));
    }

    protected processMoveDischargePortsByVoyageId_Get(response: HttpResponseBase): Observable<MoveDischargePortsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveDischargePortsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveDischargePortsClient {
    moveDischargePorts_GetAll(): Observable<MoveDischargePortsDto[]>;
    moveDischargePorts_Create(commad: CreateMoveDischargePortCommand): Observable<number>;
    moveDischargePorts_Get(id: number): Observable<MoveDischargePortDto>;
    moveDischargePorts_Update(id: number, command: UpdateMoveDischargePortCommand): Observable<number>;
    moveDischargePorts_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveDischargePortsClient implements IMoveDischargePortsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveDischargePorts_GetAll(): Observable<MoveDischargePortsDto[]> {
        let url_ = this.baseUrl + "/api/MoveDischargePorts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePorts_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePorts_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveDischargePortsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveDischargePortsDto[]>;
        }));
    }

    protected processMoveDischargePorts_GetAll(response: HttpResponseBase): Observable<MoveDischargePortsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveDischargePortsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDischargePorts_Create(commad: CreateMoveDischargePortCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveDischargePorts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePorts_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePorts_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveDischargePorts_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDischargePorts_Get(id: number): Observable<MoveDischargePortDto> {
        let url_ = this.baseUrl + "/api/MoveDischargePorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePorts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePorts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveDischargePortDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveDischargePortDto>;
        }));
    }

    protected processMoveDischargePorts_Get(response: HttpResponseBase): Observable<MoveDischargePortDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveDischargePortDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDischargePorts_Update(id: number, command: UpdateMoveDischargePortCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveDischargePorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePorts_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePorts_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveDischargePorts_Update(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDischargePorts_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveDischargePorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePorts_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePorts_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveDischargePorts_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveDischargePortsVmClient {
    moveDischargePortsVm_Get(id: number): Observable<MoveDischargePortVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveDischargePortsVmClient implements IMoveDischargePortsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveDischargePortsVm_Get(id: number): Observable<MoveDischargePortVm> {
        let url_ = this.baseUrl + "/api/MoveDischargePortsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDischargePortsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDischargePortsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveDischargePortVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveDischargePortVm>;
        }));
    }

    protected processMoveDischargePortsVm_Get(response: HttpResponseBase): Observable<MoveDischargePortVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveDischargePortVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveEquipmentsByRefNoClient {
    moveEquipmentsByRefNo_Get(id: number): Observable<MoveEquipmentsDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveEquipmentsByRefNoClient implements IMoveEquipmentsByRefNoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveEquipmentsByRefNo_Get(id: number): Observable<MoveEquipmentsDto[]> {
        let url_ = this.baseUrl + "/api/MoveEquipmentsByRefNo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipmentsByRefNo_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipmentsByRefNo_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveEquipmentsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveEquipmentsDto[]>;
        }));
    }

    protected processMoveEquipmentsByRefNo_Get(response: HttpResponseBase): Observable<MoveEquipmentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEquipmentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveEquipmentsByVoyageIdClient {
    moveEquipmentsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveEquipmentsDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveEquipmentsByVoyageIdClient implements IMoveEquipmentsByVoyageIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveEquipmentsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveEquipmentsDto[]> {
        let url_ = this.baseUrl + "/api/MoveEquipmentsByVoyageId/{id}/{refNo}/{moveNo}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipmentsByVoyageId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipmentsByVoyageId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveEquipmentsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveEquipmentsDto[]>;
        }));
    }

    protected processMoveEquipmentsByVoyageId_Get(response: HttpResponseBase): Observable<MoveEquipmentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEquipmentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveEquipmentsClient {
    moveEquipments_GetAll(): Observable<MoveEquipmentsDto[]>;
    moveEquipments_Create(command: CreateMoveEquipmentCommand): Observable<number>;
    moveEquipments_Get(id: number): Observable<MoveEquipmentDto>;
    moveEquipments_Update(id: number, command: UpdateMoveEquipmentCommand): Observable<number>;
    moveEquipments_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveEquipmentsClient implements IMoveEquipmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveEquipments_GetAll(): Observable<MoveEquipmentsDto[]> {
        let url_ = this.baseUrl + "/api/MoveEquipments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipments_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipments_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveEquipmentsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveEquipmentsDto[]>;
        }));
    }

    protected processMoveEquipments_GetAll(response: HttpResponseBase): Observable<MoveEquipmentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveEquipmentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveEquipments_Create(command: CreateMoveEquipmentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipments_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipments_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveEquipments_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveEquipments_Get(id: number): Observable<MoveEquipmentDto> {
        let url_ = this.baseUrl + "/api/MoveEquipments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipments_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipments_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveEquipmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveEquipmentDto>;
        }));
    }

    protected processMoveEquipments_Get(response: HttpResponseBase): Observable<MoveEquipmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveEquipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveEquipments_Update(id: number, command: UpdateMoveEquipmentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveEquipments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipments_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipments_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveEquipments_Update(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveEquipments_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveEquipments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipments_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipments_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveEquipments_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveEquipmentsVmClient {
    moveEquipmentsVm_Get(id: number): Observable<MoveEquipmentVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveEquipmentsVmClient implements IMoveEquipmentsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveEquipmentsVm_Get(id: number): Observable<MoveEquipmentVm> {
        let url_ = this.baseUrl + "/api/MoveEquipmentsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipmentsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipmentsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveEquipmentVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveEquipmentVm>;
        }));
    }

    protected processMoveEquipmentsVm_Get(response: HttpResponseBase): Observable<MoveEquipmentVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveEquipmentVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveLdPortsByVoyageIdClient {
    moveLdPortsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveLdPortsDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveLdPortsByVoyageIdClient implements IMoveLdPortsByVoyageIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveLdPortsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveLdPortsDto[]> {
        let url_ = this.baseUrl + "/api/MoveLdPortsByVoyageId/{id}/{refNo}/{moveNo}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPortsByVoyageId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPortsByVoyageId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLdPortsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLdPortsDto[]>;
        }));
    }

    protected processMoveLdPortsByVoyageId_Get(response: HttpResponseBase): Observable<MoveLdPortsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveLdPortsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveLdPortsClient {
    moveLdPorts_GetAll(): Observable<MoveLdPortsDto[]>;
    moveLdPorts_Create(commad: CreateMoveLdPortCommand): Observable<number>;
    moveLdPorts_Get(id: number): Observable<MoveLdPortDto>;
    moveLdPorts_Update(id: number, command: UpdateMoveLdPortCommand): Observable<number>;
    moveLdPorts_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveLdPortsClient implements IMoveLdPortsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveLdPorts_GetAll(): Observable<MoveLdPortsDto[]> {
        let url_ = this.baseUrl + "/api/MoveLdPorts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPorts_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPorts_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLdPortsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLdPortsDto[]>;
        }));
    }

    protected processMoveLdPorts_GetAll(response: HttpResponseBase): Observable<MoveLdPortsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveLdPortsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveLdPorts_Create(commad: CreateMoveLdPortCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveLdPorts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPorts_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPorts_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveLdPorts_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveLdPorts_Get(id: number): Observable<MoveLdPortDto> {
        let url_ = this.baseUrl + "/api/MoveLdPorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPorts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPorts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLdPortDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLdPortDto>;
        }));
    }

    protected processMoveLdPorts_Get(response: HttpResponseBase): Observable<MoveLdPortDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveLdPortDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveLdPorts_Update(id: number, command: UpdateMoveLdPortCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveLdPorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPorts_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPorts_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveLdPorts_Update(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveLdPorts_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveLdPorts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPorts_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPorts_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveLdPorts_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveLdPortsVmClient {
    moveLdPortsVm_Get(id: number): Observable<MoveLdPortVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveLdPortsVmClient implements IMoveLdPortsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveLdPortsVm_Get(id: number): Observable<MoveLdPortVm> {
        let url_ = this.baseUrl + "/api/MoveLdPortsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLdPortsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLdPortsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLdPortVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLdPortVm>;
        }));
    }

    protected processMoveLdPortsVm_Get(response: HttpResponseBase): Observable<MoveLdPortVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveLdPortVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveOpsTrafficsByVoyageIdClient {
    moveOpsTrafficsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveOpsTrafficsDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveOpsTrafficsByVoyageIdClient implements IMoveOpsTrafficsByVoyageIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveOpsTrafficsByVoyageId_Get(id: number, refNo: number, moveNo: number): Observable<MoveOpsTrafficsDto[]> {
        let url_ = this.baseUrl + "/api/MoveOpsTrafficsByVoyageId/{id}/{refNo}/{moveNo}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTrafficsByVoyageId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTrafficsByVoyageId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveOpsTrafficsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveOpsTrafficsDto[]>;
        }));
    }

    protected processMoveOpsTrafficsByVoyageId_Get(response: HttpResponseBase): Observable<MoveOpsTrafficsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveOpsTrafficsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveOpsTrafficsClient {
    moveOpsTraffics_GetAll(): Observable<MoveOpsTrafficsDto[]>;
    moveOpsTraffics_Create(commad: CreateMoveOpsTrafficCommand): Observable<number>;
    moveOpsTraffics_Get(id: number): Observable<MoveOpsTrafficDto>;
    moveOpsTraffics_Update(id: number, command: UpdateMoveOpsTrafficCommand): Observable<number>;
    moveOpsTraffics_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveOpsTrafficsClient implements IMoveOpsTrafficsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveOpsTraffics_GetAll(): Observable<MoveOpsTrafficsDto[]> {
        let url_ = this.baseUrl + "/api/MoveOpsTraffics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTraffics_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTraffics_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveOpsTrafficsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveOpsTrafficsDto[]>;
        }));
    }

    protected processMoveOpsTraffics_GetAll(response: HttpResponseBase): Observable<MoveOpsTrafficsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveOpsTrafficsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveOpsTraffics_Create(commad: CreateMoveOpsTrafficCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveOpsTraffics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTraffics_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTraffics_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveOpsTraffics_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveOpsTraffics_Get(id: number): Observable<MoveOpsTrafficDto> {
        let url_ = this.baseUrl + "/api/MoveOpsTraffics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTraffics_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTraffics_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveOpsTrafficDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveOpsTrafficDto>;
        }));
    }

    protected processMoveOpsTraffics_Get(response: HttpResponseBase): Observable<MoveOpsTrafficDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveOpsTrafficDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveOpsTraffics_Update(id: number, command: UpdateMoveOpsTrafficCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveOpsTraffics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTraffics_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTraffics_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveOpsTraffics_Update(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveOpsTraffics_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveOpsTraffics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTraffics_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTraffics_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveOpsTraffics_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveOpsTrafficsVmClient {
    moveOpsTrafficsVm_Get(id: number): Observable<MoveOpsTrafficVm>;
    moveOpsTrafficsVm_GetNew(refNo: number, moveNo: number): Observable<MoveOpsTrafficVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveOpsTrafficsVmClient implements IMoveOpsTrafficsVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveOpsTrafficsVm_Get(id: number): Observable<MoveOpsTrafficVm> {
        let url_ = this.baseUrl + "/api/MoveOpsTrafficsVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTrafficsVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTrafficsVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveOpsTrafficVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveOpsTrafficVm>;
        }));
    }

    protected processMoveOpsTrafficsVm_Get(response: HttpResponseBase): Observable<MoveOpsTrafficVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveOpsTrafficVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveOpsTrafficsVm_GetNew(refNo: number, moveNo: number): Observable<MoveOpsTrafficVm> {
        let url_ = this.baseUrl + "/api/MoveOpsTrafficsVm/{refNo}/{moveNo}";
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOpsTrafficsVm_GetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOpsTrafficsVm_GetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveOpsTrafficVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveOpsTrafficVm>;
        }));
    }

    protected processMoveOpsTrafficsVm_GetNew(response: HttpResponseBase): Observable<MoveOpsTrafficVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveOpsTrafficVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveSpecialProvisionsClient {
    moveSpecialProvisions_GetMoveSpecialProvisions(): Observable<MoveSpecialProvisionsDto[]>;
    moveSpecialProvisions_CreateMoveSpecialProvision(commad: CreateMoveSpecialProvisionCommand): Observable<number>;
    moveSpecialProvisions_GetMoveSpecialProvisionsByVoyageId(id: number): Observable<MoveSpecialProvisionsDto[]>;
    moveSpecialProvisions_GetMoveSpecialProvision(id: number): Observable<MoveSpecialProvisionDto>;
    moveSpecialProvisions_UpdateMoveSpecialProvision(id: number, command: UpdateMoveSpecialProvisionCommand): Observable<number>;
    moveSpecialProvisions_DeleteMoveSpecialProvision(id: number): Observable<void>;
    moveSpecialProvisions_GetMoveSpecialProvisionSelectOptions(): Observable<SelectDto[]>;
    moveSpecialProvisions_GetMoveSpecialProvisionByCode(code: string): Observable<MoveSpecialProvisionDto>;
    moveSpecialProvisions_GetMoveSpecialProvisionVm(id: number): Observable<MoveSpecialProvisionVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveSpecialProvisionsClient implements IMoveSpecialProvisionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveSpecialProvisions_GetMoveSpecialProvisions(): Observable<MoveSpecialProvisionsDto[]> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSpecialProvisionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSpecialProvisionsDto[]>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvisions(response: HttpResponseBase): Observable<MoveSpecialProvisionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveSpecialProvisionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_CreateMoveSpecialProvision(commad: CreateMoveSpecialProvisionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_CreateMoveSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_CreateMoveSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveSpecialProvisions_CreateMoveSpecialProvision(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_GetMoveSpecialProvisionsByVoyageId(id: number): Observable<MoveSpecialProvisionsDto[]> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/GetMoveSpecialProvisionsByVoyageId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvisionsByVoyageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvisionsByVoyageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSpecialProvisionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSpecialProvisionsDto[]>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvisionsByVoyageId(response: HttpResponseBase): Observable<MoveSpecialProvisionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveSpecialProvisionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_GetMoveSpecialProvision(id: number): Observable<MoveSpecialProvisionDto> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSpecialProvisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSpecialProvisionDto>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvision(response: HttpResponseBase): Observable<MoveSpecialProvisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveSpecialProvisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_UpdateMoveSpecialProvision(id: number, command: UpdateMoveSpecialProvisionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_UpdateMoveSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_UpdateMoveSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveSpecialProvisions_UpdateMoveSpecialProvision(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_DeleteMoveSpecialProvision(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_DeleteMoveSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_DeleteMoveSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveSpecialProvisions_DeleteMoveSpecialProvision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_GetMoveSpecialProvisionSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/GetMoveSpecialProvisionSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvisionSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvisionSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvisionSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_GetMoveSpecialProvisionByCode(code: string): Observable<MoveSpecialProvisionDto> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/GetMoveSpecialProvisionByCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvisionByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvisionByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSpecialProvisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSpecialProvisionDto>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvisionByCode(response: HttpResponseBase): Observable<MoveSpecialProvisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveSpecialProvisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveSpecialProvisions_GetMoveSpecialProvisionVm(id: number): Observable<MoveSpecialProvisionVm> {
        let url_ = this.baseUrl + "/api/MoveSpecialProvisions/GetMoveSpecialProvisionVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveSpecialProvisions_GetMoveSpecialProvisionVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveSpecialProvisions_GetMoveSpecialProvisionVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSpecialProvisionVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSpecialProvisionVm>;
        }));
    }

    protected processMoveSpecialProvisions_GetMoveSpecialProvisionVm(response: HttpResponseBase): Observable<MoveSpecialProvisionVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveSpecialProvisionVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMoveVesselsClient {
    moveVessels_GetMoveVessels(): Observable<MoveVesselsDto[]>;
    moveVessels_CreateMoveVessel(commad: CreateMoveVesselCommand): Observable<number>;
    moveVessels_GetMoveVessel(id: number): Observable<MoveVesselDto>;
    moveVessels_UpdateMoveVessel(id: number, command: UpdateMoveVesselCommand): Observable<number>;
    moveVessels_DeleteMoveVessel(id: number): Observable<void>;
    moveVessels_GetMoveVesselsByVoyageId(id: number): Observable<MoveVesselsDto[]>;
    moveVessels_GetMoveVesselVm(id: number): Observable<MoveVesselVm>;
}

@Injectable({
    providedIn: 'root'
})
export class MoveVesselsClient implements IMoveVesselsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    moveVessels_GetMoveVessels(): Observable<MoveVesselsDto[]> {
        let url_ = this.baseUrl + "/api/MoveVessels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_GetMoveVessels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_GetMoveVessels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveVesselsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveVesselsDto[]>;
        }));
    }

    protected processMoveVessels_GetMoveVessels(response: HttpResponseBase): Observable<MoveVesselsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveVesselsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_CreateMoveVessel(commad: CreateMoveVesselCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveVessels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_CreateMoveVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_CreateMoveVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveVessels_CreateMoveVessel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_GetMoveVessel(id: number): Observable<MoveVesselDto> {
        let url_ = this.baseUrl + "/api/MoveVessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_GetMoveVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_GetMoveVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveVesselDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveVesselDto>;
        }));
    }

    protected processMoveVessels_GetMoveVessel(response: HttpResponseBase): Observable<MoveVesselDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveVesselDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_UpdateMoveVessel(id: number, command: UpdateMoveVesselCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MoveVessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_UpdateMoveVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_UpdateMoveVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMoveVessels_UpdateMoveVessel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_DeleteMoveVessel(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MoveVessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_DeleteMoveVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_DeleteMoveVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveVessels_DeleteMoveVessel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_GetMoveVesselsByVoyageId(id: number): Observable<MoveVesselsDto[]> {
        let url_ = this.baseUrl + "/api/MoveVessels/GetMoveVesselsByVoyageId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_GetMoveVesselsByVoyageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_GetMoveVesselsByVoyageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveVesselsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveVesselsDto[]>;
        }));
    }

    protected processMoveVessels_GetMoveVesselsByVoyageId(response: HttpResponseBase): Observable<MoveVesselsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoveVesselsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveVessels_GetMoveVesselVm(id: number): Observable<MoveVesselVm> {
        let url_ = this.baseUrl + "/api/MoveVessels/GetMoveVesselVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveVessels_GetMoveVesselVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveVessels_GetMoveVesselVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveVesselVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveVesselVm>;
        }));
    }

    protected processMoveVessels_GetMoveVesselVm(response: HttpResponseBase): Observable<MoveVesselVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveVesselVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMultiMoveOpsTrafficsClient {
    multiMoveOpsTraffics_Create(commad: CreateMultiMoveOpsTrafficCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class MultiMoveOpsTrafficsClient implements IMultiMoveOpsTrafficsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    multiMoveOpsTraffics_Create(commad: CreateMultiMoveOpsTrafficCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/MultiMoveOpsTraffics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultiMoveOpsTraffics_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultiMoveOpsTraffics_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMultiMoveOpsTraffics_Create(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INewVoyagesClient {
    newVoyages_Get(id: number): Observable<BatchVoyageVm>;
    newVoyages_Create(command: NewCreateVoyageCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class NewVoyagesClient implements INewVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    newVoyages_Get(id: number): Observable<BatchVoyageVm> {
        let url_ = this.baseUrl + "/api/NewVoyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchVoyageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchVoyageVm>;
        }));
    }

    protected processNewVoyages_Get(response: HttpResponseBase): Observable<BatchVoyageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchVoyageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    newVoyages_Create(command: NewCreateVoyageCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/NewVoyages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewVoyages_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewVoyages_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processNewVoyages_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INominationsClient {
    nominations_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<VoyagesReportVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class NominationsClient implements INominationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    nominations_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<VoyagesReportVm[]> {
        let url_ = this.baseUrl + "/api/Nominations/{owner}/{ownerContact}/{charterer}/{chartererContact}/{vessel}/{status}/{fromDate}/{toDate}/{fromToday}/{dateOption}/{refNo}/{moveNo}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (ownerContact === undefined || ownerContact === null)
            throw new Error("The parameter 'ownerContact' must be defined.");
        url_ = url_.replace("{ownerContact}", encodeURIComponent("" + ownerContact));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (chartererContact === undefined || chartererContact === null)
            throw new Error("The parameter 'chartererContact' must be defined.");
        url_ = url_.replace("{chartererContact}", encodeURIComponent("" + chartererContact));
        if (vessel === undefined || vessel === null)
            throw new Error("The parameter 'vessel' must be defined.");
        url_ = url_.replace("{vessel}", encodeURIComponent("" + vessel));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNominations_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNominations_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesReportVm[]>;
        }));
    }

    protected processNominations_Get(response: HttpResponseBase): Observable<VoyagesReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOneMoveOpsTrafficsClient {
    oneMoveOpsTraffics_Create(commad: CreateOneMoveOpsTrafficCommand): Observable<number>;
    oneMoveOpsTraffics_BatchCreate(commad: CreateBatchMoveOpsTrafficCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class OneMoveOpsTrafficsClient implements IOneMoveOpsTrafficsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    oneMoveOpsTraffics_Create(commad: CreateOneMoveOpsTrafficCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/OneMoveOpsTraffics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOneMoveOpsTraffics_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOneMoveOpsTraffics_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processOneMoveOpsTraffics_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    oneMoveOpsTraffics_BatchCreate(commad: CreateBatchMoveOpsTrafficCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/OneMoveOpsTraffics/BatchCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOneMoveOpsTraffics_BatchCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOneMoveOpsTraffics_BatchCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOneMoveOpsTraffics_BatchCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpCodesClient {
    opCodes_GetOpCodes(): Observable<OpCodesDto[]>;
    opCodes_CreateOpCode(commad: CreateOpCodeCommand): Observable<void>;
    opCodes_GetOpCode(id: number): Observable<OpCodeDto>;
    opCodes_UpdateOpCode(id: number, command: UpdateOpCodeCommand): Observable<void>;
    opCodes_DeleteOpCode(id: number): Observable<void>;
    opCodes_GetOpCodeSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OpCodesClient implements IOpCodesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    opCodes_GetOpCodes(): Observable<OpCodesDto[]> {
        let url_ = this.baseUrl + "/api/OpCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_GetOpCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_GetOpCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpCodesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpCodesDto[]>;
        }));
    }

    protected processOpCodes_GetOpCodes(response: HttpResponseBase): Observable<OpCodesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpCodesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    opCodes_CreateOpCode(commad: CreateOpCodeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/OpCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_CreateOpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_CreateOpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpCodes_CreateOpCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    opCodes_GetOpCode(id: number): Observable<OpCodeDto> {
        let url_ = this.baseUrl + "/api/OpCodes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_GetOpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_GetOpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpCodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpCodeDto>;
        }));
    }

    protected processOpCodes_GetOpCode(response: HttpResponseBase): Observable<OpCodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpCodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    opCodes_UpdateOpCode(id: number, command: UpdateOpCodeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/OpCodes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_UpdateOpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_UpdateOpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpCodes_UpdateOpCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    opCodes_DeleteOpCode(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OpCodes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_DeleteOpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_DeleteOpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpCodes_DeleteOpCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    opCodes_GetOpCodeSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/OpCodes/GetOpCodeSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpCodes_GetOpCodeSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpCodes_GetOpCodeSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processOpCodes_GetOpCodeSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhoneBooksClient {
    phoneBooks_GetAll(): Observable<PhoneBooksDto[]>;
    phoneBooks_Create(commad: CreatePhoneBookCommand): Observable<void>;
    phoneBooks_Get(id: number): Observable<PhoneBookDto>;
    phoneBooks_Update(id: number, command: UpdatePhoneBookCommand): Observable<void>;
    phoneBooks_Delete(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class PhoneBooksClient implements IPhoneBooksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    phoneBooks_GetAll(): Observable<PhoneBooksDto[]> {
        let url_ = this.baseUrl + "/api/PhoneBooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooks_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooks_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneBooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneBooksDto[]>;
        }));
    }

    protected processPhoneBooks_GetAll(response: HttpResponseBase): Observable<PhoneBooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneBooksDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneBooks_Create(commad: CreatePhoneBookCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneBooks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooks_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooks_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneBooks_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneBooks_Get(id: number): Observable<PhoneBookDto> {
        let url_ = this.baseUrl + "/api/PhoneBooks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooks_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooks_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneBookDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneBookDto>;
        }));
    }

    protected processPhoneBooks_Get(response: HttpResponseBase): Observable<PhoneBookDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneBookDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneBooks_Update(id: number, command: UpdatePhoneBookCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneBooks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooks_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooks_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneBooks_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneBooks_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneBooks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooks_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooks_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneBooks_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhoneBooksVmClient {
    phoneBooksVm_Get(id: number): Observable<PhoneBookVm>;
}

@Injectable({
    providedIn: 'root'
})
export class PhoneBooksVmClient implements IPhoneBooksVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    phoneBooksVm_Get(id: number): Observable<PhoneBookVm> {
        let url_ = this.baseUrl + "/api/PhoneBooksVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneBooksVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneBooksVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneBookVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneBookVm>;
        }));
    }

    protected processPhoneBooksVm_Get(response: HttpResponseBase): Observable<PhoneBookVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneBookVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhonesByEmployeeIdClient {
    phonesByEmployeeId_Get(id: number): Observable<PhonesDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PhonesByEmployeeIdClient implements IPhonesByEmployeeIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    phonesByEmployeeId_Get(id: number): Observable<PhonesDto[]> {
        let url_ = this.baseUrl + "/api/PhonesByEmployeeId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhonesByEmployeeId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhonesByEmployeeId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhonesDto[]>;
        }));
    }

    protected processPhonesByEmployeeId_Get(response: HttpResponseBase): Observable<PhonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhonesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhonesClient {
    phones_Get(id: number): Observable<PhoneVm>;
    phones_Update(id: number, command: UpdatePhoneCommand): Observable<void>;
    phones_Delete(id: number): Observable<void>;
    phones_Create(commad: CreatePhoneCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class PhonesClient implements IPhonesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    phones_Get(id: number): Observable<PhoneVm> {
        let url_ = this.baseUrl + "/api/Phones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhones_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhones_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneVm>;
        }));
    }

    protected processPhones_Get(response: HttpResponseBase): Observable<PhoneVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phones_Update(id: number, command: UpdatePhoneCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Phones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhones_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhones_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhones_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phones_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Phones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhones_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhones_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhones_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phones_Create(commad: CreatePhoneCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Phones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhones_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhones_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhones_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPhoneTypesClient {
    phoneTypes_GetPhoneTypes(): Observable<PhoneTypesDto[]>;
    phoneTypes_CreatePhoneType(commad: CreatePhoneTypeCommand): Observable<void>;
    phoneTypes_GetPhoneType(id: number): Observable<PhoneTypeDto>;
    phoneTypes_UpdatePhoneType(id: number, command: UpdatePhoneTypeCommand): Observable<void>;
    phoneTypes_DeletePhoneType(id: number): Observable<void>;
    phoneTypes_GetPhoneTypeSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PhoneTypesClient implements IPhoneTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    phoneTypes_GetPhoneTypes(): Observable<PhoneTypesDto[]> {
        let url_ = this.baseUrl + "/api/PhoneTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_GetPhoneTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_GetPhoneTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneTypesDto[]>;
        }));
    }

    protected processPhoneTypes_GetPhoneTypes(response: HttpResponseBase): Observable<PhoneTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneTypes_CreatePhoneType(commad: CreatePhoneTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_CreatePhoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_CreatePhoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneTypes_CreatePhoneType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneTypes_GetPhoneType(id: number): Observable<PhoneTypeDto> {
        let url_ = this.baseUrl + "/api/PhoneTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_GetPhoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_GetPhoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneTypeDto>;
        }));
    }

    protected processPhoneTypes_GetPhoneType(response: HttpResponseBase): Observable<PhoneTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhoneTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneTypes_UpdatePhoneType(id: number, command: UpdatePhoneTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_UpdatePhoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_UpdatePhoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneTypes_UpdatePhoneType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneTypes_DeletePhoneType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PhoneTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_DeletePhoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_DeletePhoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPhoneTypes_DeletePhoneType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    phoneTypes_GetPhoneTypeSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/PhoneTypes/GetPhoneTypeSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoneTypes_GetPhoneTypeSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoneTypes_GetPhoneTypeSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processPhoneTypes_GetPhoneTypeSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPortsClient {
    ports_GetPorts(): Observable<PortsDto[]>;
    ports_CreatePort(commad: CreatePortCommand): Observable<void>;
    ports_GetPort(id: number): Observable<PortVm>;
    ports_UpdatePort(id: number, command: UpdatePortCommand): Observable<void>;
    ports_DeletePort(id: number): Observable<void>;
    ports_GetPortSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PortsClient implements IPortsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    ports_GetPorts(): Observable<PortsDto[]> {
        let url_ = this.baseUrl + "/api/Ports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_GetPorts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_GetPorts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortsDto[]>;
        }));
    }

    protected processPorts_GetPorts(response: HttpResponseBase): Observable<PortsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PortsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ports_CreatePort(commad: CreatePortCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Ports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_CreatePort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_CreatePort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPorts_CreatePort(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ports_GetPort(id: number): Observable<PortVm> {
        let url_ = this.baseUrl + "/api/Ports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_GetPort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_GetPort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortVm>;
        }));
    }

    protected processPorts_GetPort(response: HttpResponseBase): Observable<PortVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ports_UpdatePort(id: number, command: UpdatePortCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Ports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_UpdatePort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_UpdatePort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPorts_UpdatePort(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ports_DeletePort(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Ports/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_DeletePort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_DeletePort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPorts_DeletePort(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ports_GetPortSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Ports/GetPortSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPorts_GetPortSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPorts_GetPortSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processPorts_GetPortSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRelationTypesClient {
    relationTypes_GetRelationTypes(): Observable<RelationTypesDto[]>;
    relationTypes_CreateRelationType(commad: CreateRelationTypeCommand): Observable<void>;
    relationTypes_GetRelationType(id: number): Observable<RelationTypeDto>;
    relationTypes_UpdateRelationType(id: number, command: UpdateRelationTypeCommand): Observable<void>;
    relationTypes_DeleteRelationType(id: number): Observable<void>;
    relationTypes_GetRelationTypeSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class RelationTypesClient implements IRelationTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    relationTypes_GetRelationTypes(): Observable<RelationTypesDto[]> {
        let url_ = this.baseUrl + "/api/RelationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_GetRelationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_GetRelationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelationTypesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelationTypesDto[]>;
        }));
    }

    protected processRelationTypes_GetRelationTypes(response: HttpResponseBase): Observable<RelationTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelationTypesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relationTypes_CreateRelationType(commad: CreateRelationTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/RelationTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_CreateRelationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_CreateRelationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRelationTypes_CreateRelationType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relationTypes_GetRelationType(id: number): Observable<RelationTypeDto> {
        let url_ = this.baseUrl + "/api/RelationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_GetRelationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_GetRelationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelationTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelationTypeDto>;
        }));
    }

    protected processRelationTypes_GetRelationType(response: HttpResponseBase): Observable<RelationTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relationTypes_UpdateRelationType(id: number, command: UpdateRelationTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/RelationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_UpdateRelationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_UpdateRelationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRelationTypes_UpdateRelationType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relationTypes_DeleteRelationType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RelationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_DeleteRelationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_DeleteRelationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRelationTypes_DeleteRelationType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relationTypes_GetRelationTypeSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/RelationTypes/GetRelationTypeSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelationTypes_GetRelationTypeSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelationTypes_GetRelationTypeSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processRelationTypes_GetRelationTypeSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReleasesClient {
    releases_GetReleases(): Observable<ReleasesDto[]>;
    releases_CreateRelease(commad: CreateReleaseCommand): Observable<void>;
    releases_GetLatestReleases(): Observable<ReleasesDto[]>;
    releases_GetRelease(id: number): Observable<ReleaseDto>;
    releases_UpdateRelease(id: number, command: UpdateReleaseCommand): Observable<void>;
    releases_DeleteRelease(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ReleasesClient implements IReleasesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    releases_GetReleases(): Observable<ReleasesDto[]> {
        let url_ = this.baseUrl + "/api/Releases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_GetReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_GetReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleasesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleasesDto[]>;
        }));
    }

    protected processReleases_GetReleases(response: HttpResponseBase): Observable<ReleasesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleasesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_CreateRelease(commad: CreateReleaseCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Releases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_CreateRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_CreateRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleases_CreateRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_GetLatestReleases(): Observable<ReleasesDto[]> {
        let url_ = this.baseUrl + "/api/Releases/GetLatestReleases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_GetLatestReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_GetLatestReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleasesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleasesDto[]>;
        }));
    }

    protected processReleases_GetLatestReleases(response: HttpResponseBase): Observable<ReleasesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleasesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_GetRelease(id: number): Observable<ReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_GetRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_GetRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }));
    }

    protected processReleases_GetRelease(response: HttpResponseBase): Observable<ReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_UpdateRelease(id: number, command: UpdateReleaseCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Releases/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_UpdateRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_UpdateRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleases_UpdateRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_DeleteRelease(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Releases/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_DeleteRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_DeleteRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleases_DeleteRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportBargeCharterPartyContractsClient {
    reportBargeCharterPartyContracts_Get(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportBargeCharterPartyContractsClient implements IReportBargeCharterPartyContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportBargeCharterPartyContracts_Get(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportBargeCharterPartyContracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportBargeCharterPartyContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportBargeCharterPartyContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportBargeCharterPartyContracts_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportCompaniesClient {
    reportCompanies_Get(name: string): Observable<CompaniesReport[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportCompaniesClient implements IReportCompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportCompanies_Get(name: string): Observable<CompaniesReport[]> {
        let url_ = this.baseUrl + "/api/ReportCompanies/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportCompanies_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportCompanies_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompaniesReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompaniesReport[]>;
        }));
    }

    protected processReportCompanies_Get(response: HttpResponseBase): Observable<CompaniesReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompaniesReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportContractsClient {
    reportContracts_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<ContractsReportVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportContractsClient implements IReportContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportContracts_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<ContractsReportVm[]> {
        let url_ = this.baseUrl + "/api/ReportContracts/{owner}/{ownerContact}/{charterer}/{chartererContact}/{status}/{fromDate}/{toDate}/{fromToday}/{dateOption}/{refNo}/{moveNo}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (ownerContact === undefined || ownerContact === null)
            throw new Error("The parameter 'ownerContact' must be defined.");
        url_ = url_.replace("{ownerContact}", encodeURIComponent("" + ownerContact));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (chartererContact === undefined || chartererContact === null)
            throw new Error("The parameter 'chartererContact' must be defined.");
        url_ = url_.replace("{chartererContact}", encodeURIComponent("" + chartererContact));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractsReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractsReportVm[]>;
        }));
    }

    protected processReportContracts_Get(response: HttpResponseBase): Observable<ContractsReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractsReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportEmployeesClient {
    reportEmployees_Get(name: string): Observable<EmployeesReport[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportEmployeesClient implements IReportEmployeesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportEmployees_Get(name: string): Observable<EmployeesReport[]> {
        let url_ = this.baseUrl + "/api/ReportEmployees/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportEmployees_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportEmployees_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeesReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeesReport[]>;
        }));
    }

    protected processReportEmployees_Get(response: HttpResponseBase): Observable<EmployeesReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeesReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportHistoricVoyagesClient {
    reportHistoricVoyages_Get(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportHistoricVoyagesClient implements IReportHistoricVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportHistoricVoyages_Get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportHistoricVoyages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportHistoricVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportHistoricVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportHistoricVoyages_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportInvoicesClient {
    reportInvoices_GetAll(): Observable<InvoicesReportVm[]>;
    reportInvoices_Get(name: string): Observable<InvoicesReportVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportInvoicesClient implements IReportInvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportInvoices_GetAll(): Observable<InvoicesReportVm[]> {
        let url_ = this.baseUrl + "/api/ReportInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportInvoices_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportInvoices_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicesReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicesReportVm[]>;
        }));
    }

    protected processReportInvoices_GetAll(response: HttpResponseBase): Observable<InvoicesReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoicesReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reportInvoices_Get(name: string): Observable<InvoicesReportVm[]> {
        let url_ = this.baseUrl + "/api/ReportInvoices/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportInvoices_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportInvoices_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicesReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicesReportVm[]>;
        }));
    }

    protected processReportInvoices_Get(response: HttpResponseBase): Observable<InvoicesReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoicesReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportMultiPageTrafficsContractClient {
    reportMultiPageTrafficsContract_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string | null | undefined, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportMultiPageTrafficsContractClient implements IReportMultiPageTrafficsContractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportMultiPageTrafficsContract_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string | null | undefined, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportMultiPageTrafficsContract/{owner}/{ownerContact}/{charterer}/{chartererContact}/vessel/{status}/{fromDate}/{toDate}/{fromToday}/{dateOption}/{refNo}/{moveNo}?";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (ownerContact === undefined || ownerContact === null)
            throw new Error("The parameter 'ownerContact' must be defined.");
        url_ = url_.replace("{ownerContact}", encodeURIComponent("" + ownerContact));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (chartererContact === undefined || chartererContact === null)
            throw new Error("The parameter 'chartererContact' must be defined.");
        url_ = url_.replace("{chartererContact}", encodeURIComponent("" + chartererContact));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        if (vessel !== undefined && vessel !== null)
            url_ += "vessel=" + encodeURIComponent("" + vessel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportMultiPageTrafficsContract_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportMultiPageTrafficsContract_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportMultiPageTrafficsContract_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportNominationContractsClient {
    reportNominationContracts_Get(id: number): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportNominationContractsClient implements IReportNominationContractsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportNominationContracts_Get(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportNominationContracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportNominationContracts_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportNominationContracts_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportNominationContracts_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportsClient {
    reports_GetOutstandingInvoices(): Observable<OutstandingInvoice[]>;
    reports_DownloadOutstandingInvoices(term: string): Observable<FileResponse>;
    reports_GetDemurrageLevels(): Observable<DemurrageLevel[]>;
    reports_DownloadDemurrageLevel(term: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportsClient implements IReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reports_GetOutstandingInvoices(): Observable<OutstandingInvoice[]> {
        let url_ = this.baseUrl + "/api/Reports/GetOutstandingInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReports_GetOutstandingInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReports_GetOutstandingInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutstandingInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutstandingInvoice[]>;
        }));
    }

    protected processReports_GetOutstandingInvoices(response: HttpResponseBase): Observable<OutstandingInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutstandingInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reports_DownloadOutstandingInvoices(term: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadOutstandingInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(term);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReports_DownloadOutstandingInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReports_DownloadOutstandingInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReports_DownloadOutstandingInvoices(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reports_GetDemurrageLevels(): Observable<DemurrageLevel[]> {
        let url_ = this.baseUrl + "/api/Reports/GetDemurrageLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReports_GetDemurrageLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReports_GetDemurrageLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DemurrageLevel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DemurrageLevel[]>;
        }));
    }

    protected processReports_GetDemurrageLevels(response: HttpResponseBase): Observable<DemurrageLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DemurrageLevel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reports_DownloadDemurrageLevel(term: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadDemurrageLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(term);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReports_DownloadDemurrageLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReports_DownloadDemurrageLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReports_DownloadDemurrageLevel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportTrafficContractClient {
    reportTrafficContract_Get(id: number, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportTrafficContractClient implements IReportTrafficContractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportTrafficContract_Get(id: number, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTrafficContract/{id}/{fromDate}/{toDate}/{fromToday}/{dateOption}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTrafficContract_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTrafficContract_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportTrafficContract_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportTrafficsContractClient {
    reportTrafficsContract_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportTrafficsContractClient implements IReportTrafficsContractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportTrafficsContract_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTrafficsContract/{owner}/{ownerContact}/{charterer}/{chartererContact}/{vessel}/{status}/{fromDate}/{toDate}/{fromToday}/{dateOption}/{refNo}/{moveNo}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (ownerContact === undefined || ownerContact === null)
            throw new Error("The parameter 'ownerContact' must be defined.");
        url_ = url_.replace("{ownerContact}", encodeURIComponent("" + ownerContact));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (chartererContact === undefined || chartererContact === null)
            throw new Error("The parameter 'chartererContact' must be defined.");
        url_ = url_.replace("{chartererContact}", encodeURIComponent("" + chartererContact));
        if (vessel === undefined || vessel === null)
            throw new Error("The parameter 'vessel' must be defined.");
        url_ = url_.replace("{vessel}", encodeURIComponent("" + vessel));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTrafficsContract_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTrafficsContract_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReportTrafficsContract_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportTrafficsClient {
    reportTraffics_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<VoyagesReportVm[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportTrafficsClient implements IReportTrafficsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    reportTraffics_Get(owner: string, ownerContact: string, charterer: string, chartererContact: string, vessel: string, status: string, fromDate: Date, toDate: Date, fromToday: Date, dateOption: string, refNo: string, moveNo: string): Observable<VoyagesReportVm[]> {
        let url_ = this.baseUrl + "/api/ReportTraffics/{owner}/{ownerContact}/{charterer}/{chartererContact}/{vessel}/{status}/{fromDate}/{toDate}/{fromToday}/{dateOption}/{refNo}/{moveNo}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        if (ownerContact === undefined || ownerContact === null)
            throw new Error("The parameter 'ownerContact' must be defined.");
        url_ = url_.replace("{ownerContact}", encodeURIComponent("" + ownerContact));
        if (charterer === undefined || charterer === null)
            throw new Error("The parameter 'charterer' must be defined.");
        url_ = url_.replace("{charterer}", encodeURIComponent("" + charterer));
        if (chartererContact === undefined || chartererContact === null)
            throw new Error("The parameter 'chartererContact' must be defined.");
        url_ = url_.replace("{chartererContact}", encodeURIComponent("" + chartererContact));
        if (vessel === undefined || vessel === null)
            throw new Error("The parameter 'vessel' must be defined.");
        url_ = url_.replace("{vessel}", encodeURIComponent("" + vessel));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toISOString() : "null"));
        if (fromToday === undefined || fromToday === null)
            throw new Error("The parameter 'fromToday' must be defined.");
        url_ = url_.replace("{fromToday}", encodeURIComponent(fromToday ? "" + fromToday.toISOString() : "null"));
        if (dateOption === undefined || dateOption === null)
            throw new Error("The parameter 'dateOption' must be defined.");
        url_ = url_.replace("{dateOption}", encodeURIComponent("" + dateOption));
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        if (moveNo === undefined || moveNo === null)
            throw new Error("The parameter 'moveNo' must be defined.");
        url_ = url_.replace("{moveNo}", encodeURIComponent("" + moveNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTraffics_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTraffics_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesReportVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesReportVm[]>;
        }));
    }

    protected processReportTraffics_Get(response: HttpResponseBase): Observable<VoyagesReportVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesReportVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRolesClient {
    roles_GetAll(): Observable<RolesDto[]>;
    roles_Create(role: CreateRoleDto): Observable<void>;
    roles_Get(id: string): Observable<RoleDto>;
    roles_Update(id: string, role: UpdateRoleDto): Observable<void>;
    roles_Delete(id: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient implements IRolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    roles_GetAll(): Observable<RolesDto[]> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesDto[]>;
        }));
    }

    protected processRoles_GetAll(response: HttpResponseBase): Observable<RolesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roles_Create(role: CreateRoleDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoles_Create(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roles_Get(id: string): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processRoles_Get(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roles_Update(id: string, role: UpdateRoleDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoles_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    roles_Delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoles_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISpecialProvisionsClient {
    specialProvisions_GetSpecialProvisions(): Observable<SpecialProvisionsDto[]>;
    specialProvisions_CreateSpecialProvision(commad: CreateSpecialProvisionCommand): Observable<void>;
    specialProvisions_GetSpecialProvision(id: number): Observable<SpecialProvisionDto>;
    specialProvisions_UpdateSpecialProvision(id: number, command: UpdateSpecialProvisionCommand): Observable<void>;
    specialProvisions_DeleteSpecialProvision(id: number): Observable<void>;
    specialProvisions_GetSpecialProvisionSelectOptions(): Observable<SelectDto[]>;
    specialProvisions_GetSpecialProvisionByCode(code: string): Observable<SpecialProvisionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class SpecialProvisionsClient implements ISpecialProvisionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    specialProvisions_GetSpecialProvisions(): Observable<SpecialProvisionsDto[]> {
        let url_ = this.baseUrl + "/api/SpecialProvisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_GetSpecialProvisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_GetSpecialProvisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialProvisionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialProvisionsDto[]>;
        }));
    }

    protected processSpecialProvisions_GetSpecialProvisions(response: HttpResponseBase): Observable<SpecialProvisionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialProvisionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_CreateSpecialProvision(commad: CreateSpecialProvisionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialProvisions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_CreateSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_CreateSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialProvisions_CreateSpecialProvision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_GetSpecialProvision(id: number): Observable<SpecialProvisionDto> {
        let url_ = this.baseUrl + "/api/SpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_GetSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_GetSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialProvisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialProvisionDto>;
        }));
    }

    protected processSpecialProvisions_GetSpecialProvision(response: HttpResponseBase): Observable<SpecialProvisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialProvisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_UpdateSpecialProvision(id: number, command: UpdateSpecialProvisionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_UpdateSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_UpdateSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialProvisions_UpdateSpecialProvision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_DeleteSpecialProvision(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/SpecialProvisions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_DeleteSpecialProvision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_DeleteSpecialProvision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSpecialProvisions_DeleteSpecialProvision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_GetSpecialProvisionSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/SpecialProvisions/GetSpecialProvisionSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_GetSpecialProvisionSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_GetSpecialProvisionSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processSpecialProvisions_GetSpecialProvisionSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    specialProvisions_GetSpecialProvisionByCode(code: string): Observable<SpecialProvisionDto> {
        let url_ = this.baseUrl + "/api/SpecialProvisions/GetSpecialProvisionByCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSpecialProvisions_GetSpecialProvisionByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpecialProvisions_GetSpecialProvisionByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialProvisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialProvisionDto>;
        }));
    }

    protected processSpecialProvisions_GetSpecialProvisionByCode(response: HttpResponseBase): Observable<SpecialProvisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialProvisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStatesClient {
    states_GetStates(): Observable<StateDto[]>;
    states_CreateState(commad: CreateStateCommand): Observable<number>;
    states_GetState(id: number): Observable<StateDto>;
    states_UpdateState(id: number, command: UpdateStateCommand): Observable<FileResponse>;
    states_DeleteState(id: number): Observable<FileResponse>;
    states_GetStateSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class StatesClient implements IStatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    states_GetStates(): Observable<StateDto[]> {
        let url_ = this.baseUrl + "/api/States";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_GetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_GetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto[]>;
        }));
    }

    protected processStates_GetStates(response: HttpResponseBase): Observable<StateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    states_CreateState(commad: CreateStateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/States";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_CreateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_CreateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processStates_CreateState(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    states_GetState(id: number): Observable<StateDto> {
        let url_ = this.baseUrl + "/api/States/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_GetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_GetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto>;
        }));
    }

    protected processStates_GetState(response: HttpResponseBase): Observable<StateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    states_UpdateState(id: number, command: UpdateStateCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/States/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_UpdateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_UpdateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processStates_UpdateState(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    states_DeleteState(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/States/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_DeleteState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_DeleteState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processStates_DeleteState(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    states_GetStateSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/States/GetStateSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStates_GetStateSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStates_GetStateSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processStates_GetStateSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStatusesClient {
    statuses_GetStatuses(): Observable<StatusesDto[]>;
    statuses_CreateStatus(commad: CreateStatusCommand): Observable<void>;
    statuses_GetStatus(id: number): Observable<StatusDto>;
    statuses_UpdateStatus(id: number, command: UpdateStatusCommand): Observable<void>;
    statuses_DeleteStatus(id: number): Observable<void>;
    statuses_GetStatusSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class StatusesClient implements IStatusesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    statuses_GetStatuses(): Observable<StatusesDto[]> {
        let url_ = this.baseUrl + "/api/Statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_GetStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_GetStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusesDto[]>;
        }));
    }

    protected processStatuses_GetStatuses(response: HttpResponseBase): Observable<StatusesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statuses_CreateStatus(commad: CreateStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_CreateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_CreateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatuses_CreateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statuses_GetStatus(id: number): Observable<StatusDto> {
        let url_ = this.baseUrl + "/api/Statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_GetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_GetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusDto>;
        }));
    }

    protected processStatuses_GetStatus(response: HttpResponseBase): Observable<StatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statuses_UpdateStatus(id: number, command: UpdateStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_UpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_UpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatuses_UpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statuses_DeleteStatus(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_DeleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_DeleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatuses_DeleteStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statuses_GetStatusSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Statuses/GetStatusSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatuses_GetStatusSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatuses_GetStatusSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processStatuses_GetStatusSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITerminalsClient {
    terminals_GetTerminals(): Observable<TerminalsDto[]>;
    terminals_CreateTerminal(commad: CreateTerminalCommand): Observable<void>;
    terminals_GetTerminal(id: number): Observable<TerminalDto>;
    terminals_UpdateTerminal(id: number, command: UpdateTerminalCommand): Observable<void>;
    terminals_DeleteTerminal(id: number): Observable<void>;
    terminals_GetTerminalSelectOptions(): Observable<SelectDto[]>;
    terminals_GetTerminalVm(id: number): Observable<TerminalVm>;
}

@Injectable({
    providedIn: 'root'
})
export class TerminalsClient implements ITerminalsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    terminals_GetTerminals(): Observable<TerminalsDto[]> {
        let url_ = this.baseUrl + "/api/Terminals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_GetTerminals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_GetTerminals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalsDto[]>;
        }));
    }

    protected processTerminals_GetTerminals(response: HttpResponseBase): Observable<TerminalsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminalsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_CreateTerminal(commad: CreateTerminalCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Terminals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_CreateTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_CreateTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminals_CreateTerminal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_GetTerminal(id: number): Observable<TerminalDto> {
        let url_ = this.baseUrl + "/api/Terminals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_GetTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_GetTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalDto>;
        }));
    }

    protected processTerminals_GetTerminal(response: HttpResponseBase): Observable<TerminalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_UpdateTerminal(id: number, command: UpdateTerminalCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Terminals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_UpdateTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_UpdateTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminals_UpdateTerminal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_DeleteTerminal(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Terminals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_DeleteTerminal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_DeleteTerminal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminals_DeleteTerminal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_GetTerminalSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Terminals/GetTerminalSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_GetTerminalSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_GetTerminalSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processTerminals_GetTerminalSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminals_GetTerminalVm(id: number): Observable<TerminalVm> {
        let url_ = this.baseUrl + "/api/Terminals/GetTerminalVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminals_GetTerminalVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminals_GetTerminalVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminalVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminalVm>;
        }));
    }

    protected processTerminals_GetTerminalVm(response: HttpResponseBase): Observable<TerminalVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TerminalVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUnitsClient {
    units_GetUnits(): Observable<UnitsDto[]>;
    units_CreateUnit(commad: CreateUnitCommand): Observable<void>;
    units_GetUnit(id: number): Observable<UnitDto>;
    units_UpdateUnit(id: number, command: UpdateUnitCommand): Observable<void>;
    units_DeleteUnit(id: number): Observable<void>;
    units_GetUnitSelectOptions(): Observable<SelectDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UnitsClient implements IUnitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    units_GetUnits(): Observable<UnitsDto[]> {
        let url_ = this.baseUrl + "/api/Units";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_GetUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_GetUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitsDto[]>;
        }));
    }

    protected processUnits_GetUnits(response: HttpResponseBase): Observable<UnitsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    units_CreateUnit(commad: CreateUnitCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Units";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_CreateUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_CreateUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnits_CreateUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    units_GetUnit(id: number): Observable<UnitDto> {
        let url_ = this.baseUrl + "/api/Units/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_GetUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_GetUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitDto>;
        }));
    }

    protected processUnits_GetUnit(response: HttpResponseBase): Observable<UnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    units_UpdateUnit(id: number, command: UpdateUnitCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Units/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_UpdateUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_UpdateUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnits_UpdateUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    units_DeleteUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Units/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_DeleteUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_DeleteUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnits_DeleteUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    units_GetUnitSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Units/GetUnitSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnits_GetUnitSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnits_GetUnitSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processUnits_GetUnitSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersClient {
    users_GetAll(): Observable<UsersDto[]>;
    users_CreateUser(user: CreateUserDto): Observable<void>;
    users_Get(id: string): Observable<UserVm>;
    users_UpdateUser(id: string, user: UpdateUserDto): Observable<void>;
    users_DeleteUser(id: string): Observable<void>;
    users_ResetPassword(reset: ResetPasswordDto): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    users_GetAll(): Observable<UsersDto[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto[]>;
        }));
    }

    protected processUsers_GetAll(response: HttpResponseBase): Observable<UsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_CreateUser(user: CreateUserDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_CreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_CreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsers_CreateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_Get(id: string): Observable<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVm>;
        }));
    }

    protected processUsers_Get(response: HttpResponseBase): Observable<UserVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_UpdateUser(id: string, user: UpdateUserDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_UpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_UpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsers_UpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_DeleteUser(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_DeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_DeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsers_DeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_ResetPassword(reset: ResetPasswordDto): Observable<string> {
        let url_ = this.baseUrl + "/api/Users/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reset);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_ResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_ResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUsers_ResetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVesselAisClient {
    vesselAis_GetVesselAisLocation(vesselId: number, live?: boolean | undefined): Observable<VesselAisLocationDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VesselAisClient implements IVesselAisClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    vesselAis_GetVesselAisLocation(vesselId: number, live?: boolean | undefined): Observable<VesselAisLocationDto> {
        let url_ = this.baseUrl + "/api/VesselAis/{vesselId}";
        if (vesselId === undefined || vesselId === null)
            throw new Error("The parameter 'vesselId' must be defined.");
        url_ = url_.replace("{vesselId}", encodeURIComponent("" + vesselId));
        url_ += "?";
        if (live === null)
            throw new Error("The parameter 'live' cannot be null.");
        else if (live !== undefined)
            url_ += "live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVesselAis_GetVesselAisLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVesselAis_GetVesselAisLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VesselAisLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VesselAisLocationDto>;
        }));
    }

    protected processVesselAis_GetVesselAisLocation(response: HttpResponseBase): Observable<VesselAisLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VesselAisLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVesselsClient {
    vessels_GetVessels(): Observable<VesselsDto[]>;
    vessels_CreateVessel(commad: CreateVesselCommand): Observable<void>;
    vessels_GetVessel(id: number): Observable<VesselDto>;
    vessels_UpdateVessel(id: number, command: UpdateVesselCommand): Observable<void>;
    vessels_DeleteVessel(id: number): Observable<void>;
    vessels_GetVesselSelectOptions(): Observable<SelectDto[]>;
    vessels_GetVesselVm(id: number): Observable<VesselVm>;
    vessels_GetVesselExists(id: number, name: string): Observable<boolean>;
    vessels_GetVesselByName(name: string): Observable<VesselDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VesselsClient implements IVesselsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    vessels_GetVessels(): Observable<VesselsDto[]> {
        let url_ = this.baseUrl + "/api/Vessels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVessels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVessels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VesselsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VesselsDto[]>;
        }));
    }

    protected processVessels_GetVessels(response: HttpResponseBase): Observable<VesselsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VesselsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_CreateVessel(commad: CreateVesselCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Vessels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_CreateVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_CreateVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVessels_CreateVessel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_GetVessel(id: number): Observable<VesselDto> {
        let url_ = this.baseUrl + "/api/Vessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VesselDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VesselDto>;
        }));
    }

    protected processVessels_GetVessel(response: HttpResponseBase): Observable<VesselDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VesselDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_UpdateVessel(id: number, command: UpdateVesselCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Vessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_UpdateVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_UpdateVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVessels_UpdateVessel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_DeleteVessel(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Vessels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_DeleteVessel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_DeleteVessel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVessels_DeleteVessel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_GetVesselSelectOptions(): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Vessels/GetVesselSelectOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVesselSelectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVesselSelectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processVessels_GetVesselSelectOptions(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_GetVesselVm(id: number): Observable<VesselVm> {
        let url_ = this.baseUrl + "/api/Vessels/GetVesselVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVesselVm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVesselVm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VesselVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VesselVm>;
        }));
    }

    protected processVessels_GetVesselVm(response: HttpResponseBase): Observable<VesselVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VesselVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_GetVesselExists(id: number, name: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Vessels/GetVesselExists/{id}/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVesselExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVesselExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVessels_GetVesselExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    vessels_GetVesselByName(name: string): Observable<VesselDto> {
        let url_ = this.baseUrl + "/api/Vessels/GetVesselByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVessels_GetVesselByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVessels_GetVesselByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VesselDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VesselDto>;
        }));
    }

    protected processVessels_GetVesselByName(response: HttpResponseBase): Observable<VesselDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VesselDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesByContractIdClient {
    voyagesByContractId_Get(id: number): Observable<VoyagesDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesByContractIdClient implements IVoyagesByContractIdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyagesByContractId_Get(id: number): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/VoyagesByContractId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyagesByContractId_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyagesByContractId_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processVoyagesByContractId_Get(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesByFilterClient {
    voyagesByFilter_Get(filter: string, isActive: boolean): Observable<VoyagesDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesByFilterClient implements IVoyagesByFilterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyagesByFilter_Get(filter: string, isActive: boolean): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/VoyagesByFilter/{filter}/{isActive}";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined.");
        url_ = url_.replace("{filter}", encodeURIComponent("" + filter));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyagesByFilter_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyagesByFilter_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processVoyagesByFilter_Get(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesByOnwerClient {
    voyagesByOnwer_Get(owner: string): Observable<VoyagesDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesByOnwerClient implements IVoyagesByOnwerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyagesByOnwer_Get(owner: string): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/VoyagesByOnwer/{owner}";
        if (owner === undefined || owner === null)
            throw new Error("The parameter 'owner' must be defined.");
        url_ = url_.replace("{owner}", encodeURIComponent("" + owner));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyagesByOnwer_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyagesByOnwer_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processVoyagesByOnwer_Get(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesClient {
    voyages_GetAll(): Observable<VoyagesDto[]>;
    voyages_Create(commad: CreateVoyageCommand): Observable<number>;
    voyages_Get(id: number): Observable<VoyageVm>;
    voyages_Update(id: number, command: UpdateVoyageCommand): Observable<void>;
    voyages_Delete(id: number): Observable<void>;
    voyages_GetVoyagesByStatus(status: string): Observable<VoyagesDto[]>;
    voyages_GetMoveNumbersByOwner(refNo: number): Observable<SelectDto[]>;
    voyages_GetRefNumbersByOwnerChartererStatus(query: GetRefNumbersByOwnerChartererStatusQuery): Observable<SelectDto[]>;
    voyages_GetVoyageFileDirectory(command: GetVoyageFileDirectoryQuery): Observable<FileDto[]>;
    voyages_DownloadVoyageFile(command: DownloadVoyageFileQuery): Observable<FileResponse>;
    voyages_ActivateVoyage(id: number, command: ActivateVoyageCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesClient implements IVoyagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyages_GetAll(): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/Voyages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_GetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_GetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processVoyages_GetAll(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_Create(commad: CreateVoyageCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Voyages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_Create(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_Create(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processVoyages_Create(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_Get(id: number): Observable<VoyageVm> {
        let url_ = this.baseUrl + "/api/Voyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyageVm>;
        }));
    }

    protected processVoyages_Get(response: HttpResponseBase): Observable<VoyageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoyageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_Update(id: number, command: UpdateVoyageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Voyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_Update(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVoyages_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_Delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Voyages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVoyages_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_GetVoyagesByStatus(status: string): Observable<VoyagesDto[]> {
        let url_ = this.baseUrl + "/api/Voyages/GetVoyagesByStatus/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_GetVoyagesByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_GetVoyagesByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyagesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyagesDto[]>;
        }));
    }

    protected processVoyages_GetVoyagesByStatus(response: HttpResponseBase): Observable<VoyagesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoyagesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_GetMoveNumbersByOwner(refNo: number): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Voyages/GetMoveNumbersByOwner/{refNo}";
        if (refNo === undefined || refNo === null)
            throw new Error("The parameter 'refNo' must be defined.");
        url_ = url_.replace("{refNo}", encodeURIComponent("" + refNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_GetMoveNumbersByOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_GetMoveNumbersByOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processVoyages_GetMoveNumbersByOwner(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_GetRefNumbersByOwnerChartererStatus(query: GetRefNumbersByOwnerChartererStatusQuery): Observable<SelectDto[]> {
        let url_ = this.baseUrl + "/api/Voyages/GetRefNumbersByOwnerChartererStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_GetRefNumbersByOwnerChartererStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_GetRefNumbersByOwnerChartererStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectDto[]>;
        }));
    }

    protected processVoyages_GetRefNumbersByOwnerChartererStatus(response: HttpResponseBase): Observable<SelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_GetVoyageFileDirectory(command: GetVoyageFileDirectoryQuery): Observable<FileDto[]> {
        let url_ = this.baseUrl + "/api/Voyages/GetVoyageFileDirectory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_GetVoyageFileDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_GetVoyageFileDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto[]>;
        }));
    }

    protected processVoyages_GetVoyageFileDirectory(response: HttpResponseBase): Observable<FileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_DownloadVoyageFile(command: DownloadVoyageFileQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Voyages/DownloadVoyageFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_DownloadVoyageFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_DownloadVoyageFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processVoyages_DownloadVoyageFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voyages_ActivateVoyage(id: number, command: ActivateVoyageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Voyages/ActivateVoyage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyages_ActivateVoyage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyages_ActivateVoyage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVoyages_ActivateVoyage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesPagedClient {
    voyagesPaged_GetTodoItemsWithPagination(pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfVoyagesDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesPagedClient implements IVoyagesPagedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyagesPaged_GetTodoItemsWithPagination(pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfVoyagesDto> {
        let url_ = this.baseUrl + "/api/VoyagesPaged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyagesPaged_GetTodoItemsWithPagination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyagesPaged_GetTodoItemsWithPagination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfVoyagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfVoyagesDto>;
        }));
    }

    protected processVoyagesPaged_GetTodoItemsWithPagination(response: HttpResponseBase): Observable<PaginatedListOfVoyagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfVoyagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoyagesVmClient {
    voyagesVm_Get(id: number): Observable<VoyageVm>;
}

@Injectable({
    providedIn: 'root'
})
export class VoyagesVmClient implements IVoyagesVmClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    voyagesVm_Get(id: number): Observable<VoyageVm> {
        let url_ = this.baseUrl + "/api/VoyagesVm/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoyagesVm_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoyagesVm_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoyageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoyageVm>;
        }));
    }

    protected processVoyagesVm_Get(response: HttpResponseBase): Observable<VoyageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoyageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddressTypesDto implements IAddressTypesDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    isActive?: boolean;

    constructor(data?: IAddressTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AddressTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAddressTypesDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    isActive?: boolean;
}

export class AddressTypeDto implements IAddressTypeDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IAddressTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): AddressTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IAddressTypeDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class SelectDto implements ISelectDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ISelectDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
}

export class CreateAddressTypeCommand implements ICreateAddressTypeCommand {
    name?: string;
    displayOption?: boolean;

    constructor(data?: ICreateAddressTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
        }
    }

    static fromJS(data: any): CreateAddressTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        return data;
    }
}

export interface ICreateAddressTypeCommand {
    name?: string;
    displayOption?: boolean;
}

export class UpdateAddressTypeCommand implements IUpdateAddressTypeCommand {
    id?: number;
    name?: string;
    displayOption?: boolean;

    constructor(data?: IUpdateAddressTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
        }
    }

    static fromJS(data: any): UpdateAddressTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        return data;
    }
}

export interface IUpdateAddressTypeCommand {
    id?: number;
    name?: string;
    displayOption?: boolean;
}

export class AskQuestionResult implements IAskQuestionResult {
    executiveSummary?: string;
    sql?: string | undefined;
    columns?: string[];
    rows?: (any | undefined)[][];
    truncated?: boolean;
    businessExplanation?: string;
    confidence?: number;
    performance?: AskQuestionPerformance;
    succeeded?: boolean;
    error?: string | undefined;

    constructor(data?: IAskQuestionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executiveSummary = _data["executiveSummary"];
            this.sql = _data["sql"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.truncated = _data["truncated"];
            this.businessExplanation = _data["businessExplanation"];
            this.confidence = _data["confidence"];
            this.performance = _data["performance"] ? AskQuestionPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.succeeded = _data["succeeded"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): AskQuestionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executiveSummary"] = this.executiveSummary;
        data["sql"] = this.sql;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["truncated"] = this.truncated;
        data["businessExplanation"] = this.businessExplanation;
        data["confidence"] = this.confidence;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["succeeded"] = this.succeeded;
        data["error"] = this.error;
        return data;
    }
}

export interface IAskQuestionResult {
    executiveSummary?: string;
    sql?: string | undefined;
    columns?: string[];
    rows?: (any | undefined)[][];
    truncated?: boolean;
    businessExplanation?: string;
    confidence?: number;
    performance?: AskQuestionPerformance;
    succeeded?: boolean;
    error?: string | undefined;
}

export class AskQuestionPerformance implements IAskQuestionPerformance {
    totalMs?: number;
    generationMs?: number;
    executionMs?: number;
    rowsReturned?: number;
    inputTokens?: number;
    outputTokens?: number;
    provider?: string;
    model?: string;

    constructor(data?: IAskQuestionPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMs = _data["totalMs"];
            this.generationMs = _data["generationMs"];
            this.executionMs = _data["executionMs"];
            this.rowsReturned = _data["rowsReturned"];
            this.inputTokens = _data["inputTokens"];
            this.outputTokens = _data["outputTokens"];
            this.provider = _data["provider"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AskQuestionPerformance {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionPerformance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMs"] = this.totalMs;
        data["generationMs"] = this.generationMs;
        data["executionMs"] = this.executionMs;
        data["rowsReturned"] = this.rowsReturned;
        data["inputTokens"] = this.inputTokens;
        data["outputTokens"] = this.outputTokens;
        data["provider"] = this.provider;
        data["model"] = this.model;
        return data;
    }
}

export interface IAskQuestionPerformance {
    totalMs?: number;
    generationMs?: number;
    executionMs?: number;
    rowsReturned?: number;
    inputTokens?: number;
    outputTokens?: number;
    provider?: string;
    model?: string;
}

export class AskQuestionQuery implements IAskQuestionQuery {
    question?: string;
    history?: AskQuestionTurn[] | undefined;

    constructor(data?: IAskQuestionQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(AskQuestionTurn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AskQuestionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAskQuestionQuery {
    question?: string;
    history?: AskQuestionTurn[] | undefined;
}

export class AskQuestionTurn implements IAskQuestionTurn {
    role?: string;
    content?: string;

    constructor(data?: IAskQuestionTurn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AskQuestionTurn {
        data = typeof data === 'object' ? data : {};
        let result = new AskQuestionTurn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        return data;
    }
}

export interface IAskQuestionTurn {
    role?: string;
    content?: string;
}

export class BargePreparationsDto implements IBargePreparationsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBargePreparationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BargePreparationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BargePreparationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBargePreparationsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class BargePreparationDto implements IBargePreparationDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IBargePreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): BargePreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BargePreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IBargePreparationDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateBargePreparationCommand implements ICreateBargePreparationCommand {
    name?: string;
    description?: string;

    constructor(data?: ICreateBargePreparationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateBargePreparationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBargePreparationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateBargePreparationCommand {
    name?: string;
    description?: string;
}

export class UpdateBargePreparationCommand implements IUpdateBargePreparationCommand {
    id?: number;
    name?: string;
    description?: string;
    isActive?: boolean;

    constructor(data?: IUpdateBargePreparationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateBargePreparationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBargePreparationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateBargePreparationCommand {
    id?: number;
    name?: string;
    description?: string;
    isActive?: boolean;
}

export class BargesDto implements IBargesDto {
    id?: number;
    owner?: number;
    ownerId?: string | undefined;
    bargeName?: string | undefined;
    cargoCalibration?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    lining?: string | undefined;
    group?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBargesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.bargeName = _data["bargeName"];
            this.cargoCalibration = _data["cargoCalibration"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.lining = _data["lining"];
            this.group = _data["group"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BargesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BargesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["bargeName"] = this.bargeName;
        data["cargoCalibration"] = this.cargoCalibration;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["lining"] = this.lining;
        data["group"] = this.group;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBargesDto {
    id?: number;
    owner?: number;
    ownerId?: string | undefined;
    bargeName?: string | undefined;
    cargoCalibration?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    lining?: string | undefined;
    group?: string | undefined;
    isActive?: boolean;
}

export class BargeDto implements IBargeDto {
    id?: number;
    owner?: number;
    bargeName?: string | undefined;
    ownerId?: string | undefined;
    cargoCalibration?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    lining?: string | undefined;
    comments?: string | undefined;
    vapor?: boolean;
    operatorId?: string | undefined;
    equipType?: string | undefined;
    loa?: number;
    loaType?: string | undefined;
    beam?: number;
    beamType?: string | undefined;
    service?: string | undefined;
    built?: string | undefined;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string | undefined;
    cargoTankType?: string | undefined;
    covers?: string | undefined;
    group?: string | undefined;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IBargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.bargeName = _data["bargeName"];
            this.ownerId = _data["ownerId"];
            this.cargoCalibration = _data["cargoCalibration"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.lining = _data["lining"];
            this.comments = _data["comments"];
            this.vapor = _data["vapor"];
            this.operatorId = _data["operatorId"];
            this.equipType = _data["equipType"];
            this.loa = _data["loa"];
            this.loaType = _data["loaType"];
            this.beam = _data["beam"];
            this.beamType = _data["beamType"];
            this.service = _data["service"];
            this.built = _data["built"];
            this.inland = _data["inland"];
            this.offshore = _data["offshore"];
            this.hullType = _data["hullType"];
            this.cargoTankType = _data["cargoTankType"];
            this.covers = _data["covers"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
            this.forSale = _data["forSale"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): BargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["bargeName"] = this.bargeName;
        data["ownerId"] = this.ownerId;
        data["cargoCalibration"] = this.cargoCalibration;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["lining"] = this.lining;
        data["comments"] = this.comments;
        data["vapor"] = this.vapor;
        data["operatorId"] = this.operatorId;
        data["equipType"] = this.equipType;
        data["loa"] = this.loa;
        data["loaType"] = this.loaType;
        data["beam"] = this.beam;
        data["beamType"] = this.beamType;
        data["service"] = this.service;
        data["built"] = this.built;
        data["inland"] = this.inland;
        data["offshore"] = this.offshore;
        data["hullType"] = this.hullType;
        data["cargoTankType"] = this.cargoTankType;
        data["covers"] = this.covers;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        data["forSale"] = this.forSale;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IBargeDto {
    id?: number;
    owner?: number;
    bargeName?: string | undefined;
    ownerId?: string | undefined;
    cargoCalibration?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    lining?: string | undefined;
    comments?: string | undefined;
    vapor?: boolean;
    operatorId?: string | undefined;
    equipType?: string | undefined;
    loa?: number;
    loaType?: string | undefined;
    beam?: number;
    beamType?: string | undefined;
    service?: string | undefined;
    built?: string | undefined;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string | undefined;
    cargoTankType?: string | undefined;
    covers?: string | undefined;
    group?: string | undefined;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class BargeVm implements IBargeVm {
    barge?: BargeDto | undefined;
    units?: SelectDto[] | undefined;
    companies?: SelectDto[] | undefined;

    constructor(data?: IBargeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barge = _data["barge"] ? BargeDto.fromJS(_data["barge"]) : <any>undefined;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BargeVm {
        data = typeof data === 'object' ? data : {};
        let result = new BargeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barge"] = this.barge ? this.barge.toJSON() : <any>undefined;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBargeVm {
    barge?: BargeDto | undefined;
    units?: SelectDto[] | undefined;
    companies?: SelectDto[] | undefined;
}

export class CreateBargeCommand implements ICreateBargeCommand {
    owner?: number;
    bargeName?: string;
    cargoCalibration?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    lining?: string;
    comments?: string;
    vapor?: boolean;
    operatorId?: string;
    equipType?: string;
    loa?: number;
    loaType?: string;
    beam?: number;
    beamType?: string;
    service?: string;
    built?: string;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string;
    cargoTankType?: string;
    covers?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;

    constructor(data?: ICreateBargeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.owner = _data["owner"];
            this.bargeName = _data["bargeName"];
            this.cargoCalibration = _data["cargoCalibration"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.lining = _data["lining"];
            this.comments = _data["comments"];
            this.vapor = _data["vapor"];
            this.operatorId = _data["operatorId"];
            this.equipType = _data["equipType"];
            this.loa = _data["loa"];
            this.loaType = _data["loaType"];
            this.beam = _data["beam"];
            this.beamType = _data["beamType"];
            this.service = _data["service"];
            this.built = _data["built"];
            this.inland = _data["inland"];
            this.offshore = _data["offshore"];
            this.hullType = _data["hullType"];
            this.cargoTankType = _data["cargoTankType"];
            this.covers = _data["covers"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
            this.forSale = _data["forSale"];
        }
    }

    static fromJS(data: any): CreateBargeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBargeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner;
        data["bargeName"] = this.bargeName;
        data["cargoCalibration"] = this.cargoCalibration;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["lining"] = this.lining;
        data["comments"] = this.comments;
        data["vapor"] = this.vapor;
        data["operatorId"] = this.operatorId;
        data["equipType"] = this.equipType;
        data["loa"] = this.loa;
        data["loaType"] = this.loaType;
        data["beam"] = this.beam;
        data["beamType"] = this.beamType;
        data["service"] = this.service;
        data["built"] = this.built;
        data["inland"] = this.inland;
        data["offshore"] = this.offshore;
        data["hullType"] = this.hullType;
        data["cargoTankType"] = this.cargoTankType;
        data["covers"] = this.covers;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        data["forSale"] = this.forSale;
        return data;
    }
}

export interface ICreateBargeCommand {
    owner?: number;
    bargeName?: string;
    cargoCalibration?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    lining?: string;
    comments?: string;
    vapor?: boolean;
    operatorId?: string;
    equipType?: string;
    loa?: number;
    loaType?: string;
    beam?: number;
    beamType?: string;
    service?: string;
    built?: string;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string;
    cargoTankType?: string;
    covers?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;
}

export class UpdateBargeCommand implements IUpdateBargeCommand {
    id?: number;
    owner?: number;
    bargeName?: string;
    cargoCalibration?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    lining?: string;
    comments?: string;
    vapor?: boolean;
    operatorId?: string;
    equipType?: string;
    loa?: number;
    loaType?: string;
    beam?: number;
    beamType?: string;
    service?: string;
    built?: string;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string;
    cargoTankType?: string;
    covers?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;

    constructor(data?: IUpdateBargeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.bargeName = _data["bargeName"];
            this.cargoCalibration = _data["cargoCalibration"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.lining = _data["lining"];
            this.comments = _data["comments"];
            this.vapor = _data["vapor"];
            this.operatorId = _data["operatorId"];
            this.equipType = _data["equipType"];
            this.loa = _data["loa"];
            this.loaType = _data["loaType"];
            this.beam = _data["beam"];
            this.beamType = _data["beamType"];
            this.service = _data["service"];
            this.built = _data["built"];
            this.inland = _data["inland"];
            this.offshore = _data["offshore"];
            this.hullType = _data["hullType"];
            this.cargoTankType = _data["cargoTankType"];
            this.covers = _data["covers"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
            this.forSale = _data["forSale"];
        }
    }

    static fromJS(data: any): UpdateBargeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBargeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["bargeName"] = this.bargeName;
        data["cargoCalibration"] = this.cargoCalibration;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["lining"] = this.lining;
        data["comments"] = this.comments;
        data["vapor"] = this.vapor;
        data["operatorId"] = this.operatorId;
        data["equipType"] = this.equipType;
        data["loa"] = this.loa;
        data["loaType"] = this.loaType;
        data["beam"] = this.beam;
        data["beamType"] = this.beamType;
        data["service"] = this.service;
        data["built"] = this.built;
        data["inland"] = this.inland;
        data["offshore"] = this.offshore;
        data["hullType"] = this.hullType;
        data["cargoTankType"] = this.cargoTankType;
        data["covers"] = this.covers;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        data["forSale"] = this.forSale;
        return data;
    }
}

export interface IUpdateBargeCommand {
    id?: number;
    owner?: number;
    bargeName?: string;
    cargoCalibration?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    lining?: string;
    comments?: string;
    vapor?: boolean;
    operatorId?: string;
    equipType?: string;
    loa?: number;
    loaType?: string;
    beam?: number;
    beamType?: string;
    service?: string;
    built?: string;
    inland?: boolean;
    offshore?: boolean;
    hullType?: string;
    cargoTankType?: string;
    covers?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    forSale?: boolean;
}

export class BatchContractVm implements IBatchContractVm {
    batchContract?: BatchContractDto | undefined;
    batchVoyage?: BatchVoyageDto | undefined;
    specialProvisions?: BatchSpecialProvisionDto[];
    charterers?: SelectDto[];
    chartererContacts?: SelectDto[];
    owners?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];

    constructor(data?: IBatchContractVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchContract = _data["batchContract"] ? BatchContractDto.fromJS(_data["batchContract"]) : <any>undefined;
            this.batchVoyage = _data["batchVoyage"] ? BatchVoyageDto.fromJS(_data["batchVoyage"]) : <any>undefined;
            if (Array.isArray(_data["specialProvisions"])) {
                this.specialProvisions = [] as any;
                for (let item of _data["specialProvisions"])
                    this.specialProvisions!.push(BatchSpecialProvisionDto.fromJS(item));
            }
            if (Array.isArray(_data["charterers"])) {
                this.charterers = [] as any;
                for (let item of _data["charterers"])
                    this.charterers!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["chartererContacts"])) {
                this.chartererContacts = [] as any;
                for (let item of _data["chartererContacts"])
                    this.chartererContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ownerContacts"])) {
                this.ownerContacts = [] as any;
                for (let item of _data["ownerContacts"])
                    this.ownerContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["cpForms"])) {
                this.cpForms = [] as any;
                for (let item of _data["cpForms"])
                    this.cpForms!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchContractVm {
        data = typeof data === 'object' ? data : {};
        let result = new BatchContractVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchContract"] = this.batchContract ? this.batchContract.toJSON() : <any>undefined;
        data["batchVoyage"] = this.batchVoyage ? this.batchVoyage.toJSON() : <any>undefined;
        if (Array.isArray(this.specialProvisions)) {
            data["specialProvisions"] = [];
            for (let item of this.specialProvisions)
                data["specialProvisions"].push(item.toJSON());
        }
        if (Array.isArray(this.charterers)) {
            data["charterers"] = [];
            for (let item of this.charterers)
                data["charterers"].push(item.toJSON());
        }
        if (Array.isArray(this.chartererContacts)) {
            data["chartererContacts"] = [];
            for (let item of this.chartererContacts)
                data["chartererContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerContacts)) {
            data["ownerContacts"] = [];
            for (let item of this.ownerContacts)
                data["ownerContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.cpForms)) {
            data["cpForms"] = [];
            for (let item of this.cpForms)
                data["cpForms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchContractVm {
    batchContract?: BatchContractDto | undefined;
    batchVoyage?: BatchVoyageDto | undefined;
    specialProvisions?: BatchSpecialProvisionDto[];
    charterers?: SelectDto[];
    chartererContacts?: SelectDto[];
    owners?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];
}

export class BatchContractDto implements IBatchContractDto {
    id?: number;
    companyId?: number;
    refNo?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    cpForm?: string | undefined;
    rateType?: string | undefined;
    noVoys?: number;

    constructor(data?: IBatchContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.refNo = _data["refNo"];
            this.charterer = _data["charterer"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.remarks = _data["remarks"];
            this.userEntered = _data["userEntered"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.dischAccount = _data["dischAccount"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.commPct = _data["commPct"];
            this.rate = _data["rate"];
            this.cpForm = _data["cpForm"];
            this.rateType = _data["rateType"];
            this.noVoys = _data["noVoys"];
        }
    }

    static fromJS(data: any): BatchContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["refNo"] = this.refNo;
        data["charterer"] = this.charterer;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["remarks"] = this.remarks;
        data["userEntered"] = this.userEntered;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["dischAccount"] = this.dischAccount;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["commPct"] = this.commPct;
        data["rate"] = this.rate;
        data["cpForm"] = this.cpForm;
        data["rateType"] = this.rateType;
        data["noVoys"] = this.noVoys;
        return data;
    }
}

export interface IBatchContractDto {
    id?: number;
    companyId?: number;
    refNo?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    cpForm?: string | undefined;
    rateType?: string | undefined;
    noVoys?: number;
}

export class BatchVoyageDto implements IBatchVoyageDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invRecvd?: boolean;
    invoiceNotes?: string | undefined;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    contractCpDate?: Date;
    contractBroker?: string | undefined;
    contractType?: string | undefined;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];

    constructor(data?: IBatchVoyageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.contractId = _data["contractId"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invRecvd = _data["invRecvd"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
            this.contractCpDate = _data["contractCpDate"] ? new Date(_data["contractCpDate"].toString()) : <any>undefined;
            this.contractBroker = _data["contractBroker"];
            this.contractType = _data["contractType"];
            this.contractOwner = _data["contractOwner"];
            this.contractCharterer = _data["contractCharterer"];
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(BatchEquipmentDto.fromJS(item));
            }
            if (Array.isArray(_data["moveCargos"])) {
                this.moveCargos = [] as any;
                for (let item of _data["moveCargos"])
                    this.moveCargos!.push(BatchCargoDto.fromJS(item));
            }
            if (Array.isArray(_data["moveDischargePorts"])) {
                this.moveDischargePorts = [] as any;
                for (let item of _data["moveDischargePorts"])
                    this.moveDischargePorts!.push(BatchDischargePortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveLdPorts"])) {
                this.moveLdPorts = [] as any;
                for (let item of _data["moveLdPorts"])
                    this.moveLdPorts!.push(BatchLoadPortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveOpsTraffics"])) {
                this.moveOpsTraffics = [] as any;
                for (let item of _data["moveOpsTraffics"])
                    this.moveOpsTraffics!.push(BatchTrafficDto.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(BatchVesselDto.fromJS(item));
            }
            if (Array.isArray(_data["moveSpecialProvisions"])) {
                this.moveSpecialProvisions = [] as any;
                for (let item of _data["moveSpecialProvisions"])
                    this.moveSpecialProvisions!.push(BatchMoveSpecialProvisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchVoyageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchVoyageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["contractId"] = this.contractId;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invRecvd"] = this.invRecvd;
        data["invoiceNotes"] = this.invoiceNotes;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        data["contractCpDate"] = this.contractCpDate ? this.contractCpDate.toISOString() : <any>undefined;
        data["contractBroker"] = this.contractBroker;
        data["contractType"] = this.contractType;
        data["contractOwner"] = this.contractOwner;
        data["contractCharterer"] = this.contractCharterer;
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.moveCargos)) {
            data["moveCargos"] = [];
            for (let item of this.moveCargos)
                data["moveCargos"].push(item.toJSON());
        }
        if (Array.isArray(this.moveDischargePorts)) {
            data["moveDischargePorts"] = [];
            for (let item of this.moveDischargePorts)
                data["moveDischargePorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveLdPorts)) {
            data["moveLdPorts"] = [];
            for (let item of this.moveLdPorts)
                data["moveLdPorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveOpsTraffics)) {
            data["moveOpsTraffics"] = [];
            for (let item of this.moveOpsTraffics)
                data["moveOpsTraffics"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveSpecialProvisions)) {
            data["moveSpecialProvisions"] = [];
            for (let item of this.moveSpecialProvisions)
                data["moveSpecialProvisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchVoyageDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invRecvd?: boolean;
    invoiceNotes?: string | undefined;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    contractCpDate?: Date;
    contractBroker?: string | undefined;
    contractType?: string | undefined;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];
}

export class BatchEquipmentDto implements IBatchEquipmentDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vapor?: boolean;
    isActive?: boolean;

    constructor(data?: IBatchEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vapor = _data["vapor"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vapor"] = this.vapor;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchEquipmentDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vapor?: boolean;
    isActive?: boolean;
}

export class BatchCargoDto implements IBatchCargoDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string | undefined;
    cargo?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBatchCargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.item = _data["item"];
            this.quanity = _data["quanity"];
            this.unit = _data["unit"];
            this.cargo = _data["cargo"];
            this.rvp = _data["rvp"];
            this.api = _data["api"];
            this.pour = _data["pour"];
            this.visc = _data["visc"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchCargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["item"] = this.item;
        data["quanity"] = this.quanity;
        data["unit"] = this.unit;
        data["cargo"] = this.cargo;
        data["rvp"] = this.rvp;
        data["api"] = this.api;
        data["pour"] = this.pour;
        data["visc"] = this.visc;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchCargoDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string | undefined;
    cargo?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    isActive?: boolean;
}

export class BatchDischargePortDto implements IBatchDischargePortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;
    isActive?: boolean;

    constructor(data?: IBatchDischargePortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.notePrint = _data["notePrint"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchDischargePortDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDischargePortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["notePrint"] = this.notePrint;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchDischargePortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;
    isActive?: boolean;
}

export class BatchLoadPortDto implements IBatchLoadPortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    loadNotePrint?: boolean;
    isActive?: boolean;

    constructor(data?: IBatchLoadPortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.ligheringVsl = _data["ligheringVsl"];
            this.loadNote = _data["loadNote"];
            this.loadNotePrint = _data["loadNotePrint"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchLoadPortDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadPortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["ligheringVsl"] = this.ligheringVsl;
        data["loadNote"] = this.loadNote;
        data["loadNotePrint"] = this.loadNotePrint;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchLoadPortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    loadNotePrint?: boolean;
    isActive?: boolean;
}

export class BatchTrafficDto implements IBatchTrafficDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    msgSelector?: boolean;
    isActive?: boolean;

    constructor(data?: IBatchTrafficDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.moveTrafficNo = _data["moveTrafficNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.msgSelector = _data["msgSelector"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchTrafficDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchTrafficDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["moveTrafficNo"] = this.moveTrafficNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["msgSelector"] = this.msgSelector;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchTrafficDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    msgSelector?: boolean;
    isActive?: boolean;
}

export class BatchVesselDto implements IBatchVesselDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    isActive?: boolean;

    constructor(data?: IBatchVesselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchVesselDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchVesselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchVesselDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    isActive?: boolean;
}

export class BatchMoveSpecialProvisionDto implements IBatchMoveSpecialProvisionDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBatchMoveSpecialProvisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchMoveSpecialProvisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchMoveSpecialProvisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchMoveSpecialProvisionDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class BatchSpecialProvisionDto implements IBatchSpecialProvisionDto {
    id?: number;
    sProvNo?: number;
    refNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBatchSpecialProvisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sProvNo = _data["sProvNo"];
            this.refNo = _data["refNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BatchSpecialProvisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSpecialProvisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sProvNo"] = this.sProvNo;
        data["refNo"] = this.refNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBatchSpecialProvisionDto {
    id?: number;
    sProvNo?: number;
    refNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;
}

export class BatchCreateContractCommand implements IBatchCreateContractCommand {
    contractDto?: BatchContractDto | undefined;
    voyageDto?: BatchVoyageDto | undefined;
    specialProvisions?: BatchSpecialProvisionDto[] | undefined;

    constructor(data?: IBatchCreateContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractDto = _data["contractDto"] ? BatchContractDto.fromJS(_data["contractDto"]) : <any>undefined;
            this.voyageDto = _data["voyageDto"] ? BatchVoyageDto.fromJS(_data["voyageDto"]) : <any>undefined;
            if (Array.isArray(_data["specialProvisions"])) {
                this.specialProvisions = [] as any;
                for (let item of _data["specialProvisions"])
                    this.specialProvisions!.push(BatchSpecialProvisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchCreateContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCreateContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractDto"] = this.contractDto ? this.contractDto.toJSON() : <any>undefined;
        data["voyageDto"] = this.voyageDto ? this.voyageDto.toJSON() : <any>undefined;
        if (Array.isArray(this.specialProvisions)) {
            data["specialProvisions"] = [];
            for (let item of this.specialProvisions)
                data["specialProvisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchCreateContractCommand {
    contractDto?: BatchContractDto | undefined;
    voyageDto?: BatchVoyageDto | undefined;
    specialProvisions?: BatchSpecialProvisionDto[] | undefined;
}

export class BatchEmployeeVm implements IBatchEmployeeVm {
    batchEmployee?: BatchEmployeeDto | undefined;
    batchPhones?: BatchPhoneDto[];
    companies?: SelectDto[];
    countries?: SelectDto[];
    states?: SelectDto[];

    constructor(data?: IBatchEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchEmployee = _data["batchEmployee"] ? BatchEmployeeDto.fromJS(_data["batchEmployee"]) : <any>undefined;
            if (Array.isArray(_data["batchPhones"])) {
                this.batchPhones = [] as any;
                for (let item of _data["batchPhones"])
                    this.batchPhones!.push(BatchPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchEmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new BatchEmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchEmployee"] = this.batchEmployee ? this.batchEmployee.toJSON() : <any>undefined;
        if (Array.isArray(this.batchPhones)) {
            data["batchPhones"] = [];
            for (let item of this.batchPhones)
                data["batchPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchEmployeeVm {
    batchEmployee?: BatchEmployeeDto | undefined;
    batchPhones?: BatchPhoneDto[];
    companies?: SelectDto[];
    countries?: SelectDto[];
    states?: SelectDto[];
}

export class BatchEmployeeDto implements IBatchEmployeeDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    updated?: Date;
    displayPhone?: string | undefined;
    dateOfBirth?: Date | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    christmasCard?: boolean;
    eMailHome?: string | undefined;
    imHome?: string | undefined;
    eMailOffice?: string | undefined;
    imOffice?: string | undefined;
    jobTitle?: string | undefined;
    comment?: string | undefined;
    salutation?: string | undefined;

    constructor(data?: IBatchEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.displayPhone = _data["displayPhone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.christmasCard = _data["christmasCard"];
            this.eMailHome = _data["eMailHome"];
            this.imHome = _data["imHome"];
            this.eMailOffice = _data["eMailOffice"];
            this.imOffice = _data["imOffice"];
            this.jobTitle = _data["jobTitle"];
            this.comment = _data["comment"];
            this.salutation = _data["salutation"];
        }
    }

    static fromJS(data: any): BatchEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["displayPhone"] = this.displayPhone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["christmasCard"] = this.christmasCard;
        data["eMailHome"] = this.eMailHome;
        data["imHome"] = this.imHome;
        data["eMailOffice"] = this.eMailOffice;
        data["imOffice"] = this.imOffice;
        data["jobTitle"] = this.jobTitle;
        data["comment"] = this.comment;
        data["salutation"] = this.salutation;
        return data;
    }
}

export interface IBatchEmployeeDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    updated?: Date;
    displayPhone?: string | undefined;
    dateOfBirth?: Date | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    christmasCard?: boolean;
    eMailHome?: string | undefined;
    imHome?: string | undefined;
    eMailOffice?: string | undefined;
    imOffice?: string | undefined;
    jobTitle?: string | undefined;
    comment?: string | undefined;
    salutation?: string | undefined;
}

export class BatchPhoneDto implements IBatchPhoneDto {
    id?: number;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;

    constructor(data?: IBatchPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
        }
    }

    static fromJS(data: any): BatchPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        return data;
    }
}

export interface IBatchPhoneDto {
    id?: number;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;
}

export class BatchCreateEmployeeCommand implements IBatchCreateEmployeeCommand {
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;
    phones?: BatchPhoneDto[];

    constructor(data?: IBatchCreateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.displayPhone = _data["displayPhone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.christmasCard = _data["christmasCard"];
            this.eMailHome = _data["eMailHome"];
            this.imHome = _data["imHome"];
            this.eMailOffice = _data["eMailOffice"];
            this.imOffice = _data["imOffice"];
            this.jobTitle = _data["jobTitle"];
            this.comment = _data["comment"];
            this.salutation = _data["salutation"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(BatchPhoneDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchCreateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCreateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["displayPhone"] = this.displayPhone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["christmasCard"] = this.christmasCard;
        data["eMailHome"] = this.eMailHome;
        data["imHome"] = this.imHome;
        data["eMailOffice"] = this.eMailOffice;
        data["imOffice"] = this.imOffice;
        data["jobTitle"] = this.jobTitle;
        data["comment"] = this.comment;
        data["salutation"] = this.salutation;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchCreateEmployeeCommand {
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;
    phones?: BatchPhoneDto[];
}

export class BatchVoyageVm implements IBatchVoyageVm {
    batchVoyage?: BatchVoyageDto | undefined;
    chartererContacts?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];

    constructor(data?: IBatchVoyageVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchVoyage = _data["batchVoyage"] ? BatchVoyageDto.fromJS(_data["batchVoyage"]) : <any>undefined;
            if (Array.isArray(_data["chartererContacts"])) {
                this.chartererContacts = [] as any;
                for (let item of _data["chartererContacts"])
                    this.chartererContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ownerContacts"])) {
                this.ownerContacts = [] as any;
                for (let item of _data["ownerContacts"])
                    this.ownerContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["cpForms"])) {
                this.cpForms = [] as any;
                for (let item of _data["cpForms"])
                    this.cpForms!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchVoyageVm {
        data = typeof data === 'object' ? data : {};
        let result = new BatchVoyageVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchVoyage"] = this.batchVoyage ? this.batchVoyage.toJSON() : <any>undefined;
        if (Array.isArray(this.chartererContacts)) {
            data["chartererContacts"] = [];
            for (let item of this.chartererContacts)
                data["chartererContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerContacts)) {
            data["ownerContacts"] = [];
            for (let item of this.ownerContacts)
                data["ownerContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.cpForms)) {
            data["cpForms"] = [];
            for (let item of this.cpForms)
                data["cpForms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchVoyageVm {
    batchVoyage?: BatchVoyageDto | undefined;
    chartererContacts?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];
}

export class BatchCreateVoyageCommand implements IBatchCreateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];

    constructor(data?: IBatchCreateVoyageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.contractId = _data["contractId"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(BatchEquipmentDto.fromJS(item));
            }
            if (Array.isArray(_data["moveCargos"])) {
                this.moveCargos = [] as any;
                for (let item of _data["moveCargos"])
                    this.moveCargos!.push(BatchCargoDto.fromJS(item));
            }
            if (Array.isArray(_data["moveDischargePorts"])) {
                this.moveDischargePorts = [] as any;
                for (let item of _data["moveDischargePorts"])
                    this.moveDischargePorts!.push(BatchDischargePortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveLdPorts"])) {
                this.moveLdPorts = [] as any;
                for (let item of _data["moveLdPorts"])
                    this.moveLdPorts!.push(BatchLoadPortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveOpsTraffics"])) {
                this.moveOpsTraffics = [] as any;
                for (let item of _data["moveOpsTraffics"])
                    this.moveOpsTraffics!.push(BatchTrafficDto.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(BatchVesselDto.fromJS(item));
            }
            if (Array.isArray(_data["moveSpecialProvisions"])) {
                this.moveSpecialProvisions = [] as any;
                for (let item of _data["moveSpecialProvisions"])
                    this.moveSpecialProvisions!.push(BatchMoveSpecialProvisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchCreateVoyageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchCreateVoyageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["contractId"] = this.contractId;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.moveCargos)) {
            data["moveCargos"] = [];
            for (let item of this.moveCargos)
                data["moveCargos"].push(item.toJSON());
        }
        if (Array.isArray(this.moveDischargePorts)) {
            data["moveDischargePorts"] = [];
            for (let item of this.moveDischargePorts)
                data["moveDischargePorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveLdPorts)) {
            data["moveLdPorts"] = [];
            for (let item of this.moveLdPorts)
                data["moveLdPorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveOpsTraffics)) {
            data["moveOpsTraffics"] = [];
            for (let item of this.moveOpsTraffics)
                data["moveOpsTraffics"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveSpecialProvisions)) {
            data["moveSpecialProvisions"] = [];
            for (let item of this.moveSpecialProvisions)
                data["moveSpecialProvisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchCreateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];
}

export class CargosDto implements ICargosDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICargosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CargosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CargosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICargosDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class CargoDto implements ICargoDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ICargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): CargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ICargoDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateCargoCommand implements ICreateCargoCommand {
    code?: string;
    description?: string;

    constructor(data?: ICreateCargoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateCargoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCargoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateCargoCommand {
    code?: string;
    description?: string;
}

export class UpdateCargoCommand implements IUpdateCargoCommand {
    id?: number;
    code?: string;
    description?: string;

    constructor(data?: IUpdateCargoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateCargoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCargoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateCargoCommand {
    id?: number;
    code?: string;
    description?: string;
}

export class CompaniesDto implements ICompaniesDto {
    id?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    christmasCard?: boolean;
    phoneBook?: boolean;
    group?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICompaniesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.streetAddress = _data["streetAddress"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.christmasCard = _data["christmasCard"];
            this.phoneBook = _data["phoneBook"];
            this.group = _data["group"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CompaniesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompaniesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["streetAddress"] = this.streetAddress;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["christmasCard"] = this.christmasCard;
        data["phoneBook"] = this.phoneBook;
        data["group"] = this.group;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICompaniesDto {
    id?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    postalCode?: string | undefined;
    christmasCard?: boolean;
    phoneBook?: boolean;
    group?: string | undefined;
    isActive?: boolean;
}

export class CompanyDto implements ICompanyDto {
    id?: number;
    parentId?: number | undefined;
    name?: string | undefined;
    city?: string | undefined;
    companyCode?: string | undefined;
    updated?: Date;
    address1?: string | undefined;
    address2?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    accountingContact?: string | undefined;
    christmasCard?: boolean;
    streetAddress?: string | undefined;
    phoneBook?: boolean;
    remarks?: string | undefined;
    switchBoardPhone?: string | undefined;
    afterHoursPhone?: string | undefined;
    fax?: string | undefined;
    tlx?: string | undefined;
    tlxAnswerBack?: string | undefined;
    webSite?: string | undefined;
    status?: string | undefined;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string | undefined;
    group?: string | undefined;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.companyCode = _data["companyCode"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.accountingContact = _data["accountingContact"];
            this.christmasCard = _data["christmasCard"];
            this.streetAddress = _data["streetAddress"];
            this.phoneBook = _data["phoneBook"];
            this.remarks = _data["remarks"];
            this.switchBoardPhone = _data["switchBoardPhone"];
            this.afterHoursPhone = _data["afterHoursPhone"];
            this.fax = _data["fax"];
            this.tlx = _data["tlx"];
            this.tlxAnswerBack = _data["tlxAnswerBack"];
            this.webSite = _data["webSite"];
            this.status = _data["status"];
            this.billable = _data["billable"];
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.pkTemp = _data["pkTemp"];
            this.contactTemp = _data["contactTemp"];
            this.division = _data["division"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["companyCode"] = this.companyCode;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["accountingContact"] = this.accountingContact;
        data["christmasCard"] = this.christmasCard;
        data["streetAddress"] = this.streetAddress;
        data["phoneBook"] = this.phoneBook;
        data["remarks"] = this.remarks;
        data["switchBoardPhone"] = this.switchBoardPhone;
        data["afterHoursPhone"] = this.afterHoursPhone;
        data["fax"] = this.fax;
        data["tlx"] = this.tlx;
        data["tlxAnswerBack"] = this.tlxAnswerBack;
        data["webSite"] = this.webSite;
        data["status"] = this.status;
        data["billable"] = this.billable;
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["pkTemp"] = this.pkTemp;
        data["contactTemp"] = this.contactTemp;
        data["division"] = this.division;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ICompanyDto {
    id?: number;
    parentId?: number | undefined;
    name?: string | undefined;
    city?: string | undefined;
    companyCode?: string | undefined;
    updated?: Date;
    address1?: string | undefined;
    address2?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    accountingContact?: string | undefined;
    christmasCard?: boolean;
    streetAddress?: string | undefined;
    phoneBook?: boolean;
    remarks?: string | undefined;
    switchBoardPhone?: string | undefined;
    afterHoursPhone?: string | undefined;
    fax?: string | undefined;
    tlx?: string | undefined;
    tlxAnswerBack?: string | undefined;
    webSite?: string | undefined;
    status?: string | undefined;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string | undefined;
    group?: string | undefined;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateCompanyCommand implements ICreateCompanyCommand {
    parentId?: number | undefined;
    name?: string;
    city?: string;
    companyCode?: string;
    updated?: Date;
    address1?: string;
    address2?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    accountingContact?: string;
    christmasCard?: boolean;
    streetAddress?: string;
    phoneBook?: boolean;
    remarks?: string;
    switchBoardPhone?: string;
    afterHoursPhone?: string;
    fax?: string;
    tlx?: string;
    tlxAnswerBack?: string;
    webSite?: string;
    status?: string;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;

    constructor(data?: ICreateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.companyCode = _data["companyCode"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.accountingContact = _data["accountingContact"];
            this.christmasCard = _data["christmasCard"];
            this.streetAddress = _data["streetAddress"];
            this.phoneBook = _data["phoneBook"];
            this.remarks = _data["remarks"];
            this.switchBoardPhone = _data["switchBoardPhone"];
            this.afterHoursPhone = _data["afterHoursPhone"];
            this.fax = _data["fax"];
            this.tlx = _data["tlx"];
            this.tlxAnswerBack = _data["tlxAnswerBack"];
            this.webSite = _data["webSite"];
            this.status = _data["status"];
            this.billable = _data["billable"];
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.pkTemp = _data["pkTemp"];
            this.contactTemp = _data["contactTemp"];
            this.division = _data["division"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
        }
    }

    static fromJS(data: any): CreateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["companyCode"] = this.companyCode;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["accountingContact"] = this.accountingContact;
        data["christmasCard"] = this.christmasCard;
        data["streetAddress"] = this.streetAddress;
        data["phoneBook"] = this.phoneBook;
        data["remarks"] = this.remarks;
        data["switchBoardPhone"] = this.switchBoardPhone;
        data["afterHoursPhone"] = this.afterHoursPhone;
        data["fax"] = this.fax;
        data["tlx"] = this.tlx;
        data["tlxAnswerBack"] = this.tlxAnswerBack;
        data["webSite"] = this.webSite;
        data["status"] = this.status;
        data["billable"] = this.billable;
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["pkTemp"] = this.pkTemp;
        data["contactTemp"] = this.contactTemp;
        data["division"] = this.division;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        return data;
    }
}

export interface ICreateCompanyCommand {
    parentId?: number | undefined;
    name?: string;
    city?: string;
    companyCode?: string;
    updated?: Date;
    address1?: string;
    address2?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    accountingContact?: string;
    christmasCard?: boolean;
    streetAddress?: string;
    phoneBook?: boolean;
    remarks?: string;
    switchBoardPhone?: string;
    afterHoursPhone?: string;
    fax?: string;
    tlx?: string;
    tlxAnswerBack?: string;
    webSite?: string;
    status?: string;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
}

export class UpdateCompanyCommand implements IUpdateCompanyCommand {
    id?: number;
    parentId?: number | undefined;
    name?: string;
    city?: string;
    companyCode?: string;
    updated?: Date;
    address1?: string;
    address2?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    accountingContact?: string;
    christmasCard?: boolean;
    streetAddress?: string;
    phoneBook?: boolean;
    remarks?: string;
    switchBoardPhone?: string;
    afterHoursPhone?: string;
    fax?: string;
    tlx?: string;
    tlxAnswerBack?: string;
    webSite?: string;
    status?: string;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;

    constructor(data?: IUpdateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.companyCode = _data["companyCode"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.accountingContact = _data["accountingContact"];
            this.christmasCard = _data["christmasCard"];
            this.streetAddress = _data["streetAddress"];
            this.phoneBook = _data["phoneBook"];
            this.remarks = _data["remarks"];
            this.switchBoardPhone = _data["switchBoardPhone"];
            this.afterHoursPhone = _data["afterHoursPhone"];
            this.fax = _data["fax"];
            this.tlx = _data["tlx"];
            this.tlxAnswerBack = _data["tlxAnswerBack"];
            this.webSite = _data["webSite"];
            this.status = _data["status"];
            this.billable = _data["billable"];
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.pkTemp = _data["pkTemp"];
            this.contactTemp = _data["contactTemp"];
            this.division = _data["division"];
            this.group = _data["group"];
            this.group1 = _data["group1"];
            this.group2 = _data["group2"];
            this.group3 = _data["group3"];
            this.group4 = _data["group4"];
            this.group5 = _data["group5"];
            this.group6 = _data["group6"];
        }
    }

    static fromJS(data: any): UpdateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["companyCode"] = this.companyCode;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["accountingContact"] = this.accountingContact;
        data["christmasCard"] = this.christmasCard;
        data["streetAddress"] = this.streetAddress;
        data["phoneBook"] = this.phoneBook;
        data["remarks"] = this.remarks;
        data["switchBoardPhone"] = this.switchBoardPhone;
        data["afterHoursPhone"] = this.afterHoursPhone;
        data["fax"] = this.fax;
        data["tlx"] = this.tlx;
        data["tlxAnswerBack"] = this.tlxAnswerBack;
        data["webSite"] = this.webSite;
        data["status"] = this.status;
        data["billable"] = this.billable;
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["pkTemp"] = this.pkTemp;
        data["contactTemp"] = this.contactTemp;
        data["division"] = this.division;
        data["group"] = this.group;
        data["group1"] = this.group1;
        data["group2"] = this.group2;
        data["group3"] = this.group3;
        data["group4"] = this.group4;
        data["group5"] = this.group5;
        data["group6"] = this.group6;
        return data;
    }
}

export interface IUpdateCompanyCommand {
    id?: number;
    parentId?: number | undefined;
    name?: string;
    city?: string;
    companyCode?: string;
    updated?: Date;
    address1?: string;
    address2?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    accountingContact?: string;
    christmasCard?: boolean;
    streetAddress?: string;
    phoneBook?: boolean;
    remarks?: string;
    switchBoardPhone?: string;
    afterHoursPhone?: string;
    fax?: string;
    tlx?: string;
    tlxAnswerBack?: string;
    webSite?: string;
    status?: string;
    billable?: boolean;
    owner?: boolean;
    charterer?: boolean;
    pkTemp?: number;
    contactTemp?: number;
    division?: string;
    group?: string;
    group1?: boolean;
    group2?: boolean;
    group3?: boolean;
    group4?: boolean;
    group5?: boolean;
    group6?: boolean;
}

export class CompanyVm implements ICompanyVm {
    company?: CompanyDto | undefined;
    countries?: SelectDto[];
    states?: SelectDto[];

    constructor(data?: ICompanyVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyVm {
    company?: CompanyDto | undefined;
    countries?: SelectDto[];
    states?: SelectDto[];
}

export class ConstructionsDto implements IConstructionsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IConstructionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ConstructionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IConstructionsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class ConstructionDto implements IConstructionDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IConstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): ConstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IConstructionDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateConstructionCommand implements ICreateConstructionCommand {
    name?: string;

    constructor(data?: ICreateConstructionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateConstructionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateConstructionCommand {
    name?: string;
}

export class UpdateConstructionCommand implements IUpdateConstructionCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateConstructionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateConstructionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateConstructionCommand {
    id?: number;
    name?: string;
}

export class ContractsDto implements IContractsDto {
    id?: number;
    refNo?: number;
    cpDate?: Date | undefined;
    charterer?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    type?: string | undefined;
    isActive?: boolean;
    status?: string | undefined;

    constructor(data?: IContractsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.charterer = _data["charterer"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["charterer"] = this.charterer;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractsDto {
    id?: number;
    refNo?: number;
    cpDate?: Date | undefined;
    charterer?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    type?: string | undefined;
    isActive?: boolean;
    status?: string | undefined;
}

export class ContractDto implements IContractDto {
    id?: number;
    refNo?: number;
    companyId?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    rateType?: string | undefined;
    cpForm?: string | undefined;
    hasDemurrage?: boolean | undefined;
    noVoys?: number;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.companyId = _data["companyId"];
            this.charterer = _data["charterer"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.remarks = _data["remarks"];
            this.userEntered = _data["userEntered"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.dischAccount = _data["dischAccount"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.commPct = _data["commPct"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.cpForm = _data["cpForm"];
            this.hasDemurrage = _data["hasDemurrage"];
            this.noVoys = _data["noVoys"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["companyId"] = this.companyId;
        data["charterer"] = this.charterer;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["remarks"] = this.remarks;
        data["userEntered"] = this.userEntered;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["dischAccount"] = this.dischAccount;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["commPct"] = this.commPct;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["cpForm"] = this.cpForm;
        data["hasDemurrage"] = this.hasDemurrage;
        data["noVoys"] = this.noVoys;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IContractDto {
    id?: number;
    refNo?: number;
    companyId?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    rateType?: string | undefined;
    cpForm?: string | undefined;
    hasDemurrage?: boolean | undefined;
    noVoys?: number;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateContractCommand implements ICreateContractCommand {
    companyId?: number;
    refNo?: number;
    charterer?: string;
    cpDate?: Date;
    status?: string;
    type?: string;
    owner?: string;
    broker?: string;
    remarks?: string;
    userEntered?: string;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string;
    dischAccount?: string;
    demurrage1?: string;
    ldDemurrage?: number;
    ldDemurragePer?: string;
    ldDemurrageAppliesTo?: string;
    demurrage2?: string;
    dischDemurrage?: number;
    dischDemurragePer?: string;
    dischDemurrageAppliesTo?: string;
    commPct?: number;
    rate?: number;
    rateType?: string;
    cpForm?: string;
    noVoys?: number;
    voyage?: VoyageDto;

    constructor(data?: ICreateContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.refNo = _data["refNo"];
            this.charterer = _data["charterer"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.remarks = _data["remarks"];
            this.userEntered = _data["userEntered"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.dischAccount = _data["dischAccount"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.commPct = _data["commPct"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.cpForm = _data["cpForm"];
            this.noVoys = _data["noVoys"];
            this.voyage = _data["voyage"] ? VoyageDto.fromJS(_data["voyage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["refNo"] = this.refNo;
        data["charterer"] = this.charterer;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["remarks"] = this.remarks;
        data["userEntered"] = this.userEntered;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["dischAccount"] = this.dischAccount;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["commPct"] = this.commPct;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["cpForm"] = this.cpForm;
        data["noVoys"] = this.noVoys;
        data["voyage"] = this.voyage ? this.voyage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateContractCommand {
    companyId?: number;
    refNo?: number;
    charterer?: string;
    cpDate?: Date;
    status?: string;
    type?: string;
    owner?: string;
    broker?: string;
    remarks?: string;
    userEntered?: string;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string;
    dischAccount?: string;
    demurrage1?: string;
    ldDemurrage?: number;
    ldDemurragePer?: string;
    ldDemurrageAppliesTo?: string;
    demurrage2?: string;
    dischDemurrage?: number;
    dischDemurragePer?: string;
    dischDemurrageAppliesTo?: string;
    commPct?: number;
    rate?: number;
    rateType?: string;
    cpForm?: string;
    noVoys?: number;
    voyage?: VoyageDto;
}

export class VoyageDto implements IVoyageDto {
    id?: number;
    contractId?: number;
    refNo?: number;
    moveNo?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    hasDemurrage?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IVoyageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.contractOwner = _data["contractOwner"];
            this.contractCharterer = _data["contractCharterer"];
            this.hasDemurrage = _data["hasDemurrage"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): VoyageDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoyageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["contractOwner"] = this.contractOwner;
        data["contractCharterer"] = this.contractCharterer;
        data["hasDemurrage"] = this.hasDemurrage;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IVoyageDto {
    id?: number;
    contractId?: number;
    refNo?: number;
    moveNo?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    hasDemurrage?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class UpdateContractCommand implements IUpdateContractCommand {
    id?: number;
    refNo?: number;
    companyId?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    rateType?: string | undefined;
    cpForm?: string | undefined;
    noVoys?: number;

    constructor(data?: IUpdateContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.companyId = _data["companyId"];
            this.charterer = _data["charterer"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.remarks = _data["remarks"];
            this.userEntered = _data["userEntered"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.dischAccount = _data["dischAccount"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.commPct = _data["commPct"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.cpForm = _data["cpForm"];
            this.noVoys = _data["noVoys"];
        }
    }

    static fromJS(data: any): UpdateContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["companyId"] = this.companyId;
        data["charterer"] = this.charterer;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["remarks"] = this.remarks;
        data["userEntered"] = this.userEntered;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["dischAccount"] = this.dischAccount;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["commPct"] = this.commPct;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["cpForm"] = this.cpForm;
        data["noVoys"] = this.noVoys;
        return data;
    }
}

export interface IUpdateContractCommand {
    id?: number;
    refNo?: number;
    companyId?: number;
    charterer?: string | undefined;
    cpDate?: Date;
    status?: string | undefined;
    type?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    remarks?: string | undefined;
    userEntered?: string | undefined;
    ldLaytime?: number;
    ldLaytimeRate?: number;
    dischLaytime?: number;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    dischAccount?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    commPct?: number;
    rate?: number;
    rateType?: string | undefined;
    cpForm?: string | undefined;
    noVoys?: number;
}

export class ContractSpProvsDto implements IContractSpProvsDto {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;

    constructor(data?: IContractSpProvsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.sProvNo = _data["sProvNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ContractSpProvsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSpProvsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["sProvNo"] = this.sProvNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IContractSpProvsDto {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;
}

export class ContractSpProvDto implements IContractSpProvDto {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IContractSpProvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.sProvNo = _data["sProvNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ContractSpProvDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSpProvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["sProvNo"] = this.sProvNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IContractSpProvDto {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
}

export class ContractSpProvVm implements IContractSpProvVm {
    contractSpProv?: ContractSpProvDto | undefined;
    specialConditions?: SelectDto[];

    constructor(data?: IContractSpProvVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractSpProv = _data["contractSpProv"] ? ContractSpProvDto.fromJS(_data["contractSpProv"]) : <any>undefined;
            if (Array.isArray(_data["specialConditions"])) {
                this.specialConditions = [] as any;
                for (let item of _data["specialConditions"])
                    this.specialConditions!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractSpProvVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSpProvVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractSpProv"] = this.contractSpProv ? this.contractSpProv.toJSON() : <any>undefined;
        if (Array.isArray(this.specialConditions)) {
            data["specialConditions"] = [];
            for (let item of this.specialConditions)
                data["specialConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractSpProvVm {
    contractSpProv?: ContractSpProvDto | undefined;
    specialConditions?: SelectDto[];
}

export class CreateContractSpProvCommand implements ICreateContractSpProvCommand {
    sProvNo?: number;
    refNo?: number;
    code?: string;
    comments?: string;

    constructor(data?: ICreateContractSpProvCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sProvNo = _data["sProvNo"];
            this.refNo = _data["refNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateContractSpProvCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractSpProvCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sProvNo"] = this.sProvNo;
        data["refNo"] = this.refNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateContractSpProvCommand {
    sProvNo?: number;
    refNo?: number;
    code?: string;
    comments?: string;
}

export class UpdateContractSpProvCommand implements IUpdateContractSpProvCommand {
    id?: number;
    sProvNo?: number;
    refNo?: number;
    code?: string;
    comments?: string;

    constructor(data?: IUpdateContractSpProvCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sProvNo = _data["sProvNo"];
            this.refNo = _data["refNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UpdateContractSpProvCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractSpProvCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sProvNo"] = this.sProvNo;
        data["refNo"] = this.refNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IUpdateContractSpProvCommand {
    id?: number;
    sProvNo?: number;
    refNo?: number;
    code?: string;
    comments?: string;
}

export class ContractVm implements IContractVm {
    contract?: ContractDto | undefined;
    voyage?: VoyageDto | undefined;
    charterers?: SelectDto[];
    chartererContacts?: SelectDto[];
    owners?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];

    constructor(data?: IContractVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.voyage = _data["voyage"] ? VoyageDto.fromJS(_data["voyage"]) : <any>undefined;
            if (Array.isArray(_data["charterers"])) {
                this.charterers = [] as any;
                for (let item of _data["charterers"])
                    this.charterers!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["chartererContacts"])) {
                this.chartererContacts = [] as any;
                for (let item of _data["chartererContacts"])
                    this.chartererContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ownerContacts"])) {
                this.ownerContacts = [] as any;
                for (let item of _data["ownerContacts"])
                    this.ownerContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["cpForms"])) {
                this.cpForms = [] as any;
                for (let item of _data["cpForms"])
                    this.cpForms!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContractVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["voyage"] = this.voyage ? this.voyage.toJSON() : <any>undefined;
        if (Array.isArray(this.charterers)) {
            data["charterers"] = [];
            for (let item of this.charterers)
                data["charterers"].push(item.toJSON());
        }
        if (Array.isArray(this.chartererContacts)) {
            data["chartererContacts"] = [];
            for (let item of this.chartererContacts)
                data["chartererContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerContacts)) {
            data["ownerContacts"] = [];
            for (let item of this.ownerContacts)
                data["ownerContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.cpForms)) {
            data["cpForms"] = [];
            for (let item of this.cpForms)
                data["cpForms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractVm {
    contract?: ContractDto | undefined;
    voyage?: VoyageDto | undefined;
    charterers?: SelectDto[];
    chartererContacts?: SelectDto[];
    owners?: SelectDto[];
    ownerContacts?: SelectDto[];
    statuses?: SelectDto[];
    cpForms?: SelectDto[];
}

export class CountryDto implements ICountryDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ICountryDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateCountryCommand implements ICreateCountryCommand {
    name?: string;

    constructor(data?: ICreateCountryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCountryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCountryCommand {
    name?: string;
}

export class UpdateCountryCommand implements IUpdateCountryCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateCountryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateCountryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateCountryCommand {
    id?: number;
    name?: string;
}

export class CpFormsDto implements ICpFormsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: ICpFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CpFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CpFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICpFormsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class CpFormDto implements ICpFormDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ICpFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): CpFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new CpFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ICpFormDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateCpFormCommand implements ICreateCpFormCommand {
    name?: string;

    constructor(data?: ICreateCpFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCpFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCpFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateCpFormCommand {
    name?: string;
}

export class UpdateCpFormCommand implements IUpdateCpFormCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateCpFormCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateCpFormCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCpFormCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateCpFormCommand {
    id?: number;
    name?: string;
}

export class CustomReportsDto implements ICustomReportsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    query?: string | undefined;
    isActive?: boolean;
    route?: string | undefined;
    notes?: string | undefined;
    auditDT?: Date;

    constructor(data?: ICustomReportsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.query = _data["query"];
            this.isActive = _data["isActive"];
            this.route = _data["route"];
            this.notes = _data["notes"];
            this.auditDT = _data["auditDT"] ? new Date(_data["auditDT"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomReportsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomReportsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["query"] = this.query;
        data["isActive"] = this.isActive;
        data["route"] = this.route;
        data["notes"] = this.notes;
        data["auditDT"] = this.auditDT ? this.auditDT.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomReportsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    query?: string | undefined;
    isActive?: boolean;
    route?: string | undefined;
    notes?: string | undefined;
    auditDT?: Date;
}

export class DemurrageLevelDto implements IDemurrageLevelDto {
    refNo?: number | undefined;
    moveNo?: number | undefined;
    groupId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    friendlyFormat?: string | undefined;
    demurrageHours?: number | undefined;

    constructor(data?: IDemurrageLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.groupId = _data["groupId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.friendlyFormat = _data["friendlyFormat"];
            this.demurrageHours = _data["demurrageHours"];
        }
    }

    static fromJS(data: any): DemurrageLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DemurrageLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["groupId"] = this.groupId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["friendlyFormat"] = this.friendlyFormat;
        data["demurrageHours"] = this.demurrageHours;
        return data;
    }
}

export interface IDemurrageLevelDto {
    refNo?: number | undefined;
    moveNo?: number | undefined;
    groupId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    friendlyFormat?: string | undefined;
    demurrageHours?: number | undefined;
}

export class GetDemurragesQuery implements IGetDemurragesQuery {
    owner?: string;
    charterer?: string;
    vessel?: string;
    status?: string;
    refNo?: number | undefined;
    moveNo?: number | undefined;

    constructor(data?: IGetDemurragesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.vessel = _data["vessel"];
            this.status = _data["status"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
        }
    }

    static fromJS(data: any): GetDemurragesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemurragesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["vessel"] = this.vessel;
        data["status"] = this.status;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        return data;
    }
}

export interface IGetDemurragesQuery {
    owner?: string;
    charterer?: string;
    vessel?: string;
    status?: string;
    refNo?: number | undefined;
    moveNo?: number | undefined;
}

export class DownloadDemurragesQuery implements IDownloadDemurragesQuery {
    owner?: string;
    charterer?: string;
    vessel?: string;
    status?: string;
    refNo?: number | undefined;
    moveNo?: number | undefined;

    constructor(data?: IDownloadDemurragesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.vessel = _data["vessel"];
            this.status = _data["status"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
        }
    }

    static fromJS(data: any): DownloadDemurragesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadDemurragesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["vessel"] = this.vessel;
        data["status"] = this.status;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        return data;
    }
}

export interface IDownloadDemurragesQuery {
    owner?: string;
    charterer?: string;
    vessel?: string;
    status?: string;
    refNo?: number | undefined;
    moveNo?: number | undefined;
}

export class CreateContractFoldersCommand implements ICreateContractFoldersCommand {
    id?: number;
    moveNo?: number;

    constructor(data?: ICreateContractFoldersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moveNo = _data["moveNo"];
        }
    }

    static fromJS(data: any): CreateContractFoldersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractFoldersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moveNo"] = this.moveNo;
        return data;
    }
}

export interface ICreateContractFoldersCommand {
    id?: number;
    moveNo?: number;
}

export class CreateContractVersionCommand implements ICreateContractVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;

    constructor(data?: ICreateContractVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDto.fromJS(item));
            }
            this.templatePath = _data["templatePath"];
        }
    }

    static fromJS(data: any): CreateContractVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["templatePath"] = this.templatePath;
        return data;
    }
}

export interface ICreateContractVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;
}

export class UsersDto implements IUsersDto {
    id?: string;
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    enableLars?: boolean;
    enableVesselTracking?: boolean;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.code = _data["code"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.enableLars = _data["enableLars"];
            this.enableVesselTracking = _data["enableVesselTracking"];
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["code"] = this.code;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["enableLars"] = this.enableLars;
        data["enableVesselTracking"] = this.enableVesselTracking;
        return data;
    }
}

export interface IUsersDto {
    id?: string;
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    enableLars?: boolean;
    enableVesselTracking?: boolean;
}

export class CreateContractVersionsCommand implements ICreateContractVersionsCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;

    constructor(data?: ICreateContractVersionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDto.fromJS(item));
            }
            this.templatePath = _data["templatePath"];
        }
    }

    static fromJS(data: any): CreateContractVersionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractVersionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["templatePath"] = this.templatePath;
        return data;
    }
}

export interface ICreateContractVersionsCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;
}

export class CreateNominationVersionCommand implements ICreateNominationVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;

    constructor(data?: ICreateNominationVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDto.fromJS(item));
            }
            this.templatePath = _data["templatePath"];
        }
    }

    static fromJS(data: any): CreateNominationVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNominationVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["templatePath"] = this.templatePath;
        return data;
    }
}

export interface ICreateNominationVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;
}

export class CreateTrafficVersionCommand implements ICreateTrafficVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;

    constructor(data?: ICreateTrafficVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UsersDto.fromJS(item));
            }
            this.templatePath = _data["templatePath"];
        }
    }

    static fromJS(data: any): CreateTrafficVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrafficVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["templatePath"] = this.templatePath;
        return data;
    }
}

export interface ICreateTrafficVersionCommand {
    id?: number;
    users?: UsersDto[];
    templatePath?: string | undefined;
}

export class CreateVoyageFolderCommand implements ICreateVoyageFolderCommand {
    id?: number;
    moveNo?: number;

    constructor(data?: ICreateVoyageFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moveNo = _data["moveNo"];
        }
    }

    static fromJS(data: any): CreateVoyageFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoyageFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moveNo"] = this.moveNo;
        return data;
    }
}

export interface ICreateVoyageFolderCommand {
    id?: number;
    moveNo?: number;
}

export class EmployeePersonalsDto implements IEmployeePersonalsDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    relation?: string | undefined;
    name?: string | undefined;
    dateOfBirth?: Date;
    remarks?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEmployeePersonalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.relation = _data["relation"];
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeePersonalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePersonalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["relation"] = this.relation;
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployeePersonalsDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    relation?: string | undefined;
    name?: string | undefined;
    dateOfBirth?: Date;
    remarks?: string | undefined;
    isActive?: boolean;
}

export class EmployeePersonalDto implements IEmployeePersonalDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    relation?: string | undefined;
    name?: string | undefined;
    dateOfBirth?: Date;
    remarks?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IEmployeePersonalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.relation = _data["relation"];
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): EmployeePersonalDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePersonalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["relation"] = this.relation;
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IEmployeePersonalDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    relation?: string | undefined;
    name?: string | undefined;
    dateOfBirth?: Date;
    remarks?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateEmployeePersonalCommand implements ICreateEmployeePersonalCommand {
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    relation?: string;
    name?: string;
    dateOfBirth?: Date | undefined;
    remarks?: string;

    constructor(data?: ICreateEmployeePersonalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.relation = _data["relation"];
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateEmployeePersonalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeePersonalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["relation"] = this.relation;
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateEmployeePersonalCommand {
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    relation?: string;
    name?: string;
    dateOfBirth?: Date | undefined;
    remarks?: string;
}

export class UpdateEmployeePersonalCommand implements IUpdateEmployeePersonalCommand {
    id?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    relation?: string;
    name?: string;
    dateOfBirth?: Date | undefined;
    remarks?: string;

    constructor(data?: IUpdateEmployeePersonalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.relation = _data["relation"];
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): UpdateEmployeePersonalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeePersonalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["relation"] = this.relation;
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IUpdateEmployeePersonalCommand {
    id?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    relation?: string;
    name?: string;
    dateOfBirth?: Date | undefined;
    remarks?: string;
}

export class EmployeePersonalVm implements IEmployeePersonalVm {
    employeePersonal?: EmployeePersonalDto | undefined;
    companies?: SelectDto[];
    relationTypes?: SelectDto[];

    constructor(data?: IEmployeePersonalVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeePersonal = _data["employeePersonal"] ? EmployeePersonalDto.fromJS(_data["employeePersonal"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["relationTypes"])) {
                this.relationTypes = [] as any;
                for (let item of _data["relationTypes"])
                    this.relationTypes!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePersonalVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePersonalVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeePersonal"] = this.employeePersonal ? this.employeePersonal.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.relationTypes)) {
            data["relationTypes"] = [];
            for (let item of this.relationTypes)
                data["relationTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeePersonalVm {
    employeePersonal?: EmployeePersonalDto | undefined;
    companies?: SelectDto[];
    relationTypes?: SelectDto[];
}

export class EmployeePhonesDto implements IEmployeePhonesDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEmployeePhonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeePhonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePhonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployeePhonesDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: string | undefined;
    isActive?: boolean;
}

export class EmployeePhoneDto implements IEmployeePhoneDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IEmployeePhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): EmployeePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IEmployeePhoneDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateEmployeePhoneCommand implements ICreateEmployeePhoneCommand {
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: string;

    constructor(data?: ICreateEmployeePhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
        }
    }

    static fromJS(data: any): CreateEmployeePhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeePhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        return data;
    }
}

export interface ICreateEmployeePhoneCommand {
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: string;
}

export class UpdateEmployeePhoneCommand implements IUpdateEmployeePhoneCommand {
    id?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: string;

    constructor(data?: IUpdateEmployeePhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
        }
    }

    static fromJS(data: any): UpdateEmployeePhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeePhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        return data;
    }
}

export interface IUpdateEmployeePhoneCommand {
    id?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: string;
}

export class EmployeePhoneVm implements IEmployeePhoneVm {
    employeePhone?: EmployeePhoneDto | undefined;
    companies?: SelectDto[];

    constructor(data?: IEmployeePhoneVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeePhone = _data["employeePhone"] ? EmployeePhoneDto.fromJS(_data["employeePhone"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePhoneVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePhoneVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeePhone"] = this.employeePhone ? this.employeePhone.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeePhoneVm {
    employeePhone?: EmployeePhoneDto | undefined;
    companies?: SelectDto[];
}

export class EmployeesDto implements IEmployeesDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    jobTitle?: string | undefined;
    isActive?: boolean;

    constructor(data?: IEmployeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.jobTitle = _data["jobTitle"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["jobTitle"] = this.jobTitle;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEmployeesDto {
    id?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    jobTitle?: string | undefined;
    isActive?: boolean;
}

export class EmployeeDto implements IEmployeeDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    updated?: Date;
    displayPhone?: string | undefined;
    dateOfBirth?: Date | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    christmasCard?: boolean;
    eMailHome?: string | undefined;
    imHome?: string | undefined;
    eMailOffice?: string | undefined;
    imOffice?: string | undefined;
    jobTitle?: string | undefined;
    comment?: string | undefined;
    salutation?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.displayPhone = _data["displayPhone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.christmasCard = _data["christmasCard"];
            this.eMailHome = _data["eMailHome"];
            this.imHome = _data["imHome"];
            this.eMailOffice = _data["eMailOffice"];
            this.imOffice = _data["imOffice"];
            this.jobTitle = _data["jobTitle"];
            this.comment = _data["comment"];
            this.salutation = _data["salutation"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["displayPhone"] = this.displayPhone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["christmasCard"] = this.christmasCard;
        data["eMailHome"] = this.eMailHome;
        data["imHome"] = this.imHome;
        data["eMailOffice"] = this.eMailOffice;
        data["imOffice"] = this.imOffice;
        data["jobTitle"] = this.jobTitle;
        data["comment"] = this.comment;
        data["salutation"] = this.salutation;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IEmployeeDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    updated?: Date;
    displayPhone?: string | undefined;
    dateOfBirth?: Date | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    christmasCard?: boolean;
    eMailHome?: string | undefined;
    imHome?: string | undefined;
    eMailOffice?: string | undefined;
    imOffice?: string | undefined;
    jobTitle?: string | undefined;
    comment?: string | undefined;
    salutation?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateEmployeeCommand implements ICreateEmployeeCommand {
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;

    constructor(data?: ICreateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.displayPhone = _data["displayPhone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.christmasCard = _data["christmasCard"];
            this.eMailHome = _data["eMailHome"];
            this.imHome = _data["imHome"];
            this.eMailOffice = _data["eMailOffice"];
            this.imOffice = _data["imOffice"];
            this.jobTitle = _data["jobTitle"];
            this.comment = _data["comment"];
            this.salutation = _data["salutation"];
        }
    }

    static fromJS(data: any): CreateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["displayPhone"] = this.displayPhone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["christmasCard"] = this.christmasCard;
        data["eMailHome"] = this.eMailHome;
        data["imHome"] = this.imHome;
        data["eMailOffice"] = this.eMailOffice;
        data["imOffice"] = this.imOffice;
        data["jobTitle"] = this.jobTitle;
        data["comment"] = this.comment;
        data["salutation"] = this.salutation;
        return data;
    }
}

export interface ICreateEmployeeCommand {
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;
}

export class UpdateEmployeeCommand implements IUpdateEmployeeCommand {
    id?: number;
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;

    constructor(data?: IUpdateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.displayPhone = _data["displayPhone"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.christmasCard = _data["christmasCard"];
            this.eMailHome = _data["eMailHome"];
            this.imHome = _data["imHome"];
            this.eMailOffice = _data["eMailOffice"];
            this.imOffice = _data["imOffice"];
            this.jobTitle = _data["jobTitle"];
            this.comment = _data["comment"];
            this.salutation = _data["salutation"];
        }
    }

    static fromJS(data: any): UpdateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["displayPhone"] = this.displayPhone;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["christmasCard"] = this.christmasCard;
        data["eMailHome"] = this.eMailHome;
        data["imHome"] = this.imHome;
        data["eMailOffice"] = this.eMailOffice;
        data["imOffice"] = this.imOffice;
        data["jobTitle"] = this.jobTitle;
        data["comment"] = this.comment;
        data["salutation"] = this.salutation;
        return data;
    }
}

export interface IUpdateEmployeeCommand {
    id?: number;
    companyId?: number;
    companyCode?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    updated?: Date;
    displayPhone?: string;
    dateOfBirth?: Date | undefined;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    christmasCard?: boolean;
    eMailHome?: string;
    imHome?: string;
    eMailOffice?: string;
    imOffice?: string;
    jobTitle?: string;
    comment?: string;
    salutation?: string;
}

export class EmployeeVm implements IEmployeeVm {
    employee?: EmployeeDto | undefined;
    companies?: SelectDto[];
    countries?: SelectDto[];
    states?: SelectDto[];

    constructor(data?: IEmployeeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeVm {
    employee?: EmployeeDto | undefined;
    companies?: SelectDto[];
    countries?: SelectDto[];
    states?: SelectDto[];
}

export class GroupsDto implements IGroupsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGroupsDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class GroupDto implements IGroupDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IGroupDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateGroupCommand implements ICreateGroupCommand {
    name?: string;

    constructor(data?: ICreateGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateGroupCommand {
    name?: string;
}

export class UpdateGroupCommand implements IUpdateGroupCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateGroupCommand {
    id?: number;
    name?: string;
}

export class VoyagesDto implements IVoyagesDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    contractId?: number;
    contractCpDate?: Date;
    contractBroker?: string | undefined;
    contractType?: string | undefined;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    rates?: string | undefined;
    equipVessel?: string | undefined;
    equipBarges?: string | undefined;
    vesselId?: number | undefined;
    mmsi?: string | undefined;
    aisReportedAtUtc?: Date | undefined;
    moveEquipments?: MoveEquipment[];
    moveVessels?: MoveVessel[];
    moveDischargePorts?: MoveDischargePort[];

    constructor(data?: IVoyagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.contractId = _data["contractId"];
            this.contractCpDate = _data["contractCpDate"] ? new Date(_data["contractCpDate"].toString()) : <any>undefined;
            this.contractBroker = _data["contractBroker"];
            this.contractType = _data["contractType"];
            this.contractOwner = _data["contractOwner"];
            this.contractCharterer = _data["contractCharterer"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.rates = _data["rates"];
            this.equipVessel = _data["equipVessel"];
            this.equipBarges = _data["equipBarges"];
            this.vesselId = _data["vesselId"];
            this.mmsi = _data["mmsi"];
            this.aisReportedAtUtc = _data["aisReportedAtUtc"] ? new Date(_data["aisReportedAtUtc"].toString()) : undefined as any;
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(MoveEquipment.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(MoveVessel.fromJS(item));
            }
            if (Array.isArray(_data["moveDischargePorts"])) {
                this.moveDischargePorts = [] as any;
                for (let item of _data["moveDischargePorts"])
                    this.moveDischargePorts!.push(MoveDischargePort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoyagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoyagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["contractId"] = this.contractId;
        data["contractCpDate"] = this.contractCpDate ? this.contractCpDate.toISOString() : <any>undefined;
        data["contractBroker"] = this.contractBroker;
        data["contractType"] = this.contractType;
        data["contractOwner"] = this.contractOwner;
        data["contractCharterer"] = this.contractCharterer;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["rates"] = this.rates;
        data["equipVessel"] = this.equipVessel;
        data["equipBarges"] = this.equipBarges;
        data["vesselId"] = this.vesselId;
        data["mmsi"] = this.mmsi;
        data["aisReportedAtUtc"] = this.aisReportedAtUtc ? this.aisReportedAtUtc.toISOString() : undefined as any;
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveDischargePorts)) {
            data["moveDischargePorts"] = [];
            for (let item of this.moveDischargePorts)
                data["moveDischargePorts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoyagesDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    contractId?: number;
    contractCpDate?: Date;
    contractBroker?: string | undefined;
    contractType?: string | undefined;
    contractOwner?: string | undefined;
    contractCharterer?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    rates?: string | undefined;
    equipVessel?: string | undefined;
    equipBarges?: string | undefined;
    vesselId?: number | undefined;
    mmsi?: string | undefined;
    aisReportedAtUtc?: Date | undefined;
    moveEquipments?: MoveEquipment[];
    moveVessels?: MoveVessel[];
    moveDischargePorts?: MoveDischargePort[];
}

export abstract class BaseEntity implements IBaseEntity {
    id?: number;
    domainEvents?: BaseEvent[];

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    this.domainEvents!.push(BaseEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseEntity {
    id?: number;
    domainEvents?: BaseEvent[];
}

export abstract class BaseAuditableEntity extends BaseEntity implements IBaseAuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isActive?: boolean;

    constructor(data?: IBaseAuditableEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): BaseAuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAuditableEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseAuditableEntity extends IBaseEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
    isActive?: boolean;
}

export class MoveEquipment extends BaseAuditableEntity implements IMoveEquipment {
    voyageId?: number | undefined;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;

    constructor(data?: IMoveEquipment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vessel = _data["vessel"];
            this.vapor = _data["vapor"];
        }
    }

    static override fromJS(data: any): MoveEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEquipment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vessel"] = this.vessel;
        data["vapor"] = this.vapor;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveEquipment extends IBaseAuditableEntity {
    voyageId?: number | undefined;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;
}

export abstract class BaseEvent implements IBaseEvent {

    constructor(data?: IBaseEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseEvent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEvent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBaseEvent {
}

export class MoveVessel extends BaseAuditableEntity implements IMoveVessel {
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;

    constructor(data?: IMoveVessel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
        }
    }

    static override fromJS(data: any): MoveVessel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveVessel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveVessel extends IBaseAuditableEntity {
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
}

export class MoveDischargePort extends BaseAuditableEntity implements IMoveDischargePort {
    voyageId?: number | undefined;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;

    constructor(data?: IMoveDischargePort) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.notePrint = _data["notePrint"];
        }
    }

    static override fromJS(data: any): MoveDischargePort {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDischargePort();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["notePrint"] = this.notePrint;
        super.toJSON(data);
        return data;
    }
}

export interface IMoveDischargePort extends IBaseAuditableEntity {
    voyageId?: number | undefined;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;
}

export class MoveCargosDto implements IMoveCargosDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    quanity?: number;
    cargo?: string | undefined;
    unit?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    estimate?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMoveCargosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.quanity = _data["quanity"];
            this.cargo = _data["cargo"];
            this.unit = _data["unit"];
            this.rvp = _data["rvp"];
            this.api = _data["api"];
            this.pour = _data["pour"];
            this.visc = _data["visc"];
            this.estimate = _data["estimate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MoveCargosDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveCargosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["quanity"] = this.quanity;
        data["cargo"] = this.cargo;
        data["unit"] = this.unit;
        data["rvp"] = this.rvp;
        data["api"] = this.api;
        data["pour"] = this.pour;
        data["visc"] = this.visc;
        data["estimate"] = this.estimate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMoveCargosDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    quanity?: number;
    cargo?: string | undefined;
    unit?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    estimate?: string | undefined;
    isActive?: boolean;
}

export class MoveCargoDto implements IMoveCargoDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string | undefined;
    cargo?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    estimate?: string | undefined;

    constructor(data?: IMoveCargoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.item = _data["item"];
            this.quanity = _data["quanity"];
            this.unit = _data["unit"];
            this.cargo = _data["cargo"];
            this.rvp = _data["rvp"];
            this.api = _data["api"];
            this.pour = _data["pour"];
            this.visc = _data["visc"];
            this.estimate = _data["estimate"];
        }
    }

    static fromJS(data: any): MoveCargoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveCargoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["item"] = this.item;
        data["quanity"] = this.quanity;
        data["unit"] = this.unit;
        data["cargo"] = this.cargo;
        data["rvp"] = this.rvp;
        data["api"] = this.api;
        data["pour"] = this.pour;
        data["visc"] = this.visc;
        data["estimate"] = this.estimate;
        return data;
    }
}

export interface IMoveCargoDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string | undefined;
    cargo?: string | undefined;
    rvp?: string | undefined;
    api?: string | undefined;
    pour?: string | undefined;
    visc?: string | undefined;
    estimate?: string | undefined;
}

export class CreateMoveCargoCommand implements ICreateMoveCargoCommand {
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string;
    cargo?: string;
    rvp?: string;
    api?: string;
    pour?: string;
    visc?: string;
    estimate?: string;

    constructor(data?: ICreateMoveCargoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.item = _data["item"];
            this.quanity = _data["quanity"];
            this.unit = _data["unit"];
            this.cargo = _data["cargo"];
            this.rvp = _data["rvp"];
            this.api = _data["api"];
            this.pour = _data["pour"];
            this.visc = _data["visc"];
            this.estimate = _data["estimate"];
        }
    }

    static fromJS(data: any): CreateMoveCargoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveCargoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["item"] = this.item;
        data["quanity"] = this.quanity;
        data["unit"] = this.unit;
        data["cargo"] = this.cargo;
        data["rvp"] = this.rvp;
        data["api"] = this.api;
        data["pour"] = this.pour;
        data["visc"] = this.visc;
        data["estimate"] = this.estimate;
        return data;
    }
}

export interface ICreateMoveCargoCommand {
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string;
    cargo?: string;
    rvp?: string;
    api?: string;
    pour?: string;
    visc?: string;
    estimate?: string;
}

export class UpdateMoveCargoCommand implements IUpdateMoveCargoCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string;
    cargo?: string;
    rvp?: string;
    api?: string;
    pour?: string;
    visc?: string;
    estimate?: string;

    constructor(data?: IUpdateMoveCargoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.item = _data["item"];
            this.quanity = _data["quanity"];
            this.unit = _data["unit"];
            this.cargo = _data["cargo"];
            this.rvp = _data["rvp"];
            this.api = _data["api"];
            this.pour = _data["pour"];
            this.visc = _data["visc"];
            this.estimate = _data["estimate"];
        }
    }

    static fromJS(data: any): UpdateMoveCargoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveCargoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["item"] = this.item;
        data["quanity"] = this.quanity;
        data["unit"] = this.unit;
        data["cargo"] = this.cargo;
        data["rvp"] = this.rvp;
        data["api"] = this.api;
        data["pour"] = this.pour;
        data["visc"] = this.visc;
        data["estimate"] = this.estimate;
        return data;
    }
}

export interface IUpdateMoveCargoCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    item?: number;
    quanity?: number;
    unit?: string;
    cargo?: string;
    rvp?: string;
    api?: string;
    pour?: string;
    visc?: string;
    estimate?: string;
}

export class MoveCargoVm implements IMoveCargoVm {
    moveCargo?: MoveCargoDto | undefined;
    cargos?: SelectDto[];
    units?: SelectDto[];

    constructor(data?: IMoveCargoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveCargo = _data["moveCargo"] ? MoveCargoDto.fromJS(_data["moveCargo"]) : <any>undefined;
            if (Array.isArray(_data["cargos"])) {
                this.cargos = [] as any;
                for (let item of _data["cargos"])
                    this.cargos!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveCargoVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveCargoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveCargo"] = this.moveCargo ? this.moveCargo.toJSON() : <any>undefined;
        if (Array.isArray(this.cargos)) {
            data["cargos"] = [];
            for (let item of this.cargos)
                data["cargos"].push(item.toJSON());
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveCargoVm {
    moveCargo?: MoveCargoDto | undefined;
    cargos?: SelectDto[];
    units?: SelectDto[];
}

export class MoveDischargePortsDto implements IMoveDischargePortsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMoveDischargePortsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MoveDischargePortsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDischargePortsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMoveDischargePortsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    isActive?: boolean;
}

export class MoveDischargePortDto implements IMoveDischargePortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;

    constructor(data?: IMoveDischargePortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.notePrint = _data["notePrint"];
        }
    }

    static fromJS(data: any): MoveDischargePortDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDischargePortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["notePrint"] = this.notePrint;
        return data;
    }
}

export interface IMoveDischargePortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    lighteringVsl?: string | undefined;
    rate?: number;
    unit?: string | undefined;
    note?: string | undefined;
    notePrint?: boolean;
}

export class CreateMoveDischargePortCommand implements ICreateMoveDischargePortCommand {
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    lighteringVsl?: string;
    rate?: number;
    unit?: string;
    note?: string;
    notePrint?: boolean;

    constructor(data?: ICreateMoveDischargePortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.notePrint = _data["notePrint"];
        }
    }

    static fromJS(data: any): CreateMoveDischargePortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveDischargePortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["notePrint"] = this.notePrint;
        return data;
    }
}

export interface ICreateMoveDischargePortCommand {
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    lighteringVsl?: string;
    rate?: number;
    unit?: string;
    note?: string;
    notePrint?: boolean;
}

export class UpdateMoveDischargePortCommand implements IUpdateMoveDischargePortCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    lighteringVsl?: string;
    rate?: number;
    unit?: string;
    note?: string;
    notePrint?: boolean;

    constructor(data?: IUpdateMoveDischargePortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.lighteringVsl = _data["lighteringVsl"];
            this.rate = _data["rate"];
            this.unit = _data["unit"];
            this.note = _data["note"];
            this.notePrint = _data["notePrint"];
        }
    }

    static fromJS(data: any): UpdateMoveDischargePortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveDischargePortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["lighteringVsl"] = this.lighteringVsl;
        data["rate"] = this.rate;
        data["unit"] = this.unit;
        data["note"] = this.note;
        data["notePrint"] = this.notePrint;
        return data;
    }
}

export interface IUpdateMoveDischargePortCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    lighteringVsl?: string;
    rate?: number;
    unit?: string;
    note?: string;
    notePrint?: boolean;
}

export class MoveDischargePortVm implements IMoveDischargePortVm {
    port?: MoveDischargePortDto | undefined;
    terminals?: SelectDto[];
    ports?: SelectDto[];
    units?: SelectDto[];

    constructor(data?: IMoveDischargePortVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.port = _data["port"] ? MoveDischargePortDto.fromJS(_data["port"]) : <any>undefined;
            if (Array.isArray(_data["terminals"])) {
                this.terminals = [] as any;
                for (let item of _data["terminals"])
                    this.terminals!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ports"])) {
                this.ports = [] as any;
                for (let item of _data["ports"])
                    this.ports!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveDischargePortVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveDischargePortVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["port"] = this.port ? this.port.toJSON() : <any>undefined;
        if (Array.isArray(this.terminals)) {
            data["terminals"] = [];
            for (let item of this.terminals)
                data["terminals"].push(item.toJSON());
        }
        if (Array.isArray(this.ports)) {
            data["ports"] = [];
            for (let item of this.ports)
                data["ports"].push(item.toJSON());
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveDischargePortVm {
    port?: MoveDischargePortDto | undefined;
    terminals?: SelectDto[];
    ports?: SelectDto[];
    units?: SelectDto[];
}

export class MoveEquipmentsDto implements IMoveEquipmentsDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;
    isActive?: boolean;

    constructor(data?: IMoveEquipmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vessel = _data["vessel"];
            this.vapor = _data["vapor"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MoveEquipmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEquipmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vessel"] = this.vessel;
        data["vapor"] = this.vapor;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMoveEquipmentsDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;
    isActive?: boolean;
}

export class MoveEquipmentDto implements IMoveEquipmentDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;

    constructor(data?: IMoveEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vessel = _data["vessel"];
            this.vapor = _data["vapor"];
        }
    }

    static fromJS(data: any): MoveEquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vessel"] = this.vessel;
        data["vapor"] = this.vapor;
        return data;
    }
}

export interface IMoveEquipmentDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string | undefined;
    bargeName?: string | undefined;
    bargePrep?: string | undefined;
    cargoCalibr?: string | undefined;
    capacity?: number;
    unit?: string | undefined;
    construction?: string | undefined;
    heating?: string | undefined;
    vessel?: string | undefined;
    vapor?: boolean;
}

export class CreateMoveEquipmentCommand implements ICreateMoveEquipmentCommand {
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string;
    bargeName?: string;
    bargePrep?: string;
    cargoCalibr?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    vessel?: string;
    vapor?: boolean;

    constructor(data?: ICreateMoveEquipmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vessel = _data["vessel"];
            this.vapor = _data["vapor"];
        }
    }

    static fromJS(data: any): CreateMoveEquipmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveEquipmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vessel"] = this.vessel;
        data["vapor"] = this.vapor;
        return data;
    }
}

export interface ICreateMoveEquipmentCommand {
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string;
    bargeName?: string;
    bargePrep?: string;
    cargoCalibr?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    vessel?: string;
    vapor?: boolean;
}

export class UpdateMoveEquipmentCommand implements IUpdateMoveEquipmentCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string;
    bargeName?: string;
    bargePrep?: string;
    cargoCalibr?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    vessel?: string;
    vapor?: boolean;

    constructor(data?: IUpdateMoveEquipmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.bargeNo = _data["bargeNo"];
            this.lastCargo = _data["lastCargo"];
            this.bargeName = _data["bargeName"];
            this.bargePrep = _data["bargePrep"];
            this.cargoCalibr = _data["cargoCalibr"];
            this.capacity = _data["capacity"];
            this.unit = _data["unit"];
            this.construction = _data["construction"];
            this.heating = _data["heating"];
            this.vessel = _data["vessel"];
            this.vapor = _data["vapor"];
        }
    }

    static fromJS(data: any): UpdateMoveEquipmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveEquipmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["bargeNo"] = this.bargeNo;
        data["lastCargo"] = this.lastCargo;
        data["bargeName"] = this.bargeName;
        data["bargePrep"] = this.bargePrep;
        data["cargoCalibr"] = this.cargoCalibr;
        data["capacity"] = this.capacity;
        data["unit"] = this.unit;
        data["construction"] = this.construction;
        data["heating"] = this.heating;
        data["vessel"] = this.vessel;
        data["vapor"] = this.vapor;
        return data;
    }
}

export interface IUpdateMoveEquipmentCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    bargeNo?: number;
    lastCargo?: string;
    bargeName?: string;
    bargePrep?: string;
    cargoCalibr?: string;
    capacity?: number;
    unit?: string;
    construction?: string;
    heating?: string;
    vessel?: string;
    vapor?: boolean;
}

export class MoveEquipmentVm implements IMoveEquipmentVm {
    moveEquipment?: MoveEquipmentDto | undefined;
    bargePreparations?: SelectDto[];
    barges?: SelectDto[];
    cargos?: SelectDto[];
    units?: SelectDto[];
    vessels?: SelectDto[];

    constructor(data?: IMoveEquipmentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveEquipment = _data["moveEquipment"] ? MoveEquipmentDto.fromJS(_data["moveEquipment"]) : <any>undefined;
            if (Array.isArray(_data["bargePreparations"])) {
                this.bargePreparations = [] as any;
                for (let item of _data["bargePreparations"])
                    this.bargePreparations!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["barges"])) {
                this.barges = [] as any;
                for (let item of _data["barges"])
                    this.barges!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["cargos"])) {
                this.cargos = [] as any;
                for (let item of _data["cargos"])
                    this.cargos!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["vessels"])) {
                this.vessels = [] as any;
                for (let item of _data["vessels"])
                    this.vessels!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveEquipmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveEquipmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveEquipment"] = this.moveEquipment ? this.moveEquipment.toJSON() : <any>undefined;
        if (Array.isArray(this.bargePreparations)) {
            data["bargePreparations"] = [];
            for (let item of this.bargePreparations)
                data["bargePreparations"].push(item.toJSON());
        }
        if (Array.isArray(this.barges)) {
            data["barges"] = [];
            for (let item of this.barges)
                data["barges"].push(item.toJSON());
        }
        if (Array.isArray(this.cargos)) {
            data["cargos"] = [];
            for (let item of this.cargos)
                data["cargos"].push(item.toJSON());
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        if (Array.isArray(this.vessels)) {
            data["vessels"] = [];
            for (let item of this.vessels)
                data["vessels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveEquipmentVm {
    moveEquipment?: MoveEquipmentDto | undefined;
    bargePreparations?: SelectDto[];
    barges?: SelectDto[];
    cargos?: SelectDto[];
    units?: SelectDto[];
    vessels?: SelectDto[];
}

export class MoveLdPortsDto implements IMoveLdPortsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMoveLdPortsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.ligheringVsl = _data["ligheringVsl"];
            this.loadNote = _data["loadNote"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MoveLdPortsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveLdPortsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["ligheringVsl"] = this.ligheringVsl;
        data["loadNote"] = this.loadNote;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMoveLdPortsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    isActive?: boolean;
}

export class MoveLdPortDto implements IMoveLdPortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    loadNotePrint?: boolean;

    constructor(data?: IMoveLdPortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.ligheringVsl = _data["ligheringVsl"];
            this.loadNote = _data["loadNote"];
            this.loadNotePrint = _data["loadNotePrint"];
        }
    }

    static fromJS(data: any): MoveLdPortDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveLdPortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["ligheringVsl"] = this.ligheringVsl;
        data["loadNote"] = this.loadNote;
        data["loadNotePrint"] = this.loadNotePrint;
        return data;
    }
}

export interface IMoveLdPortDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string | undefined;
    terminal?: string | undefined;
    ligheringVsl?: string | undefined;
    loadNote?: string | undefined;
    loadNotePrint?: boolean;
}

export class CreateMoveLdPortCommand implements ICreateMoveLdPortCommand {
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    ligheringVsl?: string;
    loadNote?: string;
    loadNotePrint?: boolean;

    constructor(data?: ICreateMoveLdPortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.ligheringVsl = _data["ligheringVsl"];
            this.loadNote = _data["loadNote"];
            this.loadNotePrint = _data["loadNotePrint"];
        }
    }

    static fromJS(data: any): CreateMoveLdPortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveLdPortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["ligheringVsl"] = this.ligheringVsl;
        data["loadNote"] = this.loadNote;
        data["loadNotePrint"] = this.loadNotePrint;
        return data;
    }
}

export interface ICreateMoveLdPortCommand {
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    ligheringVsl?: string;
    loadNote?: string;
    loadNotePrint?: boolean;
}

export class UpdateMoveLdPortCommand implements IUpdateMoveLdPortCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    ligheringVsl?: string;
    loadNote?: string;
    loadNotePrint?: boolean;

    constructor(data?: IUpdateMoveLdPortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.portNo = _data["portNo"];
            this.port = _data["port"];
            this.terminal = _data["terminal"];
            this.ligheringVsl = _data["ligheringVsl"];
            this.loadNote = _data["loadNote"];
            this.loadNotePrint = _data["loadNotePrint"];
        }
    }

    static fromJS(data: any): UpdateMoveLdPortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveLdPortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["portNo"] = this.portNo;
        data["port"] = this.port;
        data["terminal"] = this.terminal;
        data["ligheringVsl"] = this.ligheringVsl;
        data["loadNote"] = this.loadNote;
        data["loadNotePrint"] = this.loadNotePrint;
        return data;
    }
}

export interface IUpdateMoveLdPortCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    portNo?: number;
    port?: string;
    terminal?: string;
    ligheringVsl?: string;
    loadNote?: string;
    loadNotePrint?: boolean;
}

export class MoveLdPortVm implements IMoveLdPortVm {
    port?: MoveLdPortDto | undefined;
    terminals?: SelectDto[];
    ports?: SelectDto[];

    constructor(data?: IMoveLdPortVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.port = _data["port"] ? MoveLdPortDto.fromJS(_data["port"]) : <any>undefined;
            if (Array.isArray(_data["terminals"])) {
                this.terminals = [] as any;
                for (let item of _data["terminals"])
                    this.terminals!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ports"])) {
                this.ports = [] as any;
                for (let item of _data["ports"])
                    this.ports!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveLdPortVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveLdPortVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["port"] = this.port ? this.port.toJSON() : <any>undefined;
        if (Array.isArray(this.terminals)) {
            data["terminals"] = [];
            for (let item of this.terminals)
                data["terminals"].push(item.toJSON());
        }
        if (Array.isArray(this.ports)) {
            data["ports"] = [];
            for (let item of this.ports)
                data["ports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveLdPortVm {
    port?: MoveLdPortDto | undefined;
    terminals?: SelectDto[];
    ports?: SelectDto[];
}

export class MoveOpsTrafficsDto implements IMoveOpsTrafficsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IMoveOpsTrafficsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.moveTrafficNo = _data["moveTrafficNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): MoveOpsTrafficsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOpsTrafficsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["moveTrafficNo"] = this.moveTrafficNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IMoveOpsTrafficsDto {
    id?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class MoveOpsTrafficDto implements IMoveOpsTrafficDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    msgSelector?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IMoveOpsTrafficDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.moveTrafficNo = _data["moveTrafficNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.msgSelector = _data["msgSelector"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): MoveOpsTrafficDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOpsTrafficDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["moveTrafficNo"] = this.moveTrafficNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["msgSelector"] = this.msgSelector;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IMoveOpsTrafficDto {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string | undefined;
    comments?: string | undefined;
    msgSelector?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateMoveOpsTrafficCommand implements ICreateMoveOpsTrafficCommand {
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;

    constructor(data?: ICreateMoveOpsTrafficCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.moveTrafficNo = _data["moveTrafficNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.msgSelector = _data["msgSelector"];
        }
    }

    static fromJS(data: any): CreateMoveOpsTrafficCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveOpsTrafficCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["moveTrafficNo"] = this.moveTrafficNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["msgSelector"] = this.msgSelector;
        return data;
    }
}

export interface ICreateMoveOpsTrafficCommand {
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;
}

export class UpdateMoveOpsTrafficCommand implements IUpdateMoveOpsTrafficCommand {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;

    constructor(data?: IUpdateMoveOpsTrafficCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.moveTrafficNo = _data["moveTrafficNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.msgSelector = _data["msgSelector"];
        }
    }

    static fromJS(data: any): UpdateMoveOpsTrafficCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveOpsTrafficCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["moveTrafficNo"] = this.moveTrafficNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["msgSelector"] = this.msgSelector;
        return data;
    }
}

export interface IUpdateMoveOpsTrafficCommand {
    id?: number;
    voyageId?: number;
    refNo?: number;
    moveNo?: number;
    moveTrafficNo?: number;
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;
}

export class MoveOpsTrafficVm implements IMoveOpsTrafficVm {
    moveOpsTraffic?: MoveOpsTrafficDto | undefined;
    opCodes?: SelectDto[];

    constructor(data?: IMoveOpsTrafficVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveOpsTraffic = _data["moveOpsTraffic"] ? MoveOpsTrafficDto.fromJS(_data["moveOpsTraffic"]) : <any>undefined;
            if (Array.isArray(_data["opCodes"])) {
                this.opCodes = [] as any;
                for (let item of _data["opCodes"])
                    this.opCodes!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveOpsTrafficVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOpsTrafficVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveOpsTraffic"] = this.moveOpsTraffic ? this.moveOpsTraffic.toJSON() : <any>undefined;
        if (Array.isArray(this.opCodes)) {
            data["opCodes"] = [];
            for (let item of this.opCodes)
                data["opCodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveOpsTrafficVm {
    moveOpsTraffic?: MoveOpsTrafficDto | undefined;
    opCodes?: SelectDto[];
}

export class MoveSpecialProvisionsDto implements IMoveSpecialProvisionsDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IMoveSpecialProvisionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): MoveSpecialProvisionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSpecialProvisionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IMoveSpecialProvisionsDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class MoveSpecialProvisionDto implements IMoveSpecialProvisionDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMoveSpecialProvisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MoveSpecialProvisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSpecialProvisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IMoveSpecialProvisionDto {
    id?: number;
    voyageId?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class MoveSpecialProvisionVm implements IMoveSpecialProvisionVm {
    moveSpecialProvision?: MoveSpecialProvisionDto | undefined;
    specialConditions?: SelectDto[];

    constructor(data?: IMoveSpecialProvisionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveSpecialProvision = _data["moveSpecialProvision"] ? MoveSpecialProvisionDto.fromJS(_data["moveSpecialProvision"]) : <any>undefined;
            if (Array.isArray(_data["specialConditions"])) {
                this.specialConditions = [] as any;
                for (let item of _data["specialConditions"])
                    this.specialConditions!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveSpecialProvisionVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSpecialProvisionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveSpecialProvision"] = this.moveSpecialProvision ? this.moveSpecialProvision.toJSON() : <any>undefined;
        if (Array.isArray(this.specialConditions)) {
            data["specialConditions"] = [];
            for (let item of this.specialConditions)
                data["specialConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveSpecialProvisionVm {
    moveSpecialProvision?: MoveSpecialProvisionDto | undefined;
    specialConditions?: SelectDto[];
}

export class CreateMoveSpecialProvisionCommand implements ICreateMoveSpecialProvisionCommand {
    voyageId?: number;
    code?: string;
    description?: string;

    constructor(data?: ICreateMoveSpecialProvisionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateMoveSpecialProvisionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveSpecialProvisionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateMoveSpecialProvisionCommand {
    voyageId?: number;
    code?: string;
    description?: string;
}

export class UpdateMoveSpecialProvisionCommand implements IUpdateMoveSpecialProvisionCommand {
    id?: number;
    voyageId?: number;
    code?: string;
    description?: string;

    constructor(data?: IUpdateMoveSpecialProvisionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateMoveSpecialProvisionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveSpecialProvisionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateMoveSpecialProvisionCommand {
    id?: number;
    voyageId?: number;
    code?: string;
    description?: string;
}

export class MoveVesselsDto implements IMoveVesselsDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    vesselId?: number | undefined;
    mmsi?: string | undefined;
    aisReportedAtUtc?: Date | undefined;

    constructor(data?: IMoveVesselsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.vesselId = _data["vesselId"];
            this.mmsi = _data["mmsi"];
            this.aisReportedAtUtc = _data["aisReportedAtUtc"] ? new Date(_data["aisReportedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MoveVesselsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveVesselsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["vesselId"] = this.vesselId;
        data["mmsi"] = this.mmsi;
        data["aisReportedAtUtc"] = this.aisReportedAtUtc ? this.aisReportedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IMoveVesselsDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    vesselId?: number | undefined;
    mmsi?: string | undefined;
    aisReportedAtUtc?: Date | undefined;
}

export class MoveVesselDto implements IMoveVesselDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;

    constructor(data?: IMoveVesselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
        }
    }

    static fromJS(data: any): MoveVesselDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveVesselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        return data;
    }
}

export interface IMoveVesselDto {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
}

export class MoveVesselVm implements IMoveVesselVm {
    moveVessel?: MoveVesselDto | undefined;
    vessels?: SelectDto[];
    companies?: SelectDto[];

    constructor(data?: IMoveVesselVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveVessel = _data["moveVessel"] ? MoveVesselDto.fromJS(_data["moveVessel"]) : <any>undefined;
            if (Array.isArray(_data["vessels"])) {
                this.vessels = [] as any;
                for (let item of _data["vessels"])
                    this.vessels!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MoveVesselVm {
        data = typeof data === 'object' ? data : {};
        let result = new MoveVesselVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveVessel"] = this.moveVessel ? this.moveVessel.toJSON() : <any>undefined;
        if (Array.isArray(this.vessels)) {
            data["vessels"] = [];
            for (let item of this.vessels)
                data["vessels"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMoveVesselVm {
    moveVessel?: MoveVesselDto | undefined;
    vessels?: SelectDto[];
    companies?: SelectDto[];
}

export class CreateMoveVesselCommand implements ICreateMoveVesselCommand {
    voyageId?: number;
    name?: string;
    companyCode?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;

    constructor(data?: ICreateMoveVesselCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
        }
    }

    static fromJS(data: any): CreateMoveVesselCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoveVesselCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        return data;
    }
}

export interface ICreateMoveVesselCommand {
    voyageId?: number;
    name?: string;
    companyCode?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
}

export class UpdateMoveVesselCommand implements IUpdateMoveVesselCommand {
    id?: number;
    voyageId?: number;
    name?: string;
    companyCode?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;

    constructor(data?: IUpdateMoveVesselCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
        }
    }

    static fromJS(data: any): UpdateMoveVesselCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoveVesselCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        return data;
    }
}

export interface IUpdateMoveVesselCommand {
    id?: number;
    voyageId?: number;
    name?: string;
    companyCode?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
}

export class CreateMultiMoveOpsTrafficCommand implements ICreateMultiMoveOpsTrafficCommand {
    voyages?: VoyagesDto[];
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;

    constructor(data?: ICreateMultiMoveOpsTrafficCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voyages"])) {
                this.voyages = [] as any;
                for (let item of _data["voyages"])
                    this.voyages!.push(VoyagesDto.fromJS(item));
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.msgSelector = _data["msgSelector"];
        }
    }

    static fromJS(data: any): CreateMultiMoveOpsTrafficCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultiMoveOpsTrafficCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voyages)) {
            data["voyages"] = [];
            for (let item of this.voyages)
                data["voyages"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["msgSelector"] = this.msgSelector;
        return data;
    }
}

export interface ICreateMultiMoveOpsTrafficCommand {
    voyages?: VoyagesDto[];
    date?: Date | undefined;
    time?: Date | undefined;
    opCode?: string;
    comments?: string;
    msgSelector?: boolean;
}

export class NewCreateVoyageCommand implements INewCreateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];

    constructor(data?: INewCreateVoyageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.contractId = _data["contractId"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(BatchEquipmentDto.fromJS(item));
            }
            if (Array.isArray(_data["moveCargos"])) {
                this.moveCargos = [] as any;
                for (let item of _data["moveCargos"])
                    this.moveCargos!.push(BatchCargoDto.fromJS(item));
            }
            if (Array.isArray(_data["moveDischargePorts"])) {
                this.moveDischargePorts = [] as any;
                for (let item of _data["moveDischargePorts"])
                    this.moveDischargePorts!.push(BatchDischargePortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveLdPorts"])) {
                this.moveLdPorts = [] as any;
                for (let item of _data["moveLdPorts"])
                    this.moveLdPorts!.push(BatchLoadPortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveOpsTraffics"])) {
                this.moveOpsTraffics = [] as any;
                for (let item of _data["moveOpsTraffics"])
                    this.moveOpsTraffics!.push(BatchTrafficDto.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(BatchVesselDto.fromJS(item));
            }
            if (Array.isArray(_data["moveSpecialProvisions"])) {
                this.moveSpecialProvisions = [] as any;
                for (let item of _data["moveSpecialProvisions"])
                    this.moveSpecialProvisions!.push(BatchMoveSpecialProvisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewCreateVoyageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NewCreateVoyageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["contractId"] = this.contractId;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.moveCargos)) {
            data["moveCargos"] = [];
            for (let item of this.moveCargos)
                data["moveCargos"].push(item.toJSON());
        }
        if (Array.isArray(this.moveDischargePorts)) {
            data["moveDischargePorts"] = [];
            for (let item of this.moveDischargePorts)
                data["moveDischargePorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveLdPorts)) {
            data["moveLdPorts"] = [];
            for (let item of this.moveLdPorts)
                data["moveLdPorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveOpsTraffics)) {
            data["moveOpsTraffics"] = [];
            for (let item of this.moveOpsTraffics)
                data["moveOpsTraffics"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveSpecialProvisions)) {
            data["moveSpecialProvisions"] = [];
            for (let item of this.moveSpecialProvisions)
                data["moveSpecialProvisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewCreateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean | undefined;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];
}

export class VoyagesReportVm implements IVoyagesReportVm {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    readinessDate?: Date | undefined;
    contract?: ContractReport | undefined;
    moveVessels?: VesselsReport[];
    moveEquipments?: MoveEquipment[];

    constructor(data?: IVoyagesReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.contract = _data["contract"] ? ContractReport.fromJS(_data["contract"]) : <any>undefined;
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(VesselsReport.fromJS(item));
            }
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(MoveEquipment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoyagesReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoyagesReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoyagesReportVm {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    readinessDate?: Date | undefined;
    contract?: ContractReport | undefined;
    moveVessels?: VesselsReport[];
    moveEquipments?: MoveEquipment[];
}

export class ContractReport implements IContractReport {
    id?: number;
    refNo?: number;
    cpDate?: Date;
    charterer?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    type?: string | undefined;
    contractSpProvs?: ContractSpProvsReport[];

    constructor(data?: IContractReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.cpDate = _data["cpDate"] ? new Date(_data["cpDate"].toString()) : <any>undefined;
            this.charterer = _data["charterer"];
            this.owner = _data["owner"];
            this.broker = _data["broker"];
            this.type = _data["type"];
            if (Array.isArray(_data["contractSpProvs"])) {
                this.contractSpProvs = [] as any;
                for (let item of _data["contractSpProvs"])
                    this.contractSpProvs!.push(ContractSpProvsReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractReport {
        data = typeof data === 'object' ? data : {};
        let result = new ContractReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["cpDate"] = this.cpDate ? this.cpDate.toISOString() : <any>undefined;
        data["charterer"] = this.charterer;
        data["owner"] = this.owner;
        data["broker"] = this.broker;
        data["type"] = this.type;
        if (Array.isArray(this.contractSpProvs)) {
            data["contractSpProvs"] = [];
            for (let item of this.contractSpProvs)
                data["contractSpProvs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractReport {
    id?: number;
    refNo?: number;
    cpDate?: Date;
    charterer?: string | undefined;
    owner?: string | undefined;
    broker?: string | undefined;
    type?: string | undefined;
    contractSpProvs?: ContractSpProvsReport[];
}

export class ContractSpProvsReport implements IContractSpProvsReport {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IContractSpProvsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.sProvNo = _data["sProvNo"];
            this.code = _data["code"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ContractSpProvsReport {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSpProvsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["sProvNo"] = this.sProvNo;
        data["code"] = this.code;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IContractSpProvsReport {
    id?: number;
    refNo?: number;
    sProvNo?: number;
    code?: string | undefined;
    comments?: string | undefined;
}

export class VesselsReport implements IVesselsReport {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;

    constructor(data?: IVesselsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voyageId = _data["voyageId"];
            this.name = _data["name"];
            this.companyCode = _data["companyCode"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
        }
    }

    static fromJS(data: any): VesselsReport {
        data = typeof data === 'object' ? data : {};
        let result = new VesselsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voyageId"] = this.voyageId;
        data["name"] = this.name;
        data["companyCode"] = this.companyCode;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        return data;
    }
}

export interface IVesselsReport {
    id?: number;
    voyageId?: number;
    name?: string | undefined;
    companyCode?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
}

export class CreateOneMoveOpsTrafficCommand implements ICreateOneMoveOpsTrafficCommand {
    voyageId?: number;

    constructor(data?: ICreateOneMoveOpsTrafficCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voyageId = _data["voyageId"];
        }
    }

    static fromJS(data: any): CreateOneMoveOpsTrafficCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOneMoveOpsTrafficCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyageId"] = this.voyageId;
        return data;
    }
}

export interface ICreateOneMoveOpsTrafficCommand {
    voyageId?: number;
}

export class CreateBatchMoveOpsTrafficCommand implements ICreateBatchMoveOpsTrafficCommand {
    ids?: number[];

    constructor(data?: ICreateBatchMoveOpsTrafficCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateBatchMoveOpsTrafficCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchMoveOpsTrafficCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ICreateBatchMoveOpsTrafficCommand {
    ids?: number[];
}

export class OpCodesDto implements IOpCodesDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IOpCodesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): OpCodesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpCodesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IOpCodesDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class OpCodeDto implements IOpCodeDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IOpCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): OpCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IOpCodeDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateOpCodeCommand implements ICreateOpCodeCommand {
    name?: string;
    description?: string;

    constructor(data?: ICreateOpCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateOpCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOpCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateOpCodeCommand {
    name?: string;
    description?: string;
}

export class UpdateOpCodeCommand implements IUpdateOpCodeCommand {
    id?: number;
    name?: string;
    description?: string;

    constructor(data?: IUpdateOpCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateOpCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOpCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateOpCodeCommand {
    id?: number;
    name?: string;
    description?: string;
}

export class PhoneBooksDto implements IPhoneBooksDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastFirst?: string | undefined;
    office?: string | undefined;
    faxOffice?: string | undefined;
    home?: string | undefined;
    faxHome?: string | undefined;
    cellular?: string | undefined;
    isActive?: boolean;

    constructor(data?: IPhoneBooksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastFirst = _data["lastFirst"];
            this.office = _data["office"];
            this.faxOffice = _data["faxOffice"];
            this.home = _data["home"];
            this.faxHome = _data["faxHome"];
            this.cellular = _data["cellular"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PhoneBooksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneBooksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastFirst"] = this.lastFirst;
        data["office"] = this.office;
        data["faxOffice"] = this.faxOffice;
        data["home"] = this.home;
        data["faxHome"] = this.faxHome;
        data["cellular"] = this.cellular;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPhoneBooksDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastFirst?: string | undefined;
    office?: string | undefined;
    faxOffice?: string | undefined;
    home?: string | undefined;
    faxHome?: string | undefined;
    cellular?: string | undefined;
    isActive?: boolean;
}

export class PhoneBookDto implements IPhoneBookDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastFirst?: string | undefined;
    office?: string | undefined;
    faxOffice?: string | undefined;
    home?: string | undefined;
    faxHome?: string | undefined;
    cellular?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IPhoneBookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastFirst = _data["lastFirst"];
            this.office = _data["office"];
            this.faxOffice = _data["faxOffice"];
            this.home = _data["home"];
            this.faxHome = _data["faxHome"];
            this.cellular = _data["cellular"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): PhoneBookDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneBookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastFirst"] = this.lastFirst;
        data["office"] = this.office;
        data["faxOffice"] = this.faxOffice;
        data["home"] = this.home;
        data["faxHome"] = this.faxHome;
        data["cellular"] = this.cellular;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IPhoneBookDto {
    id?: number;
    companyId?: number;
    companyCode?: string | undefined;
    lastFirst?: string | undefined;
    office?: string | undefined;
    faxOffice?: string | undefined;
    home?: string | undefined;
    faxHome?: string | undefined;
    cellular?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreatePhoneBookCommand implements ICreatePhoneBookCommand {
    companyId?: number;
    companyCode?: string;
    lastFirst?: string;
    office?: string;
    faxOffice?: string;
    home?: string;
    faxHome?: string;
    cellular?: string;

    constructor(data?: ICreatePhoneBookCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastFirst = _data["lastFirst"];
            this.office = _data["office"];
            this.faxOffice = _data["faxOffice"];
            this.home = _data["home"];
            this.faxHome = _data["faxHome"];
            this.cellular = _data["cellular"];
        }
    }

    static fromJS(data: any): CreatePhoneBookCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhoneBookCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastFirst"] = this.lastFirst;
        data["office"] = this.office;
        data["faxOffice"] = this.faxOffice;
        data["home"] = this.home;
        data["faxHome"] = this.faxHome;
        data["cellular"] = this.cellular;
        return data;
    }
}

export interface ICreatePhoneBookCommand {
    companyId?: number;
    companyCode?: string;
    lastFirst?: string;
    office?: string;
    faxOffice?: string;
    home?: string;
    faxHome?: string;
    cellular?: string;
}

export class UpdatePhoneBookCommand implements IUpdatePhoneBookCommand {
    id?: number;
    companyId?: number;
    companyCode?: string;
    lastFirst?: string;
    office?: string;
    faxOffice?: string;
    home?: string;
    faxHome?: string;
    cellular?: string;

    constructor(data?: IUpdatePhoneBookCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.lastFirst = _data["lastFirst"];
            this.office = _data["office"];
            this.faxOffice = _data["faxOffice"];
            this.home = _data["home"];
            this.faxHome = _data["faxHome"];
            this.cellular = _data["cellular"];
        }
    }

    static fromJS(data: any): UpdatePhoneBookCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneBookCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["lastFirst"] = this.lastFirst;
        data["office"] = this.office;
        data["faxOffice"] = this.faxOffice;
        data["home"] = this.home;
        data["faxHome"] = this.faxHome;
        data["cellular"] = this.cellular;
        return data;
    }
}

export interface IUpdatePhoneBookCommand {
    id?: number;
    companyId?: number;
    companyCode?: string;
    lastFirst?: string;
    office?: string;
    faxOffice?: string;
    home?: string;
    faxHome?: string;
    cellular?: string;
}

export class PhoneBookVm implements IPhoneBookVm {
    phoneBook?: PhoneBookDto | undefined;
    companies?: SelectDto[];

    constructor(data?: IPhoneBookVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneBook = _data["phoneBook"] ? PhoneBookDto.fromJS(_data["phoneBook"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhoneBookVm {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneBookVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneBook"] = this.phoneBook ? this.phoneBook.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhoneBookVm {
    phoneBook?: PhoneBookDto | undefined;
    companies?: SelectDto[];
}

export class PhonesDto implements IPhonesDto {
    id?: number;
    phoneType?: string | undefined;
    phoneTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;
    isActive?: boolean;

    constructor(data?: IPhonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneType = _data["phoneType"];
            this.phoneTypeName = _data["phoneTypeName"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PhonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneType"] = this.phoneType;
        data["phoneTypeName"] = this.phoneTypeName;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPhonesDto {
    id?: number;
    phoneType?: string | undefined;
    phoneTypeName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;
    isActive?: boolean;
}

export class PhoneVm implements IPhoneVm {
    phone?: PhoneDto | undefined;
    phoneTypes?: SelectDto[];

    constructor(data?: IPhoneVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"] ? PhoneDto.fromJS(_data["phone"]) : <any>undefined;
            if (Array.isArray(_data["phoneTypes"])) {
                this.phoneTypes = [] as any;
                for (let item of _data["phoneTypes"])
                    this.phoneTypes!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhoneVm {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        if (Array.isArray(this.phoneTypes)) {
            data["phoneTypes"] = [];
            for (let item of this.phoneTypes)
                data["phoneTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPhoneVm {
    phone?: PhoneDto | undefined;
    phoneTypes?: SelectDto[];
}

export class PhoneDto implements IPhoneDto {
    id?: number;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): PhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IPhoneDto {
    id?: number;
    phoneType?: string | undefined;
    phoneNumber?: string | undefined;
    phoneDisplay?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreatePhoneCommand implements ICreatePhoneCommand {
    employeId?: number;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: boolean;

    constructor(data?: ICreatePhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeId = _data["employeId"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
        }
    }

    static fromJS(data: any): CreatePhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeId"] = this.employeId;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        return data;
    }
}

export interface ICreatePhoneCommand {
    employeId?: number;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: boolean;
}

export class UpdatePhoneCommand implements IUpdatePhoneCommand {
    id?: number;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: boolean;

    constructor(data?: IUpdatePhoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneDisplay = _data["phoneDisplay"];
        }
    }

    static fromJS(data: any): UpdatePhoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneDisplay"] = this.phoneDisplay;
        return data;
    }
}

export interface IUpdatePhoneCommand {
    id?: number;
    phoneType?: string;
    phoneNumber?: string;
    phoneDisplay?: boolean;
}

export class PhoneTypesDto implements IPhoneTypesDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    displayCode?: string | undefined;
    isActive?: boolean;

    constructor(data?: IPhoneTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.displayCode = _data["displayCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PhoneTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["displayCode"] = this.displayCode;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPhoneTypesDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    displayCode?: string | undefined;
    isActive?: boolean;
}

export class PhoneTypeDto implements IPhoneTypeDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    displayCode?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IPhoneTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.displayCode = _data["displayCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): PhoneTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["displayCode"] = this.displayCode;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IPhoneTypeDto {
    id?: number;
    name?: string | undefined;
    displayOption?: boolean;
    displayCode?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreatePhoneTypeCommand implements ICreatePhoneTypeCommand {
    name?: string;
    displayOption?: boolean;
    displayCode?: string;

    constructor(data?: ICreatePhoneTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.displayCode = _data["displayCode"];
        }
    }

    static fromJS(data: any): CreatePhoneTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhoneTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["displayCode"] = this.displayCode;
        return data;
    }
}

export interface ICreatePhoneTypeCommand {
    name?: string;
    displayOption?: boolean;
    displayCode?: string;
}

export class UpdatePhoneTypeCommand implements IUpdatePhoneTypeCommand {
    id?: number;
    name?: string;
    displayOption?: boolean;
    displayCode?: string;

    constructor(data?: IUpdatePhoneTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOption = _data["displayOption"];
            this.displayCode = _data["displayCode"];
        }
    }

    static fromJS(data: any): UpdatePhoneTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOption"] = this.displayOption;
        data["displayCode"] = this.displayCode;
        return data;
    }
}

export interface IUpdatePhoneTypeCommand {
    id?: number;
    name?: string;
    displayOption?: boolean;
    displayCode?: string;
}

export class PortsDto implements IPortsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    isActive?: boolean;

    constructor(data?: IPortsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PortsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["state"] = this.state;
        data["country"] = this.country;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPortsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    isActive?: boolean;
}

export class PortVm implements IPortVm {
    port?: PortDto | undefined;
    countries?: SelectDto[];
    states?: SelectDto[];

    constructor(data?: IPortVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.port = _data["port"] ? PortDto.fromJS(_data["port"]) : <any>undefined;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PortVm {
        data = typeof data === 'object' ? data : {};
        let result = new PortVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["port"] = this.port ? this.port.toJSON() : <any>undefined;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPortVm {
    port?: PortDto | undefined;
    countries?: SelectDto[];
    states?: SelectDto[];
}

export class PortDto implements IPortDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IPortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): PortDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["state"] = this.state;
        data["country"] = this.country;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IPortDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreatePortCommand implements ICreatePortCommand {
    code?: string;
    name?: string;
    state?: string;
    country?: string;

    constructor(data?: ICreatePortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CreatePortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface ICreatePortCommand {
    code?: string;
    name?: string;
    state?: string;
    country?: string;
}

export class UpdatePortCommand implements IUpdatePortCommand {
    id?: number;
    code?: string;
    name?: string;
    state?: string;
    country?: string;

    constructor(data?: IUpdatePortCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): UpdatePortCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePortCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface IUpdatePortCommand {
    id?: number;
    code?: string;
    name?: string;
    state?: string;
    country?: string;
}

export class RelationTypesDto implements IRelationTypesDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IRelationTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RelationTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRelationTypesDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class RelationTypeDto implements IRelationTypeDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IRelationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): RelationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IRelationTypeDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateRelationTypeCommand implements ICreateRelationTypeCommand {
    name?: string;

    constructor(data?: ICreateRelationTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRelationTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRelationTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateRelationTypeCommand {
    name?: string;
}

export class UpdateRelationTypeCommand implements IUpdateRelationTypeCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateRelationTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateRelationTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRelationTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateRelationTypeCommand {
    id?: number;
    name?: string;
}

export class ReleasesDto implements IReleasesDto {
    id?: number;
    name?: string | undefined;
    notes?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IReleasesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): ReleasesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleasesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IReleasesDto {
    id?: number;
    name?: string | undefined;
    notes?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class ReleaseDto implements IReleaseDto {
    id?: number;
    name?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IReleaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): ReleaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IReleaseDto {
    id?: number;
    name?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateReleaseCommand implements ICreateReleaseCommand {
    name?: string;
    notes?: string;

    constructor(data?: ICreateReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateReleaseCommand {
    name?: string;
    notes?: string;
}

export class UpdateReleaseCommand implements IUpdateReleaseCommand {
    id?: number;
    name?: string;
    notes?: string;

    constructor(data?: IUpdateReleaseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateReleaseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReleaseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateReleaseCommand {
    id?: number;
    name?: string;
    notes?: string;
}

export class CompaniesReport implements ICompaniesReport {
    id?: number;
    name?: string | undefined;
    company?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountingContact?: string | undefined;
    webSite?: string | undefined;
    tlx?: string | undefined;
    owner?: string | undefined;
    charterer?: string | undefined;
    remarks?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
    isActive?: string | undefined;
    projection?: ExpressionOfFuncOfCompanyAndCompaniesReport;

    constructor(data?: ICompaniesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.company = _data["company"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.accountingContact = _data["accountingContact"];
            this.webSite = _data["webSite"];
            this.tlx = _data["tlx"];
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.remarks = _data["remarks"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.isActive = _data["isActive"];
            this.projection = _data["projection"] ? ExpressionOfFuncOfCompanyAndCompaniesReport.fromJS(_data["projection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompaniesReport {
        data = typeof data === 'object' ? data : {};
        let result = new CompaniesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["company"] = this.company;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["accountingContact"] = this.accountingContact;
        data["webSite"] = this.webSite;
        data["tlx"] = this.tlx;
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["remarks"] = this.remarks;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["isActive"] = this.isActive;
        data["projection"] = this.projection ? this.projection.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompaniesReport {
    id?: number;
    name?: string | undefined;
    company?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountingContact?: string | undefined;
    webSite?: string | undefined;
    tlx?: string | undefined;
    owner?: string | undefined;
    charterer?: string | undefined;
    remarks?: string | undefined;
    lastModified?: Date;
    lastModifiedBy?: string | undefined;
    isActive?: string | undefined;
    projection?: ExpressionOfFuncOfCompanyAndCompaniesReport;
}

export abstract class Expression implements IExpression {
    nodeType?: ExpressionType;
    type?: string;
    canReduce?: boolean;
    debugView?: string;

    constructor(data?: IExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeType = _data["nodeType"];
            this.type = _data["type"];
            this.canReduce = _data["canReduce"];
            this.debugView = _data["debugView"];
        }
    }

    static fromJS(data: any): Expression {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Expression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeType"] = this.nodeType;
        data["type"] = this.type;
        data["canReduce"] = this.canReduce;
        data["debugView"] = this.debugView;
        return data;
    }
}

export interface IExpression {
    nodeType?: ExpressionType;
    type?: string;
    canReduce?: boolean;
    debugView?: string;
}

export abstract class LambdaExpression extends Expression implements ILambdaExpression {
    canCompileToIL?: boolean;
    canInterpret?: boolean;
    type?: string;
    typeCore?: string;
    publicType?: string;
    nodeType?: ExpressionType;
    parameters?: ParameterExpression[];
    name?: string | undefined;
    nameCore?: string | undefined;
    body?: Expression;
    returnType?: string;
    tailCall?: boolean;
    tailCallCore?: boolean;
    systemLinqExpressionsIParameterProviderParameterCount?: number;
    parameterCount?: number;

    constructor(data?: ILambdaExpression) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canCompileToIL = _data["canCompileToIL"];
            this.canInterpret = _data["canInterpret"];
            this.type = _data["type"];
            this.typeCore = _data["typeCore"];
            this.publicType = _data["publicType"];
            this.nodeType = _data["nodeType"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterExpression.fromJS(item));
            }
            this.name = _data["name"];
            this.nameCore = _data["nameCore"];
            this.body = _data["body"] ? Expression.fromJS(_data["body"]) : <any>undefined;
            this.returnType = _data["returnType"];
            this.tailCall = _data["tailCall"];
            this.tailCallCore = _data["tailCallCore"];
            this.systemLinqExpressionsIParameterProviderParameterCount = _data["system.Linq.Expressions.IParameterProvider.ParameterCount"];
            this.parameterCount = _data["parameterCount"];
        }
    }

    static override fromJS(data: any): LambdaExpression {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'LambdaExpression' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCompileToIL"] = this.canCompileToIL;
        data["canInterpret"] = this.canInterpret;
        data["type"] = this.type;
        data["typeCore"] = this.typeCore;
        data["publicType"] = this.publicType;
        data["nodeType"] = this.nodeType;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["nameCore"] = this.nameCore;
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        data["tailCall"] = this.tailCall;
        data["tailCallCore"] = this.tailCallCore;
        data["system.Linq.Expressions.IParameterProvider.ParameterCount"] = this.systemLinqExpressionsIParameterProviderParameterCount;
        data["parameterCount"] = this.parameterCount;
        super.toJSON(data);
        return data;
    }
}

export interface ILambdaExpression extends IExpression {
    canCompileToIL?: boolean;
    canInterpret?: boolean;
    type?: string;
    typeCore?: string;
    publicType?: string;
    nodeType?: ExpressionType;
    parameters?: ParameterExpression[];
    name?: string | undefined;
    nameCore?: string | undefined;
    body?: Expression;
    returnType?: string;
    tailCall?: boolean;
    tailCallCore?: boolean;
    systemLinqExpressionsIParameterProviderParameterCount?: number;
    parameterCount?: number;
}

export class ExpressionOfFuncOfCompanyAndCompaniesReport extends LambdaExpression implements IExpressionOfFuncOfCompanyAndCompaniesReport {
    typeCore?: string;
    publicType?: string;

    constructor(data?: IExpressionOfFuncOfCompanyAndCompaniesReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCore = _data["typeCore"];
            this.publicType = _data["publicType"];
        }
    }

    static override fromJS(data: any): ExpressionOfFuncOfCompanyAndCompaniesReport {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionOfFuncOfCompanyAndCompaniesReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCore"] = this.typeCore;
        data["publicType"] = this.publicType;
        super.toJSON(data);
        return data;
    }
}

export interface IExpressionOfFuncOfCompanyAndCompaniesReport extends ILambdaExpression {
    typeCore?: string;
    publicType?: string;
}

export enum ExpressionType {
    Add = 0,
    AddChecked = 1,
    And = 2,
    AndAlso = 3,
    ArrayLength = 4,
    ArrayIndex = 5,
    Call = 6,
    Coalesce = 7,
    Conditional = 8,
    Constant = 9,
    Convert = 10,
    ConvertChecked = 11,
    Divide = 12,
    Equal = 13,
    ExclusiveOr = 14,
    GreaterThan = 15,
    GreaterThanOrEqual = 16,
    Invoke = 17,
    Lambda = 18,
    LeftShift = 19,
    LessThan = 20,
    LessThanOrEqual = 21,
    ListInit = 22,
    MemberAccess = 23,
    MemberInit = 24,
    Modulo = 25,
    Multiply = 26,
    MultiplyChecked = 27,
    Negate = 28,
    UnaryPlus = 29,
    NegateChecked = 30,
    New = 31,
    NewArrayInit = 32,
    NewArrayBounds = 33,
    Not = 34,
    NotEqual = 35,
    Or = 36,
    OrElse = 37,
    Parameter = 38,
    Power = 39,
    Quote = 40,
    RightShift = 41,
    Subtract = 42,
    SubtractChecked = 43,
    TypeAs = 44,
    TypeIs = 45,
    Assign = 46,
    Block = 47,
    DebugInfo = 48,
    Decrement = 49,
    Dynamic = 50,
    Default = 51,
    Extension = 52,
    Goto = 53,
    Increment = 54,
    Index = 55,
    Label = 56,
    RuntimeVariables = 57,
    Loop = 58,
    Switch = 59,
    Throw = 60,
    Try = 61,
    Unbox = 62,
    AddAssign = 63,
    AndAssign = 64,
    DivideAssign = 65,
    ExclusiveOrAssign = 66,
    LeftShiftAssign = 67,
    ModuloAssign = 68,
    MultiplyAssign = 69,
    OrAssign = 70,
    PowerAssign = 71,
    RightShiftAssign = 72,
    SubtractAssign = 73,
    AddAssignChecked = 74,
    MultiplyAssignChecked = 75,
    SubtractAssignChecked = 76,
    PreIncrementAssign = 77,
    PreDecrementAssign = 78,
    PostIncrementAssign = 79,
    PostDecrementAssign = 80,
    TypeEqual = 81,
    OnesComplement = 82,
    IsTrue = 83,
    IsFalse = 84,
}

export class ParameterExpression extends Expression implements IParameterExpression {
    type?: string;
    nodeType?: ExpressionType;
    name?: string | undefined;
    isByRef?: boolean;

    constructor(data?: IParameterExpression) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.nodeType = _data["nodeType"];
            this.name = _data["name"];
            this.isByRef = _data["isByRef"];
        }
    }

    static override fromJS(data: any): ParameterExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["nodeType"] = this.nodeType;
        data["name"] = this.name;
        data["isByRef"] = this.isByRef;
        super.toJSON(data);
        return data;
    }
}

export interface IParameterExpression extends IExpression {
    type?: string;
    nodeType?: ExpressionType;
    name?: string | undefined;
    isByRef?: boolean;
}

export class ContractsReportVm implements IContractsReportVm {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    readinessDate?: Date | undefined;
    contract?: ContractReport | undefined;
    moveOpsTraffics?: TrafficsReport[];
    moveVessels?: MoveVessel[];
    moveEquipments?: MoveEquipment[];

    constructor(data?: IContractsReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.contract = _data["contract"] ? ContractReport.fromJS(_data["contract"]) : <any>undefined;
            if (Array.isArray(_data["moveOpsTraffics"])) {
                this.moveOpsTraffics = [] as any;
                for (let item of _data["moveOpsTraffics"])
                    this.moveOpsTraffics!.push(TrafficsReport.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(MoveVessel.fromJS(item));
            }
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(MoveEquipment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractsReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContractsReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        if (Array.isArray(this.moveOpsTraffics)) {
            data["moveOpsTraffics"] = [];
            for (let item of this.moveOpsTraffics)
                data["moveOpsTraffics"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractsReportVm {
    id?: number;
    refNo?: number;
    moveNo?: number;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    readinessDate?: Date | undefined;
    contract?: ContractReport | undefined;
    moveOpsTraffics?: TrafficsReport[];
    moveVessels?: MoveVessel[];
    moveEquipments?: MoveEquipment[];
}

export class TrafficsReport implements ITrafficsReport {
    id?: number;
    refNo?: number;
    moveNo?: string | undefined;
    date?: Date;
    time?: Date;
    opCode?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITrafficsReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.opCode = _data["opCode"];
            this.comments = _data["comments"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TrafficsReport {
        data = typeof data === 'object' ? data : {};
        let result = new TrafficsReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["opCode"] = this.opCode;
        data["comments"] = this.comments;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITrafficsReport {
    id?: number;
    refNo?: number;
    moveNo?: string | undefined;
    date?: Date;
    time?: Date;
    opCode?: string | undefined;
    comments?: string | undefined;
    isActive?: boolean;
}

export class EmployeesReport implements IEmployeesReport {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    displayPhone?: string | undefined;
    emailHome?: string | undefined;
    emailOffice?: string | undefined;
    address?: string | undefined;
    projection?: ExpressionOfFuncOfEmployeeAndEmployeesReport;

    constructor(data?: IEmployeesReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.jobTitle = _data["jobTitle"];
            this.displayPhone = _data["displayPhone"];
            this.emailHome = _data["emailHome"];
            this.emailOffice = _data["emailOffice"];
            this.address = _data["address"];
            this.projection = _data["projection"] ? ExpressionOfFuncOfEmployeeAndEmployeesReport.fromJS(_data["projection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeesReport {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["jobTitle"] = this.jobTitle;
        data["displayPhone"] = this.displayPhone;
        data["emailHome"] = this.emailHome;
        data["emailOffice"] = this.emailOffice;
        data["address"] = this.address;
        data["projection"] = this.projection ? this.projection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeesReport {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    displayPhone?: string | undefined;
    emailHome?: string | undefined;
    emailOffice?: string | undefined;
    address?: string | undefined;
    projection?: ExpressionOfFuncOfEmployeeAndEmployeesReport;
}

export class ExpressionOfFuncOfEmployeeAndEmployeesReport extends LambdaExpression implements IExpressionOfFuncOfEmployeeAndEmployeesReport {
    typeCore?: string;
    publicType?: string;

    constructor(data?: IExpressionOfFuncOfEmployeeAndEmployeesReport) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCore = _data["typeCore"];
            this.publicType = _data["publicType"];
        }
    }

    static override fromJS(data: any): ExpressionOfFuncOfEmployeeAndEmployeesReport {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionOfFuncOfEmployeeAndEmployeesReport();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCore"] = this.typeCore;
        data["publicType"] = this.publicType;
        super.toJSON(data);
        return data;
    }
}

export interface IExpressionOfFuncOfEmployeeAndEmployeesReport extends ILambdaExpression {
    typeCore?: string;
    publicType?: string;
}

export class InvoicesReportVm implements IInvoicesReportVm {
    refNo?: string | undefined;
    cpDate?: string | undefined;
    charterer?: string | undefined;
    ownerRefNo?: string | undefined;
    chartererRefNo?: string | undefined;
    equip?: string | undefined;
    readinessDate?: string | undefined;
    invoicesNeeded?: string | undefined;
    notes?: string | undefined;
    projection?: ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm;

    constructor(data?: IInvoicesReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.cpDate = _data["cpDate"];
            this.charterer = _data["charterer"];
            this.ownerRefNo = _data["ownerRefNo"];
            this.chartererRefNo = _data["chartererRefNo"];
            this.equip = _data["equip"];
            this.readinessDate = _data["readinessDate"];
            this.invoicesNeeded = _data["invoicesNeeded"];
            this.notes = _data["notes"];
            this.projection = _data["projection"] ? ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm.fromJS(_data["projection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicesReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["cpDate"] = this.cpDate;
        data["charterer"] = this.charterer;
        data["ownerRefNo"] = this.ownerRefNo;
        data["chartererRefNo"] = this.chartererRefNo;
        data["equip"] = this.equip;
        data["readinessDate"] = this.readinessDate;
        data["invoicesNeeded"] = this.invoicesNeeded;
        data["notes"] = this.notes;
        data["projection"] = this.projection ? this.projection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoicesReportVm {
    refNo?: string | undefined;
    cpDate?: string | undefined;
    charterer?: string | undefined;
    ownerRefNo?: string | undefined;
    chartererRefNo?: string | undefined;
    equip?: string | undefined;
    readinessDate?: string | undefined;
    invoicesNeeded?: string | undefined;
    notes?: string | undefined;
    projection?: ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm;
}

export class ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm extends LambdaExpression implements IExpressionOfFuncOfInvoicesReportAndInvoicesReportVm {
    typeCore?: string;
    publicType?: string;

    constructor(data?: IExpressionOfFuncOfInvoicesReportAndInvoicesReportVm) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeCore = _data["typeCore"];
            this.publicType = _data["publicType"];
        }
    }

    static override fromJS(data: any): ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionOfFuncOfInvoicesReportAndInvoicesReportVm();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeCore"] = this.typeCore;
        data["publicType"] = this.publicType;
        super.toJSON(data);
        return data;
    }
}

export interface IExpressionOfFuncOfInvoicesReportAndInvoicesReportVm extends ILambdaExpression {
    typeCore?: string;
    publicType?: string;
}

export class OutstandingInvoice implements IOutstandingInvoice {
    refNo?: number;
    moveNo?: number;
    refNoMoveNo?: string | undefined;
    owner?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    demDueFlag?: number;
    demDue?: string | undefined;
    demInvRecvdFlag?: boolean;
    demInvRecvd?: string | undefined;
    invRecvdFlag?: boolean;
    invRecvd?: string | undefined;
    bcpDate?: string | undefined;
    charterer?: string | undefined;
    ownerRefNo?: string | undefined;
    loadDate?: string | undefined;
    invoicesNeeded?: string | undefined;
    id?: number;
    created?: Date | undefined;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IOutstandingInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.refNoMoveNo = _data["refNoMoveNo"];
            this.owner = _data["owner"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.demDueFlag = _data["demDueFlag"];
            this.demDue = _data["demDue"];
            this.demInvRecvdFlag = _data["demInvRecvdFlag"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.invRecvdFlag = _data["invRecvdFlag"];
            this.invRecvd = _data["invRecvd"];
            this.bcpDate = _data["bcpDate"];
            this.charterer = _data["charterer"];
            this.ownerRefNo = _data["ownerRefNo"];
            this.loadDate = _data["loadDate"];
            this.invoicesNeeded = _data["invoicesNeeded"];
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): OutstandingInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new OutstandingInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["refNoMoveNo"] = this.refNoMoveNo;
        data["owner"] = this.owner;
        data["status"] = this.status;
        data["type"] = this.type;
        data["demDueFlag"] = this.demDueFlag;
        data["demDue"] = this.demDue;
        data["demInvRecvdFlag"] = this.demInvRecvdFlag;
        data["demInvRecvd"] = this.demInvRecvd;
        data["invRecvdFlag"] = this.invRecvdFlag;
        data["invRecvd"] = this.invRecvd;
        data["bcpDate"] = this.bcpDate;
        data["charterer"] = this.charterer;
        data["ownerRefNo"] = this.ownerRefNo;
        data["loadDate"] = this.loadDate;
        data["invoicesNeeded"] = this.invoicesNeeded;
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IOutstandingInvoice {
    refNo?: number;
    moveNo?: number;
    refNoMoveNo?: string | undefined;
    owner?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    demDueFlag?: number;
    demDue?: string | undefined;
    demInvRecvdFlag?: boolean;
    demInvRecvd?: string | undefined;
    invRecvdFlag?: boolean;
    invRecvd?: string | undefined;
    bcpDate?: string | undefined;
    charterer?: string | undefined;
    ownerRefNo?: string | undefined;
    loadDate?: string | undefined;
    invoicesNeeded?: string | undefined;
    id?: number;
    created?: Date | undefined;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class DemurrageLevel implements IDemurrageLevel {
    moveNo?: string | undefined;
    opCode?: string | undefined;
    derivedDate?: string | undefined;
    hoursDifference?: string | undefined;

    constructor(data?: IDemurrageLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moveNo = _data["moveNo"];
            this.opCode = _data["opCode"];
            this.derivedDate = _data["derivedDate"];
            this.hoursDifference = _data["hoursDifference"];
        }
    }

    static fromJS(data: any): DemurrageLevel {
        data = typeof data === 'object' ? data : {};
        let result = new DemurrageLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moveNo"] = this.moveNo;
        data["opCode"] = this.opCode;
        data["derivedDate"] = this.derivedDate;
        data["hoursDifference"] = this.hoursDifference;
        return data;
    }
}

export interface IDemurrageLevel {
    moveNo?: string | undefined;
    opCode?: string | undefined;
    derivedDate?: string | undefined;
    hoursDifference?: string | undefined;
}

export class RolesDto implements IRolesDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRolesDto {
    id?: string;
    name?: string | undefined;
}

export class RoleDto implements IRoleDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateRoleDto {
    id?: string;
    name?: string | undefined;
}

export class UpdateRoleDto implements IUpdateRoleDto {
    name?: string | undefined;

    constructor(data?: IUpdateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateRoleDto {
    name?: string | undefined;
}

export class SpecialProvisionsDto implements ISpecialProvisionsDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISpecialProvisionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SpecialProvisionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialProvisionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISpecialProvisionsDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class SpecialProvisionDto implements ISpecialProvisionDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ISpecialProvisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): SpecialProvisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialProvisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ISpecialProvisionDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateSpecialProvisionCommand implements ICreateSpecialProvisionCommand {
    code?: string;
    description?: string;

    constructor(data?: ICreateSpecialProvisionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateSpecialProvisionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialProvisionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateSpecialProvisionCommand {
    code?: string;
    description?: string;
}

export class UpdateSpecialProvisionCommand implements IUpdateSpecialProvisionCommand {
    id?: number;
    code?: string;
    description?: string;

    constructor(data?: IUpdateSpecialProvisionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateSpecialProvisionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecialProvisionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateSpecialProvisionCommand {
    id?: number;
    code?: string;
    description?: string;
}

export class StateDto implements IStateDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IStateDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    isActive?: boolean;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateStateCommand implements ICreateStateCommand {
    code?: string;
    name?: string;

    constructor(data?: ICreateStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStateCommand {
    code?: string;
    name?: string;
}

export class UpdateStateCommand implements IUpdateStateCommand {
    id?: number;
    code?: string;
    name?: string;

    constructor(data?: IUpdateStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStateCommand {
    id?: number;
    code?: string;
    name?: string;
}

export class StatusesDto implements IStatusesDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;

    constructor(data?: IStatusesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StatusesDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStatusesDto {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export class StatusDto implements IStatusDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): StatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IStatusDto {
    id?: number;
    name?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateStatusCommand implements ICreateStatusCommand {
    name?: string;

    constructor(data?: ICreateStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateStatusCommand {
    name?: string;
}

export class UpdateStatusCommand implements IUpdateStatusCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdateStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStatusCommand {
    id?: number;
    name?: string;
}

export class TerminalsDto implements ITerminalsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    portCode?: string | undefined;
    isActive?: boolean;

    constructor(data?: ITerminalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.portCode = _data["portCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TerminalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["portCode"] = this.portCode;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITerminalsDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    portCode?: string | undefined;
    isActive?: boolean;
}

export class TerminalDto implements ITerminalDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    portCode?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: ITerminalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.portCode = _data["portCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): TerminalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["portCode"] = this.portCode;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface ITerminalDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    portCode?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class TerminalVm implements ITerminalVm {
    terminal?: TerminalDto | undefined;
    ports?: SelectDto[];

    constructor(data?: ITerminalVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminal = _data["terminal"] ? TerminalDto.fromJS(_data["terminal"]) : <any>undefined;
            if (Array.isArray(_data["ports"])) {
                this.ports = [] as any;
                for (let item of _data["ports"])
                    this.ports!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TerminalVm {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminal"] = this.terminal ? this.terminal.toJSON() : <any>undefined;
        if (Array.isArray(this.ports)) {
            data["ports"] = [];
            for (let item of this.ports)
                data["ports"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITerminalVm {
    terminal?: TerminalDto | undefined;
    ports?: SelectDto[];
}

export class CreateTerminalCommand implements ICreateTerminalCommand {
    code?: string;
    name?: string;
    portCode?: string;

    constructor(data?: ICreateTerminalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.portCode = _data["portCode"];
        }
    }

    static fromJS(data: any): CreateTerminalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTerminalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["portCode"] = this.portCode;
        return data;
    }
}

export interface ICreateTerminalCommand {
    code?: string;
    name?: string;
    portCode?: string;
}

export class UpdateTerminalCommand implements IUpdateTerminalCommand {
    id?: number;
    code?: string;
    name?: string;
    portCode?: string;

    constructor(data?: IUpdateTerminalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.portCode = _data["portCode"];
        }
    }

    static fromJS(data: any): UpdateTerminalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTerminalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["portCode"] = this.portCode;
        return data;
    }
}

export interface IUpdateTerminalCommand {
    id?: number;
    code?: string;
    name?: string;
    portCode?: string;
}

export class UnitsDto implements IUnitsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUnitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UnitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUnitsDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
}

export class UnitDto implements IUnitDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IUnitDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class CreateUnitCommand implements ICreateUnitCommand {
    name?: string;
    description?: string;

    constructor(data?: ICreateUnitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateUnitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateUnitCommand {
    name?: string;
    description?: string;
}

export class UpdateUnitCommand implements IUpdateUnitCommand {
    id?: number;
    name?: string;
    description?: string;

    constructor(data?: IUpdateUnitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateUnitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUnitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateUnitCommand {
    id?: number;
    name?: string;
    description?: string;
}

export class UserVm implements IUserVm {
    user?: UserDto | undefined;
    roles?: RolesDto[];

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RolesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserVm {
    user?: UserDto | undefined;
    roles?: RolesDto[];
}

export class UserDto implements IUserDto {
    id?: string;
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    enableLars?: boolean;
    enableVesselTracking?: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.code = _data["code"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.enableLars = _data["enableLars"];
            this.enableVesselTracking = _data["enableVesselTracking"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["code"] = this.code;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["enableLars"] = this.enableLars;
        data["enableVesselTracking"] = this.enableVesselTracking;
        return data;
    }
}

export interface IUserDto {
    id?: string;
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    enableLars?: boolean;
    enableVesselTracking?: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName?: string;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    enableLars?: boolean;
    enableVesselTracking?: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.role = _data["role"];
            this.enableLars = _data["enableLars"];
            this.enableVesselTracking = _data["enableVesselTracking"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["role"] = this.role;
        data["enableLars"] = this.enableLars;
        data["enableVesselTracking"] = this.enableVesselTracking;
        return data;
    }
}

export interface ICreateUserDto {
    userName?: string;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    enableLars?: boolean;
    enableVesselTracking?: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
    userId?: string;
    password?: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordDto {
    userId?: string;
    password?: string;
}

export class UpdateUserDto implements IUpdateUserDto {
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    enableLars?: boolean;
    enableVesselTracking?: boolean;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.role = _data["role"];
            this.enableLars = _data["enableLars"];
            this.enableVesselTracking = _data["enableVesselTracking"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["role"] = this.role;
        data["enableLars"] = this.enableLars;
        data["enableVesselTracking"] = this.enableVesselTracking;
        return data;
    }
}

export interface IUpdateUserDto {
    userName?: string | undefined;
    code?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    role?: string | undefined;
    enableLars?: boolean;
    enableVesselTracking?: boolean;
}

export class VesselAisLocationDto implements IVesselAisLocationDto {
    vesselId?: number;
    vesselName?: string | undefined;
    mmsi?: string | undefined;
    state?: string;
    detail?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    speedKnots?: number | undefined;
    courseDegrees?: number | undefined;
    headingDegrees?: number | undefined;
    navigationalStatus?: string | undefined;
    broadcastName?: string | undefined;
    reportedAtUtc?: Date | undefined;
    source?: string | undefined;
    savedAtUtc?: Date | undefined;
    liveOutcome?: string | undefined;
    listenedSeconds?: number | undefined;
    listenedWithScheduledCheck?: boolean;

    constructor(data?: IVesselAisLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vesselId = _data["vesselId"];
            this.vesselName = _data["vesselName"];
            this.mmsi = _data["mmsi"];
            this.state = _data["state"];
            this.detail = _data["detail"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.speedKnots = _data["speedKnots"];
            this.courseDegrees = _data["courseDegrees"];
            this.headingDegrees = _data["headingDegrees"];
            this.navigationalStatus = _data["navigationalStatus"];
            this.broadcastName = _data["broadcastName"];
            this.reportedAtUtc = _data["reportedAtUtc"] ? new Date(_data["reportedAtUtc"].toString()) : undefined as any;
            this.source = _data["source"];
            this.savedAtUtc = _data["savedAtUtc"] ? new Date(_data["savedAtUtc"].toString()) : undefined as any;
            this.liveOutcome = _data["liveOutcome"];
            this.listenedSeconds = _data["listenedSeconds"];
            this.listenedWithScheduledCheck = _data["listenedWithScheduledCheck"];
        }
    }

    static fromJS(data: any): VesselAisLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VesselAisLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vesselId"] = this.vesselId;
        data["vesselName"] = this.vesselName;
        data["mmsi"] = this.mmsi;
        data["state"] = this.state;
        data["detail"] = this.detail;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["speedKnots"] = this.speedKnots;
        data["courseDegrees"] = this.courseDegrees;
        data["headingDegrees"] = this.headingDegrees;
        data["navigationalStatus"] = this.navigationalStatus;
        data["broadcastName"] = this.broadcastName;
        data["reportedAtUtc"] = this.reportedAtUtc ? this.reportedAtUtc.toISOString() : undefined as any;
        data["source"] = this.source;
        data["savedAtUtc"] = this.savedAtUtc ? this.savedAtUtc.toISOString() : undefined as any;
        data["liveOutcome"] = this.liveOutcome;
        data["listenedSeconds"] = this.listenedSeconds;
        data["listenedWithScheduledCheck"] = this.listenedWithScheduledCheck;
        return data;
    }
}

export interface IVesselAisLocationDto {
    vesselId?: number;
    vesselName?: string | undefined;
    mmsi?: string | undefined;
    state?: string;
    detail?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    speedKnots?: number | undefined;
    courseDegrees?: number | undefined;
    headingDegrees?: number | undefined;
    navigationalStatus?: string | undefined;
    broadcastName?: string | undefined;
    reportedAtUtc?: Date | undefined;
    source?: string | undefined;
    savedAtUtc?: Date | undefined;
    liveOutcome?: string | undefined;
    listenedSeconds?: number | undefined;
    listenedWithScheduledCheck?: boolean;
}

export class VesselsDto implements IVesselsDto {
    id?: number;
    name?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    isActive?: boolean;
    aisReportedAtUtc?: Date | undefined;
    mmsi?: string | undefined;
    companyCode?: string | undefined;

    constructor(data?: IVesselsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.isActive = _data["isActive"];
            this.aisReportedAtUtc = _data["aisReportedAtUtc"] ? new Date(_data["aisReportedAtUtc"].toString()) : undefined as any;
            this.mmsi = _data["mmsi"];
            this.companyCode = _data["companyCode"];
        }
    }

    static fromJS(data: any): VesselsDto {
        data = typeof data === 'object' ? data : {};
        let result = new VesselsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["isActive"] = this.isActive;
        data["aisReportedAtUtc"] = this.aisReportedAtUtc ? this.aisReportedAtUtc.toISOString() : undefined as any;
        data["mmsi"] = this.mmsi;
        data["companyCode"] = this.companyCode;
        return data;
    }
}

export interface IVesselsDto {
    id?: number;
    name?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    isActive?: boolean;
    aisReportedAtUtc?: Date | undefined;
    mmsi?: string | undefined;
    companyCode?: string | undefined;
}

export class VesselDto implements IVesselDto {
    id?: number;
    name?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    companyCode?: string | undefined;
    mmsi?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IVesselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.companyCode = _data["companyCode"];
            this.mmsi = _data["mmsi"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): VesselDto {
        data = typeof data === 'object' ? data : {};
        let result = new VesselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["companyCode"] = this.companyCode;
        data["mmsi"] = this.mmsi;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IVesselDto {
    id?: number;
    name?: string | undefined;
    dimensions?: string | undefined;
    engines?: string | undefined;
    horsePower?: string | undefined;
    yearBuilt?: number;
    companyCode?: string | undefined;
    mmsi?: string | undefined;
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class VesselVm implements IVesselVm {
    vessel?: VesselDto | undefined;
    companies?: SelectDto[];

    constructor(data?: IVesselVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vessel = _data["vessel"] ? VesselDto.fromJS(_data["vessel"]) : <any>undefined;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VesselVm {
        data = typeof data === 'object' ? data : {};
        let result = new VesselVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vessel"] = this.vessel ? this.vessel.toJSON() : <any>undefined;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVesselVm {
    vessel?: VesselDto | undefined;
    companies?: SelectDto[];
}

export class CreateVesselCommand implements ICreateVesselCommand {
    name?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
    companyCode?: string;
    mmsi?: string | undefined;

    constructor(data?: ICreateVesselCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.companyCode = _data["companyCode"];
            this.mmsi = _data["mmsi"];
        }
    }

    static fromJS(data: any): CreateVesselCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVesselCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["companyCode"] = this.companyCode;
        data["mmsi"] = this.mmsi;
        return data;
    }
}

export interface ICreateVesselCommand {
    name?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
    companyCode?: string;
    mmsi?: string | undefined;
}

export class UpdateVesselCommand implements IUpdateVesselCommand {
    id?: number;
    name?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
    companyCode?: string;
    mmsi?: string | undefined;

    constructor(data?: IUpdateVesselCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dimensions = _data["dimensions"];
            this.engines = _data["engines"];
            this.horsePower = _data["horsePower"];
            this.yearBuilt = _data["yearBuilt"];
            this.companyCode = _data["companyCode"];
            this.mmsi = _data["mmsi"];
        }
    }

    static fromJS(data: any): UpdateVesselCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVesselCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dimensions"] = this.dimensions;
        data["engines"] = this.engines;
        data["horsePower"] = this.horsePower;
        data["yearBuilt"] = this.yearBuilt;
        data["companyCode"] = this.companyCode;
        data["mmsi"] = this.mmsi;
        return data;
    }
}

export interface IUpdateVesselCommand {
    id?: number;
    name?: string;
    dimensions?: string;
    engines?: string;
    horsePower?: string;
    yearBuilt?: number;
    companyCode?: string;
    mmsi?: string | undefined;
}

export class VoyageVm implements IVoyageVm {
    voyage?: VoyageDto | undefined;
    statuses?: SelectDto[];
    ownerContacts?: SelectDto[];
    chartererContacts?: SelectDto[];

    constructor(data?: IVoyageVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voyage = _data["voyage"] ? VoyageDto.fromJS(_data["voyage"]) : <any>undefined;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["ownerContacts"])) {
                this.ownerContacts = [] as any;
                for (let item of _data["ownerContacts"])
                    this.ownerContacts!.push(SelectDto.fromJS(item));
            }
            if (Array.isArray(_data["chartererContacts"])) {
                this.chartererContacts = [] as any;
                for (let item of _data["chartererContacts"])
                    this.chartererContacts!.push(SelectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoyageVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoyageVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voyage"] = this.voyage ? this.voyage.toJSON() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerContacts)) {
            data["ownerContacts"] = [];
            for (let item of this.ownerContacts)
                data["ownerContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.chartererContacts)) {
            data["chartererContacts"] = [];
            for (let item of this.chartererContacts)
                data["chartererContacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVoyageVm {
    voyage?: VoyageDto | undefined;
    statuses?: SelectDto[];
    ownerContacts?: SelectDto[];
    chartererContacts?: SelectDto[];
}

export class GetRefNumbersByOwnerChartererStatusQuery implements IGetRefNumbersByOwnerChartererStatusQuery {
    owner?: string;
    charterer?: string;
    status?: string;

    constructor(data?: IGetRefNumbersByOwnerChartererStatusQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.owner = _data["owner"];
            this.charterer = _data["charterer"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetRefNumbersByOwnerChartererStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRefNumbersByOwnerChartererStatusQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner;
        data["charterer"] = this.charterer;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetRefNumbersByOwnerChartererStatusQuery {
    owner?: string;
    charterer?: string;
    status?: string;
}

export class FileDto implements IFileDto {
    name?: string | undefined;
    path?: string | undefined;
    isDirectory?: boolean;
    children?: FileDto[];

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.path = _data["path"];
            this.isDirectory = _data["isDirectory"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["path"] = this.path;
        data["isDirectory"] = this.isDirectory;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileDto {
    name?: string | undefined;
    path?: string | undefined;
    isDirectory?: boolean;
    children?: FileDto[];
}

export class GetVoyageFileDirectoryQuery implements IGetVoyageFileDirectoryQuery {
    id?: number;
    path?: string;

    constructor(data?: IGetVoyageFileDirectoryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): GetVoyageFileDirectoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoyageFileDirectoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        return data;
    }
}

export interface IGetVoyageFileDirectoryQuery {
    id?: number;
    path?: string;
}

export class DownloadVoyageFileQuery implements IDownloadVoyageFileQuery {
    id?: number;
    filePath?: string;

    constructor(data?: IDownloadVoyageFileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): DownloadVoyageFileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadVoyageFileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IDownloadVoyageFileQuery {
    id?: number;
    filePath?: string;
}

export class CreateVoyageCommand implements ICreateVoyageCommand {
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string;
    nominationDate?: Date | undefined;
    ownerContact?: string;
    chartContact?: string;
    chartRefNum?: string;
    ownerRefNum?: string;
    ldLaytime?: string;
    ldLaytimeRate?: number;
    dischLaytime?: string;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string;
    layTimeUnit?: string;
    dischAccount?: string;
    ldDemurrage?: number;
    ldDemurragePer?: string;
    demurrage1?: string;
    ldDemurrageAppliesTo?: string;
    dischDemurrage?: number;
    dischDemurragePer?: string;
    demurrage2?: string;
    dischDemurrageAppliesTo?: string;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string;
    rate?: number;
    rateType?: string;
    rates?: string;
    equip?: string;
    status?: string;
    invoiceNotes?: string;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;

    constructor(data?: ICreateVoyageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.contractId = _data["contractId"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
        }
    }

    static fromJS(data: any): CreateVoyageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoyageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["contractId"] = this.contractId;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        return data;
    }
}

export interface ICreateVoyageCommand {
    refNo?: number;
    moveNo?: number;
    contractId?: number;
    voyNo?: string;
    nominationDate?: Date | undefined;
    ownerContact?: string;
    chartContact?: string;
    chartRefNum?: string;
    ownerRefNum?: string;
    ldLaytime?: string;
    ldLaytimeRate?: number;
    dischLaytime?: string;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string;
    layTimeUnit?: string;
    dischAccount?: string;
    ldDemurrage?: number;
    ldDemurragePer?: string;
    demurrage1?: string;
    ldDemurrageAppliesTo?: string;
    dischDemurrage?: number;
    dischDemurragePer?: string;
    demurrage2?: string;
    dischDemurrageAppliesTo?: string;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string;
    rate?: number;
    rateType?: string;
    rates?: string;
    equip?: string;
    status?: string;
    invoiceNotes?: string;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;
}

export class ActivateVoyageCommand implements IActivateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];

    constructor(data?: IActivateVoyageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
            if (Array.isArray(_data["moveEquipments"])) {
                this.moveEquipments = [] as any;
                for (let item of _data["moveEquipments"])
                    this.moveEquipments!.push(BatchEquipmentDto.fromJS(item));
            }
            if (Array.isArray(_data["moveCargos"])) {
                this.moveCargos = [] as any;
                for (let item of _data["moveCargos"])
                    this.moveCargos!.push(BatchCargoDto.fromJS(item));
            }
            if (Array.isArray(_data["moveDischargePorts"])) {
                this.moveDischargePorts = [] as any;
                for (let item of _data["moveDischargePorts"])
                    this.moveDischargePorts!.push(BatchDischargePortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveLdPorts"])) {
                this.moveLdPorts = [] as any;
                for (let item of _data["moveLdPorts"])
                    this.moveLdPorts!.push(BatchLoadPortDto.fromJS(item));
            }
            if (Array.isArray(_data["moveOpsTraffics"])) {
                this.moveOpsTraffics = [] as any;
                for (let item of _data["moveOpsTraffics"])
                    this.moveOpsTraffics!.push(BatchTrafficDto.fromJS(item));
            }
            if (Array.isArray(_data["moveVessels"])) {
                this.moveVessels = [] as any;
                for (let item of _data["moveVessels"])
                    this.moveVessels!.push(BatchVesselDto.fromJS(item));
            }
            if (Array.isArray(_data["moveSpecialProvisions"])) {
                this.moveSpecialProvisions = [] as any;
                for (let item of _data["moveSpecialProvisions"])
                    this.moveSpecialProvisions!.push(BatchMoveSpecialProvisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivateVoyageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateVoyageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        if (Array.isArray(this.moveEquipments)) {
            data["moveEquipments"] = [];
            for (let item of this.moveEquipments)
                data["moveEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.moveCargos)) {
            data["moveCargos"] = [];
            for (let item of this.moveCargos)
                data["moveCargos"].push(item.toJSON());
        }
        if (Array.isArray(this.moveDischargePorts)) {
            data["moveDischargePorts"] = [];
            for (let item of this.moveDischargePorts)
                data["moveDischargePorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveLdPorts)) {
            data["moveLdPorts"] = [];
            for (let item of this.moveLdPorts)
                data["moveLdPorts"].push(item.toJSON());
        }
        if (Array.isArray(this.moveOpsTraffics)) {
            data["moveOpsTraffics"] = [];
            for (let item of this.moveOpsTraffics)
                data["moveOpsTraffics"].push(item.toJSON());
        }
        if (Array.isArray(this.moveVessels)) {
            data["moveVessels"] = [];
            for (let item of this.moveVessels)
                data["moveVessels"].push(item.toJSON());
        }
        if (Array.isArray(this.moveSpecialProvisions)) {
            data["moveSpecialProvisions"] = [];
            for (let item of this.moveSpecialProvisions)
                data["moveSpecialProvisions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;
    moveEquipments?: BatchEquipmentDto[];
    moveCargos?: BatchCargoDto[];
    moveDischargePorts?: BatchDischargePortDto[];
    moveLdPorts?: BatchLoadPortDto[];
    moveOpsTraffics?: BatchTrafficDto[];
    moveVessels?: BatchVesselDto[];
    moveSpecialProvisions?: BatchMoveSpecialProvisionDto[];
}

export class UpdateVoyageCommand implements IUpdateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;

    constructor(data?: IUpdateVoyageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refNo = _data["refNo"];
            this.moveNo = _data["moveNo"];
            this.voyNo = _data["voyNo"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.ownerContact = _data["ownerContact"];
            this.chartContact = _data["chartContact"];
            this.chartRefNum = _data["chartRefNum"];
            this.ownerRefNum = _data["ownerRefNum"];
            this.ldLaytime = _data["ldLaytime"];
            this.ldLaytimeRate = _data["ldLaytimeRate"];
            this.dischLaytime = _data["dischLaytime"];
            this.dischLaytimeRate = _data["dischLaytimeRate"];
            this.allPurposeLaytime = _data["allPurposeLaytime"];
            this.layTimeAppliesTo = _data["layTimeAppliesTo"];
            this.layTimeUnit = _data["layTimeUnit"];
            this.dischAccount = _data["dischAccount"];
            this.ldDemurrage = _data["ldDemurrage"];
            this.ldDemurragePer = _data["ldDemurragePer"];
            this.demurrage1 = _data["demurrage1"];
            this.ldDemurrageAppliesTo = _data["ldDemurrageAppliesTo"];
            this.dischDemurrage = _data["dischDemurrage"];
            this.dischDemurragePer = _data["dischDemurragePer"];
            this.demurrage2 = _data["demurrage2"];
            this.dischDemurrageAppliesTo = _data["dischDemurrageAppliesTo"];
            this.readinessDate = _data["readinessDate"] ? new Date(_data["readinessDate"].toString()) : <any>undefined;
            this.npt = _data["npt"] ? new Date(_data["npt"].toString()) : <any>undefined;
            this.nlt = _data["nlt"] ? new Date(_data["nlt"].toString()) : <any>undefined;
            this.dischDate = _data["dischDate"] ? new Date(_data["dischDate"].toString()) : <any>undefined;
            this.cargoPrefix = _data["cargoPrefix"];
            this.rate = _data["rate"];
            this.rateType = _data["rateType"];
            this.rates = _data["rates"];
            this.equip = _data["equip"];
            this.status = _data["status"];
            this.invoiceNotes = _data["invoiceNotes"];
            this.invRecvd = _data["invRecvd"];
            this.frtInvAmt = _data["frtInvAmt"];
            this.demDue = _data["demDue"];
            this.demInvRecvd = _data["demInvRecvd"];
            this.demInvAmt = _data["demInvAmt"];
            this.hasDemurrage = _data["hasDemurrage"];
        }
    }

    static fromJS(data: any): UpdateVoyageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoyageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refNo"] = this.refNo;
        data["moveNo"] = this.moveNo;
        data["voyNo"] = this.voyNo;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["ownerContact"] = this.ownerContact;
        data["chartContact"] = this.chartContact;
        data["chartRefNum"] = this.chartRefNum;
        data["ownerRefNum"] = this.ownerRefNum;
        data["ldLaytime"] = this.ldLaytime;
        data["ldLaytimeRate"] = this.ldLaytimeRate;
        data["dischLaytime"] = this.dischLaytime;
        data["dischLaytimeRate"] = this.dischLaytimeRate;
        data["allPurposeLaytime"] = this.allPurposeLaytime;
        data["layTimeAppliesTo"] = this.layTimeAppliesTo;
        data["layTimeUnit"] = this.layTimeUnit;
        data["dischAccount"] = this.dischAccount;
        data["ldDemurrage"] = this.ldDemurrage;
        data["ldDemurragePer"] = this.ldDemurragePer;
        data["demurrage1"] = this.demurrage1;
        data["ldDemurrageAppliesTo"] = this.ldDemurrageAppliesTo;
        data["dischDemurrage"] = this.dischDemurrage;
        data["dischDemurragePer"] = this.dischDemurragePer;
        data["demurrage2"] = this.demurrage2;
        data["dischDemurrageAppliesTo"] = this.dischDemurrageAppliesTo;
        data["readinessDate"] = this.readinessDate ? this.readinessDate.toISOString() : <any>undefined;
        data["npt"] = this.npt ? this.npt.toISOString() : <any>undefined;
        data["nlt"] = this.nlt ? this.nlt.toISOString() : <any>undefined;
        data["dischDate"] = this.dischDate ? this.dischDate.toISOString() : <any>undefined;
        data["cargoPrefix"] = this.cargoPrefix;
        data["rate"] = this.rate;
        data["rateType"] = this.rateType;
        data["rates"] = this.rates;
        data["equip"] = this.equip;
        data["status"] = this.status;
        data["invoiceNotes"] = this.invoiceNotes;
        data["invRecvd"] = this.invRecvd;
        data["frtInvAmt"] = this.frtInvAmt;
        data["demDue"] = this.demDue;
        data["demInvRecvd"] = this.demInvRecvd;
        data["demInvAmt"] = this.demInvAmt;
        data["hasDemurrage"] = this.hasDemurrage;
        return data;
    }
}

export interface IUpdateVoyageCommand {
    id?: number;
    refNo?: number;
    moveNo?: number;
    voyNo?: string | undefined;
    nominationDate?: Date | undefined;
    ownerContact?: string | undefined;
    chartContact?: string | undefined;
    chartRefNum?: string | undefined;
    ownerRefNum?: string | undefined;
    ldLaytime?: string | undefined;
    ldLaytimeRate?: number;
    dischLaytime?: string | undefined;
    dischLaytimeRate?: number;
    allPurposeLaytime?: number;
    layTimeAppliesTo?: string | undefined;
    layTimeUnit?: string | undefined;
    dischAccount?: string | undefined;
    ldDemurrage?: number;
    ldDemurragePer?: string | undefined;
    demurrage1?: string | undefined;
    ldDemurrageAppliesTo?: string | undefined;
    dischDemurrage?: number;
    dischDemurragePer?: string | undefined;
    demurrage2?: string | undefined;
    dischDemurrageAppliesTo?: string | undefined;
    readinessDate?: Date | undefined;
    npt?: Date | undefined;
    nlt?: Date | undefined;
    dischDate?: Date | undefined;
    cargoPrefix?: string | undefined;
    rate?: number;
    rateType?: string | undefined;
    rates?: string | undefined;
    equip?: string | undefined;
    status?: string | undefined;
    invoiceNotes?: string | undefined;
    invRecvd?: boolean;
    frtInvAmt?: number;
    demDue?: number;
    demInvRecvd?: boolean;
    demInvAmt?: number;
    hasDemurrage?: boolean;
}

export class PaginatedListOfVoyagesDto implements IPaginatedListOfVoyagesDto {
    items?: VoyagesDto[];
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfVoyagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VoyagesDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfVoyagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfVoyagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfVoyagesDto {
    items?: VoyagesDto[];
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}